import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_card_proto from './dcei_wildsky_card_proto';
import * as dcei_wildsky_ship_upgrade_proto from './dcei_wildsky_ship_upgrade_proto';
class PlayerInfo_Experiment {
  get descriptor() {
    return PlayerInfo_Experiment.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerInfo_Experiment) {
      return value;
    }
    return PlayerInfo_Experiment.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerInfo_Experiment();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToString.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue) {
      result.value = JsonToString.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get value() {
    return this._hasValue ? this._value : JsonToString.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo_Experiment(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new PlayerInfo_Experiment(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo_Experiment(this);
              copy._hasValue = true;
              copy._value = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new PlayerInfo_Experiment(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerInfo_Experiment} other
   * @returns {PlayerInfo_Experiment}
   */
  merge(other) {
    const copy = new PlayerInfo_Experiment(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    return copy;
  }
}
PlayerInfo_Experiment.default = new PlayerInfo_Experiment();
class PlayerInfo_Experiment_Builder {
  constructor(value) {
    this._value = new PlayerInfo_Experiment(value);
  }
  build() {
    return new PlayerInfo_Experiment(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
PlayerInfo_Experiment.Builder = PlayerInfo_Experiment_Builder;
class PlayerInfo_Experiment_WithParent {
  /**
   * @param {PlayerInfo_Experiment} value
   * @param {PlayerInfo_Experiment_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerInfo_Experiment.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new PlayerInfo_Experiment_WithParent(current, parent);
    return result;
  }
}
PlayerInfo_Experiment_WithParent.default = new PlayerInfo_Experiment_WithParent(PlayerInfo_Experiment.default, null);
PlayerInfo_Experiment.WithParent = PlayerInfo_Experiment_WithParent;
class PlayerInfo_Experiment_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 9,
        protoName: "value",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerInfo_Experiment.descriptor = new PlayerInfo_Experiment_Descriptor();
export class PlayerInfo {
  get descriptor() {
    return PlayerInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUuid = false;
    this._uuid = null;
    this._hasPassword = false;
    this._password = null;
    this._hasName = false;
    this._name = null;
    this._hasFacebookId = false;
    this._facebookId = null;
    this._hasTag = false;
    this._tag = null;
    this._hasGoogleId = false;
    this._googleId = null;
    this._hasLevel = false;
    this._level = null;
    this._hasGold = false;
    this._gold = null;
    this._hasGems = false;
    this._gems = null;
    this._hasExp = false;
    this._exp = null;
    this._hasRenameCount = false;
    this._renameCount = null;
    this._experiments = [];
    this._hasSequenceNumber = false;
    this._sequenceNumber = null;
  }
  isEmpty() {
    if (this._hasUuid) return false;
    if (this._hasPassword) return false;
    if (this._hasName) return false;
    if (this._hasFacebookId) return false;
    if (this._hasTag) return false;
    if (this._hasGoogleId) return false;
    if (this._hasLevel) return false;
    if (this._hasGold) return false;
    if (this._hasGems) return false;
    if (this._hasExp) return false;
    if (this._hasRenameCount) return false;
    if (this._experiments.length > 0) return false;
    if (this._hasSequenceNumber) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerInfo) {
      return value;
    }
    return PlayerInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerInfo();
    if (json.uuid != null) {
      result._hasUuid = true;
      result._uuid = JsonToString.fromJson(json.uuid);
    }
    if (json.password != null) {
      result._hasPassword = true;
      result._password = JsonToString.fromJson(json.password);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.facebookId != null) {
      result._hasFacebookId = true;
      result._facebookId = JsonToString.fromJson(json.facebookId);
    }
    if (json.tag != null) {
      result._hasTag = true;
      result._tag = JsonToString.fromJson(json.tag);
    }
    if (json.googleId != null) {
      result._hasGoogleId = true;
      result._googleId = JsonToString.fromJson(json.googleId);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.gold != null) {
      result._hasGold = true;
      result._gold = JsonToInt32.fromJson(json.gold);
    }
    if (json.gems != null) {
      result._hasGems = true;
      result._gems = JsonToInt32.fromJson(json.gems);
    }
    if (json.exp != null) {
      result._hasExp = true;
      result._exp = JsonToInt32.fromJson(json.exp);
    }
    if (json.renameCount != null) {
      result._hasRenameCount = true;
      result._renameCount = JsonToInt32.fromJson(json.renameCount);
    }
    result._experiments = JsonToList(json.experiments, PlayerInfo_Experiment);
    if (json.sequenceNumber != null) {
      result._hasSequenceNumber = true;
      result._sequenceNumber = JsonToInt32.fromJson(json.sequenceNumber);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUuid) {
      result.uuid = JsonToString.toJson(this._uuid);
    }
    if (this._hasPassword) {
      result.password = JsonToString.toJson(this._password);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasFacebookId) {
      result.facebookId = JsonToString.toJson(this._facebookId);
    }
    if (this._hasTag) {
      result.tag = JsonToString.toJson(this._tag);
    }
    if (this._hasGoogleId) {
      result.googleId = JsonToString.toJson(this._googleId);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasGold) {
      result.gold = JsonToInt32.toJson(this._gold);
    }
    if (this._hasGems) {
      result.gems = JsonToInt32.toJson(this._gems);
    }
    if (this._hasExp) {
      result.exp = JsonToInt32.toJson(this._exp);
    }
    if (this._hasRenameCount) {
      result.renameCount = JsonToInt32.toJson(this._renameCount);
    }
    if (this._experiments.length > 0) {
      result.experiments = ArrayToJson(this._experiments, PlayerInfo_Experiment);
    }
    if (this._hasSequenceNumber) {
      result.sequenceNumber = JsonToInt32.toJson(this._sequenceNumber);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get uuid() {
    return this._hasUuid ? this._uuid : JsonToString.default;
  }
  get hasUuid() {
    return this._hasUuid;
  }
  setUuid(path, value) {
    return {type: 'SET', path: path.concat(['uuid']), value};
  }
  deleteUuid(path) {
    return {type: 'DELETE', path: path.concat(['uuid'])};
  }
  /**
   * @returns {string}
   */
  get password() {
    return this._hasPassword ? this._password : JsonToString.default;
  }
  get hasPassword() {
    return this._hasPassword;
  }
  setPassword(path, value) {
    return {type: 'SET', path: path.concat(['password']), value};
  }
  deletePassword(path) {
    return {type: 'DELETE', path: path.concat(['password'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get facebookId() {
    return this._hasFacebookId ? this._facebookId : JsonToString.default;
  }
  get hasFacebookId() {
    return this._hasFacebookId;
  }
  setFacebookId(path, value) {
    return {type: 'SET', path: path.concat(['facebookId']), value};
  }
  deleteFacebookId(path) {
    return {type: 'DELETE', path: path.concat(['facebookId'])};
  }
  /**
   * @returns {string}
   */
  get tag() {
    return this._hasTag ? this._tag : JsonToString.default;
  }
  get hasTag() {
    return this._hasTag;
  }
  setTag(path, value) {
    return {type: 'SET', path: path.concat(['tag']), value};
  }
  deleteTag(path) {
    return {type: 'DELETE', path: path.concat(['tag'])};
  }
  /**
   * @returns {string}
   */
  get googleId() {
    return this._hasGoogleId ? this._googleId : JsonToString.default;
  }
  get hasGoogleId() {
    return this._hasGoogleId;
  }
  setGoogleId(path, value) {
    return {type: 'SET', path: path.concat(['googleId']), value};
  }
  deleteGoogleId(path) {
    return {type: 'DELETE', path: path.concat(['googleId'])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {number}
   */
  get gold() {
    return this._hasGold ? this._gold : JsonToInt32.default;
  }
  get hasGold() {
    return this._hasGold;
  }
  setGold(path, value) {
    return {type: 'SET', path: path.concat(['gold']), value};
  }
  deleteGold(path) {
    return {type: 'DELETE', path: path.concat(['gold'])};
  }
  /**
   * @returns {number}
   */
  get gems() {
    return this._hasGems ? this._gems : JsonToInt32.default;
  }
  get hasGems() {
    return this._hasGems;
  }
  setGems(path, value) {
    return {type: 'SET', path: path.concat(['gems']), value};
  }
  deleteGems(path) {
    return {type: 'DELETE', path: path.concat(['gems'])};
  }
  /**
   * @returns {number}
   */
  get exp() {
    return this._hasExp ? this._exp : JsonToInt32.default;
  }
  get hasExp() {
    return this._hasExp;
  }
  setExp(path, value) {
    return {type: 'SET', path: path.concat(['exp']), value};
  }
  deleteExp(path) {
    return {type: 'DELETE', path: path.concat(['exp'])};
  }
  /**
   * @returns {number}
   */
  get renameCount() {
    return this._hasRenameCount ? this._renameCount : JsonToInt32.default;
  }
  get hasRenameCount() {
    return this._hasRenameCount;
  }
  setRenameCount(path, value) {
    return {type: 'SET', path: path.concat(['renameCount']), value};
  }
  deleteRenameCount(path) {
    return {type: 'DELETE', path: path.concat(['renameCount'])};
  }
  /**
   * @returns {PlayerInfo_Experiment[]}
   */
  get experiments() {
    return this._experiments;
  }
  addExperiments(path, value) {
    return {type: 'ADD', path: path.concat(['experiments']), value: value.toJson()};
  }
  setExperiments(path, value) {
    return {type: 'SET', path: path.concat(['experiments']), value: ArrayToJson(value, PlayerInfo_Experiment)};
  }
  setExperimentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['experiments', key]), value: value.toJson()};
  }
  deleteExperiments(path) {
    return {type: 'DELETE', path: path.concat(['experiments'])};
  }
  deleteExperimentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['experiments', key])};
  }
  /**
   * @returns {number}
   */
  get sequenceNumber() {
    return this._hasSequenceNumber ? this._sequenceNumber : JsonToInt32.default;
  }
  get hasSequenceNumber() {
    return this._hasSequenceNumber;
  }
  setSequenceNumber(path, value) {
    return {type: 'SET', path: path.concat(['sequenceNumber']), value};
  }
  deleteSequenceNumber(path) {
    return {type: 'DELETE', path: path.concat(['sequenceNumber'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "uuid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasUuid = true;
              copy._uuid = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUuid) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasUuid = false;
              copy._uuid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "password": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasPassword = true;
              copy._password = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPassword) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasPassword = false;
              copy._password = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "facebookId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasFacebookId = true;
              copy._facebookId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFacebookId) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasFacebookId = false;
              copy._facebookId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasTag = true;
              copy._tag = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTag) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasTag = false;
              copy._tag = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "googleId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasGoogleId = true;
              copy._googleId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoogleId) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasGoogleId = false;
              copy._googleId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasGold = true;
              copy._gold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGold) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasGold = false;
              copy._gold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasGems = true;
              copy._gems = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGems) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasGems = false;
              copy._gems = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "exp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasExp = true;
              copy._exp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExp) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasExp = false;
              copy._exp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "renameCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasRenameCount = true;
              copy._renameCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRenameCount) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasRenameCount = false;
              copy._renameCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "experiments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._experiments = [];        for (let i of value) {
                copy._experiments.push(PlayerInfo_Experiment.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerInfo(this);
              copy._experiments = copy._experiments.concat([PlayerInfo_Experiment.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._experiments.length === 0) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._experiments = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._experiments.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._experiments = copy._experiments.slice();
              copy._experiments[path[1]] = PlayerInfo_Experiment.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerInfo(this);
              copy._experiments = copy._experiments.slice(0, path[1]).concat(copy._experiments.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._experiments.length) {
            return this;
          }
          const oldValue = this._experiments[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerInfo(this);
          copy._experiments = copy._experiments.slice();
          copy._experiments[key] = newValue;
          return copy;
        }
      }
      case "sequenceNumber": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerInfo(this);
              copy._hasSequenceNumber = true;
              copy._sequenceNumber = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSequenceNumber) {
                return this;
              }
              const copy = new PlayerInfo(this);
              copy._hasSequenceNumber = false;
              copy._sequenceNumber = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerInfo} other
   * @returns {PlayerInfo}
   */
  merge(other) {
    const copy = new PlayerInfo(this);
    if (other._hasUuid) {
      copy._hasUuid = true;
      copy._uuid = other._uuid;
    }
    if (other._hasPassword) {
      copy._hasPassword = true;
      copy._password = other._password;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasFacebookId) {
      copy._hasFacebookId = true;
      copy._facebookId = other._facebookId;
    }
    if (other._hasTag) {
      copy._hasTag = true;
      copy._tag = other._tag;
    }
    if (other._hasGoogleId) {
      copy._hasGoogleId = true;
      copy._googleId = other._googleId;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasGold) {
      copy._hasGold = true;
      copy._gold = other._gold;
    }
    if (other._hasGems) {
      copy._hasGems = true;
      copy._gems = other._gems;
    }
    if (other._hasExp) {
      copy._hasExp = true;
      copy._exp = other._exp;
    }
    if (other._hasRenameCount) {
      copy._hasRenameCount = true;
      copy._renameCount = other._renameCount;
    }
    copy._experiments = this._experiments.concat(other._experiments);
    if (other._hasSequenceNumber) {
      copy._hasSequenceNumber = true;
      copy._sequenceNumber = other._sequenceNumber;
    }
    return copy;
  }
}
PlayerInfo.default = new PlayerInfo();
PlayerInfo.Experiment = PlayerInfo_Experiment;
class PlayerInfo_Builder {
  constructor(value) {
    this._value = new PlayerInfo(value);
  }
  build() {
    return new PlayerInfo(this._value);
  }
  setUuid(value) {
    this._value._hasUuid = true;
    this._value._uuid = value;
    return this;
  }
  deleteUuid() {
    this._value._hasUuid = false;
    this._value._uuid = null;
    return this;
  }
  setPassword(value) {
    this._value._hasPassword = true;
    this._value._password = value;
    return this;
  }
  deletePassword() {
    this._value._hasPassword = false;
    this._value._password = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setFacebookId(value) {
    this._value._hasFacebookId = true;
    this._value._facebookId = value;
    return this;
  }
  deleteFacebookId() {
    this._value._hasFacebookId = false;
    this._value._facebookId = null;
    return this;
  }
  setTag(value) {
    this._value._hasTag = true;
    this._value._tag = value;
    return this;
  }
  deleteTag() {
    this._value._hasTag = false;
    this._value._tag = null;
    return this;
  }
  setGoogleId(value) {
    this._value._hasGoogleId = true;
    this._value._googleId = value;
    return this;
  }
  deleteGoogleId() {
    this._value._hasGoogleId = false;
    this._value._googleId = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setGold(value) {
    this._value._hasGold = true;
    this._value._gold = value;
    return this;
  }
  deleteGold() {
    this._value._hasGold = false;
    this._value._gold = null;
    return this;
  }
  setGems(value) {
    this._value._hasGems = true;
    this._value._gems = value;
    return this;
  }
  deleteGems() {
    this._value._hasGems = false;
    this._value._gems = null;
    return this;
  }
  setExp(value) {
    this._value._hasExp = true;
    this._value._exp = value;
    return this;
  }
  deleteExp() {
    this._value._hasExp = false;
    this._value._exp = null;
    return this;
  }
  setRenameCount(value) {
    this._value._hasRenameCount = true;
    this._value._renameCount = value;
    return this;
  }
  deleteRenameCount() {
    this._value._hasRenameCount = false;
    this._value._renameCount = null;
    return this;
  }
  addAllExperiments(values) {
    this._value._experiments = this._value._experiments.concat(values);
    return this;
  }
  addExperiments(value) {
    this._value._experiments = this._value._experiments.concat([value]);
    return this;
  }
  setExperiments(index, value) {
    this._value._experiments = this._value._experiments.concat();
    this._value._experiments[index] = value;
    return this;
  }
  clearExperiments() {
    this._value._experiments = [];
    return this;
  }
  setSequenceNumber(value) {
    this._value._hasSequenceNumber = true;
    this._value._sequenceNumber = value;
    return this;
  }
  deleteSequenceNumber() {
    this._value._hasSequenceNumber = false;
    this._value._sequenceNumber = null;
    return this;
  }
}
PlayerInfo.Builder = PlayerInfo_Builder;
class PlayerInfo_WithParent {
  /**
   * @param {PlayerInfo} value
   * @param {PlayerInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUuid() {
    if (this._cachedHasUuid === undefined) {
      if (this._value.hasUuid) {
        this._cachedHasUuid = true;
      } else {
        this._cachedHasUuid = this._parent ? this._parent.hasUuid : false;
      }
    }
    return this._cachedHasUuid;
  }
  get uuid() {
    if (this._cachedUuid === undefined) {
      if (this._value.hasUuid) {
        this._cachedUuid = this._value.uuid;
      } else {
        this._cachedUuid = this._parent ? this._parent.uuid : this._value.uuid;
      }
    }
    return this._cachedUuid;
  }
  get hasPassword() {
    if (this._cachedHasPassword === undefined) {
      if (this._value.hasPassword) {
        this._cachedHasPassword = true;
      } else {
        this._cachedHasPassword = this._parent ? this._parent.hasPassword : false;
      }
    }
    return this._cachedHasPassword;
  }
  get password() {
    if (this._cachedPassword === undefined) {
      if (this._value.hasPassword) {
        this._cachedPassword = this._value.password;
      } else {
        this._cachedPassword = this._parent ? this._parent.password : this._value.password;
      }
    }
    return this._cachedPassword;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasFacebookId() {
    if (this._cachedHasFacebookId === undefined) {
      if (this._value.hasFacebookId) {
        this._cachedHasFacebookId = true;
      } else {
        this._cachedHasFacebookId = this._parent ? this._parent.hasFacebookId : false;
      }
    }
    return this._cachedHasFacebookId;
  }
  get facebookId() {
    if (this._cachedFacebookId === undefined) {
      if (this._value.hasFacebookId) {
        this._cachedFacebookId = this._value.facebookId;
      } else {
        this._cachedFacebookId = this._parent ? this._parent.facebookId : this._value.facebookId;
      }
    }
    return this._cachedFacebookId;
  }
  get hasTag() {
    if (this._cachedHasTag === undefined) {
      if (this._value.hasTag) {
        this._cachedHasTag = true;
      } else {
        this._cachedHasTag = this._parent ? this._parent.hasTag : false;
      }
    }
    return this._cachedHasTag;
  }
  get tag() {
    if (this._cachedTag === undefined) {
      if (this._value.hasTag) {
        this._cachedTag = this._value.tag;
      } else {
        this._cachedTag = this._parent ? this._parent.tag : this._value.tag;
      }
    }
    return this._cachedTag;
  }
  get hasGoogleId() {
    if (this._cachedHasGoogleId === undefined) {
      if (this._value.hasGoogleId) {
        this._cachedHasGoogleId = true;
      } else {
        this._cachedHasGoogleId = this._parent ? this._parent.hasGoogleId : false;
      }
    }
    return this._cachedHasGoogleId;
  }
  get googleId() {
    if (this._cachedGoogleId === undefined) {
      if (this._value.hasGoogleId) {
        this._cachedGoogleId = this._value.googleId;
      } else {
        this._cachedGoogleId = this._parent ? this._parent.googleId : this._value.googleId;
      }
    }
    return this._cachedGoogleId;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasGold() {
    if (this._cachedHasGold === undefined) {
      if (this._value.hasGold) {
        this._cachedHasGold = true;
      } else {
        this._cachedHasGold = this._parent ? this._parent.hasGold : false;
      }
    }
    return this._cachedHasGold;
  }
  get gold() {
    if (this._cachedGold === undefined) {
      if (this._value.hasGold) {
        this._cachedGold = this._value.gold;
      } else {
        this._cachedGold = this._parent ? this._parent.gold : this._value.gold;
      }
    }
    return this._cachedGold;
  }
  get hasGems() {
    if (this._cachedHasGems === undefined) {
      if (this._value.hasGems) {
        this._cachedHasGems = true;
      } else {
        this._cachedHasGems = this._parent ? this._parent.hasGems : false;
      }
    }
    return this._cachedHasGems;
  }
  get gems() {
    if (this._cachedGems === undefined) {
      if (this._value.hasGems) {
        this._cachedGems = this._value.gems;
      } else {
        this._cachedGems = this._parent ? this._parent.gems : this._value.gems;
      }
    }
    return this._cachedGems;
  }
  get hasExp() {
    if (this._cachedHasExp === undefined) {
      if (this._value.hasExp) {
        this._cachedHasExp = true;
      } else {
        this._cachedHasExp = this._parent ? this._parent.hasExp : false;
      }
    }
    return this._cachedHasExp;
  }
  get exp() {
    if (this._cachedExp === undefined) {
      if (this._value.hasExp) {
        this._cachedExp = this._value.exp;
      } else {
        this._cachedExp = this._parent ? this._parent.exp : this._value.exp;
      }
    }
    return this._cachedExp;
  }
  get hasRenameCount() {
    if (this._cachedHasRenameCount === undefined) {
      if (this._value.hasRenameCount) {
        this._cachedHasRenameCount = true;
      } else {
        this._cachedHasRenameCount = this._parent ? this._parent.hasRenameCount : false;
      }
    }
    return this._cachedHasRenameCount;
  }
  get renameCount() {
    if (this._cachedRenameCount === undefined) {
      if (this._value.hasRenameCount) {
        this._cachedRenameCount = this._value.renameCount;
      } else {
        this._cachedRenameCount = this._parent ? this._parent.renameCount : this._value.renameCount;
      }
    }
    return this._cachedRenameCount;
  }
  get selfExperiments() {
    if (!this._selfExperiments) {
      this._selfExperiments = [];
      for (let i of this._value.experiments) {
        this._selfExperiments.push(new PlayerInfo_Experiment.WithParent(i, null));
      }
    }
    return this._selfExperiments;
  }
  get inherentExperiments() {
    if (!this._inherentExperiments) {
      this._inherentExperiments = this._parent ? this._parent.experiments : [];
    }
    return this._inherentExperiments;
  }
  get experiments() {
    if (!this._allExperiments) {
      this._allExperiments = this._parent ? this._parent.experiments.concat(this.selfExperiments) : this.selfExperiments;
    }
    return this._allExperiments;
  }
  get hasSequenceNumber() {
    if (this._cachedHasSequenceNumber === undefined) {
      if (this._value.hasSequenceNumber) {
        this._cachedHasSequenceNumber = true;
      } else {
        this._cachedHasSequenceNumber = this._parent ? this._parent.hasSequenceNumber : false;
      }
    }
    return this._cachedHasSequenceNumber;
  }
  get sequenceNumber() {
    if (this._cachedSequenceNumber === undefined) {
      if (this._value.hasSequenceNumber) {
        this._cachedSequenceNumber = this._value.sequenceNumber;
      } else {
        this._cachedSequenceNumber = this._parent ? this._parent.sequenceNumber : this._value.sequenceNumber;
      }
    }
    return this._cachedSequenceNumber;
  }
  update(current, parent) {
    const result = new PlayerInfo_WithParent(current, parent);
    if (this._selfExperiments) {
      if (this._value.experiments === current.experiments) {
        result._selfExperiments = this._selfExperiments;
      } else {
        result._selfExperiments = [];
        for (let i = 0; i < current.experiments.length; i++) {
          const oldValue = this._value.experiments[i];
          if (oldValue) {
            const oldCache = this._selfExperiments[i];
            if (oldValue === current.experiments[i]) {
              result._selfExperiments[i] = oldCache;
            } else {
              result._selfExperiments[i] = oldCache.update(current.experiments[i], null);
            }
          } else {
            result._selfExperiments[i] = new PlayerInfo_Experiment.WithParent(current.experiments[i], null);
          }
        }
      }
    }
    return result;
  }
}
PlayerInfo_WithParent.default = new PlayerInfo_WithParent(PlayerInfo.default, null);
PlayerInfo.WithParent = PlayerInfo_WithParent;
class PlayerInfo_Descriptor {
  get uuid() {
    if (!this._uuid) {
      this._uuid = {
        name: "uuid",
        Name: "Uuid",
        number: 1,
        protoType: 9,
        protoName: "uuid",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uuid;
  }
  get password() {
    if (!this._password) {
      this._password = {
        name: "password",
        Name: "Password",
        number: 2,
        protoType: 9,
        protoName: "password",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._password;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 3,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get facebookId() {
    if (!this._facebookId) {
      this._facebookId = {
        name: "facebookId",
        Name: "FacebookId",
        number: 4,
        protoType: 9,
        protoName: "facebook_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._facebookId;
  }
  get tag() {
    if (!this._tag) {
      this._tag = {
        name: "tag",
        Name: "Tag",
        number: 5,
        protoType: 9,
        protoName: "tag",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tag;
  }
  get googleId() {
    if (!this._googleId) {
      this._googleId = {
        name: "googleId",
        Name: "GoogleId",
        number: 6,
        protoType: 9,
        protoName: "google_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._googleId;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 11,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get gold() {
    if (!this._gold) {
      this._gold = {
        name: "gold",
        Name: "Gold",
        number: 12,
        protoType: 5,
        protoName: "gold",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gold;
  }
  get gems() {
    if (!this._gems) {
      this._gems = {
        name: "gems",
        Name: "Gems",
        number: 13,
        protoType: 5,
        protoName: "gems",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gems;
  }
  get exp() {
    if (!this._exp) {
      this._exp = {
        name: "exp",
        Name: "Exp",
        number: 14,
        protoType: 5,
        protoName: "exp",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._exp;
  }
  get renameCount() {
    if (!this._renameCount) {
      this._renameCount = {
        name: "renameCount",
        Name: "RenameCount",
        number: 15,
        protoType: 5,
        protoName: "rename_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._renameCount;
  }
  get experiments() {
    if (!this._experiments) {
      this._experiments = {
        name: "experiments",
        Name: "Experiments",
        number: 21,
        protoType: 11,
        protoName: "experiments",
        type: PlayerInfo_Experiment,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._experiments;
  }
  get sequenceNumber() {
    if (!this._sequenceNumber) {
      this._sequenceNumber = {
        name: "sequenceNumber",
        Name: "SequenceNumber",
        number: 31,
        protoType: 5,
        protoName: "sequence_number",
        type: JsonToInt32,
        options: {
          comments: "Used for energy system to keep tracks of how many time the user purchased",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sequenceNumber;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.uuid,
        this.password,
        this.name,
        this.facebookId,
        this.tag,
        this.googleId,
        this.level,
        this.gold,
        this.gems,
        this.exp,
        this.renameCount,
        this.experiments,
        this.sequenceNumber,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUuid",
        Name: "DummyOneofForUuid",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPassword",
        Name: "DummyOneofForPassword",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFacebookId",
        Name: "DummyOneofForFacebookId",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTag",
        Name: "DummyOneofForTag",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoogleId",
        Name: "DummyOneofForGoogleId",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGold",
        Name: "DummyOneofForGold",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGems",
        Name: "DummyOneofForGems",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExp",
        Name: "DummyOneofForExp",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRenameCount",
        Name: "DummyOneofForRenameCount",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSequenceNumber",
        Name: "DummyOneofForSequenceNumber",
        fields: [
          this.fields[12],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerInfo.descriptor = new PlayerInfo_Descriptor();
class CardUsageStats_CardUsage {
  get descriptor() {
    return CardUsageStats_CardUsage.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasUseCount = false;
    this._useCount = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasUseCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardUsageStats_CardUsage) {
      return value;
    }
    return CardUsageStats_CardUsage.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardUsageStats_CardUsage();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.useCount != null) {
      result._hasUseCount = true;
      result._useCount = JsonToInt32.fromJson(json.useCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasUseCount) {
      result.useCount = JsonToInt32.toJson(this._useCount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get useCount() {
    return this._hasUseCount ? this._useCount : JsonToInt32.default;
  }
  get hasUseCount() {
    return this._hasUseCount;
  }
  setUseCount(path, value) {
    return {type: 'SET', path: path.concat(['useCount']), value};
  }
  deleteUseCount(path) {
    return {type: 'DELETE', path: path.concat(['useCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardUsageStats_CardUsage(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardUsageStats_CardUsage(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardUsageStats_CardUsage(this);
              copy._hasUseCount = true;
              copy._useCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseCount) {
                return this;
              }
              const copy = new CardUsageStats_CardUsage(this);
              copy._hasUseCount = false;
              copy._useCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardUsageStats_CardUsage} other
   * @returns {CardUsageStats_CardUsage}
   */
  merge(other) {
    const copy = new CardUsageStats_CardUsage(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasUseCount) {
      copy._hasUseCount = true;
      copy._useCount = other._useCount;
    }
    return copy;
  }
}
CardUsageStats_CardUsage.default = new CardUsageStats_CardUsage();
class CardUsageStats_CardUsage_Builder {
  constructor(value) {
    this._value = new CardUsageStats_CardUsage(value);
  }
  build() {
    return new CardUsageStats_CardUsage(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setUseCount(value) {
    this._value._hasUseCount = true;
    this._value._useCount = value;
    return this;
  }
  deleteUseCount() {
    this._value._hasUseCount = false;
    this._value._useCount = null;
    return this;
  }
}
CardUsageStats_CardUsage.Builder = CardUsageStats_CardUsage_Builder;
class CardUsageStats_CardUsage_WithParent {
  /**
   * @param {CardUsageStats_CardUsage} value
   * @param {CardUsageStats_CardUsage_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardUsageStats_CardUsage.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasUseCount() {
    if (this._cachedHasUseCount === undefined) {
      if (this._value.hasUseCount) {
        this._cachedHasUseCount = true;
      } else {
        this._cachedHasUseCount = this._parent ? this._parent.hasUseCount : false;
      }
    }
    return this._cachedHasUseCount;
  }
  get useCount() {
    if (this._cachedUseCount === undefined) {
      if (this._value.hasUseCount) {
        this._cachedUseCount = this._value.useCount;
      } else {
        this._cachedUseCount = this._parent ? this._parent.useCount : this._value.useCount;
      }
    }
    return this._cachedUseCount;
  }
  update(current, parent) {
    const result = new CardUsageStats_CardUsage_WithParent(current, parent);
    return result;
  }
}
CardUsageStats_CardUsage_WithParent.default = new CardUsageStats_CardUsage_WithParent(CardUsageStats_CardUsage.default, null);
CardUsageStats_CardUsage.WithParent = CardUsageStats_CardUsage_WithParent;
class CardUsageStats_CardUsage_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get useCount() {
    if (!this._useCount) {
      this._useCount = {
        name: "useCount",
        Name: "UseCount",
        number: 2,
        protoType: 5,
        protoName: "use_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.useCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseCount",
        Name: "DummyOneofForUseCount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardUsageStats_CardUsage.descriptor = new CardUsageStats_CardUsage_Descriptor();
export class CardUsageStats {
  get descriptor() {
    return CardUsageStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cardUsageList = [];
  }
  isEmpty() {
    if (this._cardUsageList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardUsageStats) {
      return value;
    }
    return CardUsageStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardUsageStats();
    result._cardUsageList = JsonToList(json.cardUsageList, CardUsageStats_CardUsage);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cardUsageList.length > 0) {
      result.cardUsageList = ArrayToJson(this._cardUsageList, CardUsageStats_CardUsage);
    }
    return result;
  }
  /**
   * @returns {CardUsageStats_CardUsage[]}
   */
  get cardUsageList() {
    return this._cardUsageList;
  }
  addCardUsageList(path, value) {
    return {type: 'ADD', path: path.concat(['cardUsageList']), value: value.toJson()};
  }
  setCardUsageList(path, value) {
    return {type: 'SET', path: path.concat(['cardUsageList']), value: ArrayToJson(value, CardUsageStats_CardUsage)};
  }
  setCardUsageListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardUsageList', key]), value: value.toJson()};
  }
  deleteCardUsageList(path) {
    return {type: 'DELETE', path: path.concat(['cardUsageList'])};
  }
  deleteCardUsageListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardUsageList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardUsageList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardUsageStats(this);
              copy._cardUsageList = [];        for (let i of value) {
                copy._cardUsageList.push(CardUsageStats_CardUsage.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardUsageStats(this);
              copy._cardUsageList = copy._cardUsageList.concat([CardUsageStats_CardUsage.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardUsageList.length === 0) {
                return this;
              }
              const copy = new CardUsageStats(this);
              copy._cardUsageList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardUsageList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardUsageStats(this);
              copy._cardUsageList = copy._cardUsageList.slice();
              copy._cardUsageList[path[1]] = CardUsageStats_CardUsage.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardUsageStats(this);
              copy._cardUsageList = copy._cardUsageList.slice(0, path[1]).concat(copy._cardUsageList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardUsageList.length) {
            return this;
          }
          const oldValue = this._cardUsageList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardUsageStats(this);
          copy._cardUsageList = copy._cardUsageList.slice();
          copy._cardUsageList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardUsageStats} other
   * @returns {CardUsageStats}
   */
  merge(other) {
    const copy = new CardUsageStats(this);
    copy._cardUsageList = this._cardUsageList.concat(other._cardUsageList);
    return copy;
  }
}
CardUsageStats.default = new CardUsageStats();
CardUsageStats.CardUsage = CardUsageStats_CardUsage;
class CardUsageStats_Builder {
  constructor(value) {
    this._value = new CardUsageStats(value);
  }
  build() {
    return new CardUsageStats(this._value);
  }
  addAllCardUsageList(values) {
    this._value._cardUsageList = this._value._cardUsageList.concat(values);
    return this;
  }
  addCardUsageList(value) {
    this._value._cardUsageList = this._value._cardUsageList.concat([value]);
    return this;
  }
  setCardUsageList(index, value) {
    this._value._cardUsageList = this._value._cardUsageList.concat();
    this._value._cardUsageList[index] = value;
    return this;
  }
  clearCardUsageList() {
    this._value._cardUsageList = [];
    return this;
  }
}
CardUsageStats.Builder = CardUsageStats_Builder;
class CardUsageStats_WithParent {
  /**
   * @param {CardUsageStats} value
   * @param {CardUsageStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardUsageStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCardUsageList() {
    if (!this._selfCardUsageList) {
      this._selfCardUsageList = [];
      for (let i of this._value.cardUsageList) {
        this._selfCardUsageList.push(new CardUsageStats_CardUsage.WithParent(i, null));
      }
    }
    return this._selfCardUsageList;
  }
  get inherentCardUsageList() {
    if (!this._inherentCardUsageList) {
      this._inherentCardUsageList = this._parent ? this._parent.cardUsageList : [];
    }
    return this._inherentCardUsageList;
  }
  get cardUsageList() {
    if (!this._allCardUsageList) {
      this._allCardUsageList = this._parent ? this._parent.cardUsageList.concat(this.selfCardUsageList) : this.selfCardUsageList;
    }
    return this._allCardUsageList;
  }
  update(current, parent) {
    const result = new CardUsageStats_WithParent(current, parent);
    if (this._selfCardUsageList) {
      if (this._value.cardUsageList === current.cardUsageList) {
        result._selfCardUsageList = this._selfCardUsageList;
      } else {
        result._selfCardUsageList = [];
        for (let i = 0; i < current.cardUsageList.length; i++) {
          const oldValue = this._value.cardUsageList[i];
          if (oldValue) {
            const oldCache = this._selfCardUsageList[i];
            if (oldValue === current.cardUsageList[i]) {
              result._selfCardUsageList[i] = oldCache;
            } else {
              result._selfCardUsageList[i] = oldCache.update(current.cardUsageList[i], null);
            }
          } else {
            result._selfCardUsageList[i] = new CardUsageStats_CardUsage.WithParent(current.cardUsageList[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardUsageStats_WithParent.default = new CardUsageStats_WithParent(CardUsageStats.default, null);
CardUsageStats.WithParent = CardUsageStats_WithParent;
class CardUsageStats_Descriptor {
  get cardUsageList() {
    if (!this._cardUsageList) {
      this._cardUsageList = {
        name: "cardUsageList",
        Name: "CardUsageList",
        number: 1,
        protoType: 11,
        protoName: "card_usage_list",
        type: CardUsageStats_CardUsage,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardUsageList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardUsageList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CardUsageStats.descriptor = new CardUsageStats_Descriptor();
class SaveFile_SaveData {
  get descriptor() {
    return SaveFile_SaveData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasSave = false;
    this._save = null;
    this._hasTimestamp = false;
    this._timestamp = null;
    this._hasEntryPoint = false;
    this._entryPoint = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasSave) return false;
    if (this._hasTimestamp) return false;
    if (this._hasEntryPoint) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SaveFile_SaveData) {
      return value;
    }
    return SaveFile_SaveData.fromJson(value);
  }
  static fromJson(json) {
    const result = new SaveFile_SaveData();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.save != null) {
      result._hasSave = true;
      result._save = JsonToString.fromJson(json.save);
    }
    if (json.timestamp != null) {
      result._hasTimestamp = true;
      result._timestamp = JsonToString.fromJson(json.timestamp);
    }
    if (json.entryPoint != null) {
      result._hasEntryPoint = true;
      result._entryPoint = JsonToString.fromJson(json.entryPoint);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasSave) {
      result.save = JsonToString.toJson(this._save);
    }
    if (this._hasTimestamp) {
      result.timestamp = JsonToString.toJson(this._timestamp);
    }
    if (this._hasEntryPoint) {
      result.entryPoint = JsonToString.toJson(this._entryPoint);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get save() {
    return this._hasSave ? this._save : JsonToString.default;
  }
  get hasSave() {
    return this._hasSave;
  }
  setSave(path, value) {
    return {type: 'SET', path: path.concat(['save']), value};
  }
  deleteSave(path) {
    return {type: 'DELETE', path: path.concat(['save'])};
  }
  /**
   * @returns {string}
   */
  get timestamp() {
    return this._hasTimestamp ? this._timestamp : JsonToString.default;
  }
  get hasTimestamp() {
    return this._hasTimestamp;
  }
  setTimestamp(path, value) {
    return {type: 'SET', path: path.concat(['timestamp']), value};
  }
  deleteTimestamp(path) {
    return {type: 'DELETE', path: path.concat(['timestamp'])};
  }
  /**
   * @returns {string}
   */
  get entryPoint() {
    return this._hasEntryPoint ? this._entryPoint : JsonToString.default;
  }
  get hasEntryPoint() {
    return this._hasEntryPoint;
  }
  setEntryPoint(path, value) {
    return {type: 'SET', path: path.concat(['entryPoint']), value};
  }
  deleteEntryPoint(path) {
    return {type: 'DELETE', path: path.concat(['entryPoint'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile_SaveData(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new SaveFile_SaveData(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "save": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile_SaveData(this);
              copy._hasSave = true;
              copy._save = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSave) {
                return this;
              }
              const copy = new SaveFile_SaveData(this);
              copy._hasSave = false;
              copy._save = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "timestamp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile_SaveData(this);
              copy._hasTimestamp = true;
              copy._timestamp = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTimestamp) {
                return this;
              }
              const copy = new SaveFile_SaveData(this);
              copy._hasTimestamp = false;
              copy._timestamp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "entryPoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile_SaveData(this);
              copy._hasEntryPoint = true;
              copy._entryPoint = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEntryPoint) {
                return this;
              }
              const copy = new SaveFile_SaveData(this);
              copy._hasEntryPoint = false;
              copy._entryPoint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SaveFile_SaveData} other
   * @returns {SaveFile_SaveData}
   */
  merge(other) {
    const copy = new SaveFile_SaveData(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasSave) {
      copy._hasSave = true;
      copy._save = other._save;
    }
    if (other._hasTimestamp) {
      copy._hasTimestamp = true;
      copy._timestamp = other._timestamp;
    }
    if (other._hasEntryPoint) {
      copy._hasEntryPoint = true;
      copy._entryPoint = other._entryPoint;
    }
    return copy;
  }
}
SaveFile_SaveData.default = new SaveFile_SaveData();
class SaveFile_SaveData_Builder {
  constructor(value) {
    this._value = new SaveFile_SaveData(value);
  }
  build() {
    return new SaveFile_SaveData(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setSave(value) {
    this._value._hasSave = true;
    this._value._save = value;
    return this;
  }
  deleteSave() {
    this._value._hasSave = false;
    this._value._save = null;
    return this;
  }
  setTimestamp(value) {
    this._value._hasTimestamp = true;
    this._value._timestamp = value;
    return this;
  }
  deleteTimestamp() {
    this._value._hasTimestamp = false;
    this._value._timestamp = null;
    return this;
  }
  setEntryPoint(value) {
    this._value._hasEntryPoint = true;
    this._value._entryPoint = value;
    return this;
  }
  deleteEntryPoint() {
    this._value._hasEntryPoint = false;
    this._value._entryPoint = null;
    return this;
  }
}
SaveFile_SaveData.Builder = SaveFile_SaveData_Builder;
class SaveFile_SaveData_WithParent {
  /**
   * @param {SaveFile_SaveData} value
   * @param {SaveFile_SaveData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SaveFile_SaveData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasSave() {
    if (this._cachedHasSave === undefined) {
      if (this._value.hasSave) {
        this._cachedHasSave = true;
      } else {
        this._cachedHasSave = this._parent ? this._parent.hasSave : false;
      }
    }
    return this._cachedHasSave;
  }
  get save() {
    if (this._cachedSave === undefined) {
      if (this._value.hasSave) {
        this._cachedSave = this._value.save;
      } else {
        this._cachedSave = this._parent ? this._parent.save : this._value.save;
      }
    }
    return this._cachedSave;
  }
  get hasTimestamp() {
    if (this._cachedHasTimestamp === undefined) {
      if (this._value.hasTimestamp) {
        this._cachedHasTimestamp = true;
      } else {
        this._cachedHasTimestamp = this._parent ? this._parent.hasTimestamp : false;
      }
    }
    return this._cachedHasTimestamp;
  }
  get timestamp() {
    if (this._cachedTimestamp === undefined) {
      if (this._value.hasTimestamp) {
        this._cachedTimestamp = this._value.timestamp;
      } else {
        this._cachedTimestamp = this._parent ? this._parent.timestamp : this._value.timestamp;
      }
    }
    return this._cachedTimestamp;
  }
  get hasEntryPoint() {
    if (this._cachedHasEntryPoint === undefined) {
      if (this._value.hasEntryPoint) {
        this._cachedHasEntryPoint = true;
      } else {
        this._cachedHasEntryPoint = this._parent ? this._parent.hasEntryPoint : false;
      }
    }
    return this._cachedHasEntryPoint;
  }
  get entryPoint() {
    if (this._cachedEntryPoint === undefined) {
      if (this._value.hasEntryPoint) {
        this._cachedEntryPoint = this._value.entryPoint;
      } else {
        this._cachedEntryPoint = this._parent ? this._parent.entryPoint : this._value.entryPoint;
      }
    }
    return this._cachedEntryPoint;
  }
  update(current, parent) {
    const result = new SaveFile_SaveData_WithParent(current, parent);
    return result;
  }
}
SaveFile_SaveData_WithParent.default = new SaveFile_SaveData_WithParent(SaveFile_SaveData.default, null);
SaveFile_SaveData.WithParent = SaveFile_SaveData_WithParent;
class SaveFile_SaveData_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get save() {
    if (!this._save) {
      this._save = {
        name: "save",
        Name: "Save",
        number: 2,
        protoType: 9,
        protoName: "save",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._save;
  }
  get timestamp() {
    if (!this._timestamp) {
      this._timestamp = {
        name: "timestamp",
        Name: "Timestamp",
        number: 3,
        protoType: 9,
        protoName: "timestamp",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._timestamp;
  }
  get entryPoint() {
    if (!this._entryPoint) {
      this._entryPoint = {
        name: "entryPoint",
        Name: "EntryPoint",
        number: 4,
        protoType: 9,
        protoName: "entry_point",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._entryPoint;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.save,
        this.timestamp,
        this.entryPoint,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSave",
        Name: "DummyOneofForSave",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTimestamp",
        Name: "DummyOneofForTimestamp",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEntryPoint",
        Name: "DummyOneofForEntryPoint",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
SaveFile_SaveData.descriptor = new SaveFile_SaveData_Descriptor();
export class SaveFile {
  get descriptor() {
    return SaveFile.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerInfo = false;
    this._playerInfo = null;
    this._hasPlayerProgression = false;
    this._playerProgression = null;
    this._hasPlayerEnergy = false;
    this._playerEnergy = null;
    this._likedCommentIds = [];
    this._mapProgresses = [];
    this._savedMapComments = [];
    this._consumableItems = [];
    this._hasShipUpgradeProgression = false;
    this._shipUpgradeProgression = null;
    this._hasCampaignProgress = false;
    this._campaignProgress = null;
    this._achievementProgresses = [];
    this._playerLoadouts = [];
    this._hasPlayerInventory = false;
    this._playerInventory = null;
    this._hasGenericDataProgress = false;
    this._genericDataProgress = null;
    this._mapSaveData = [];
    this._hasCardUsageStats = false;
    this._cardUsageStats = null;
    this._promotionBundleStatus = [];
  }
  isEmpty() {
    if (this._hasPlayerInfo && !this._playerInfo.isEmpty()) return false;
    if (this._hasPlayerProgression && !this._playerProgression.isEmpty()) return false;
    if (this._hasPlayerEnergy && !this._playerEnergy.isEmpty()) return false;
    if (this._likedCommentIds.length > 0) return false;
    if (this._mapProgresses.length > 0) return false;
    if (this._savedMapComments.length > 0) return false;
    if (this._consumableItems.length > 0) return false;
    if (this._hasShipUpgradeProgression && !this._shipUpgradeProgression.isEmpty()) return false;
    if (this._hasCampaignProgress && !this._campaignProgress.isEmpty()) return false;
    if (this._achievementProgresses.length > 0) return false;
    if (this._playerLoadouts.length > 0) return false;
    if (this._hasPlayerInventory && !this._playerInventory.isEmpty()) return false;
    if (this._hasGenericDataProgress && !this._genericDataProgress.isEmpty()) return false;
    if (this._mapSaveData.length > 0) return false;
    if (this._hasCardUsageStats && !this._cardUsageStats.isEmpty()) return false;
    if (this._promotionBundleStatus.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SaveFile) {
      return value;
    }
    return SaveFile.fromJson(value);
  }
  static fromJson(json) {
    const result = new SaveFile();
    if (json.playerInfo != null) {
      result._hasPlayerInfo = true;
      result._playerInfo = PlayerInfo.fromJson(json.playerInfo);
    }
    if (json.playerProgression != null) {
      result._hasPlayerProgression = true;
      result._playerProgression = dcei_wildsky_card_proto.PlayerProgression.fromJson(json.playerProgression);
    }
    if (json.playerEnergy != null) {
      result._hasPlayerEnergy = true;
      result._playerEnergy = EnergyData.fromJson(json.playerEnergy);
    }
    result._likedCommentIds = JsonToList(json.likedCommentIds, JsonToString);
    result._mapProgresses = JsonToList(json.mapProgresses, MapProgress);
    result._savedMapComments = JsonToList(json.savedMapComments, SavedMapComment);
    result._consumableItems = JsonToList(json.consumableItems, ConsumableItemSave);
    if (json.shipUpgradeProgression != null) {
      result._hasShipUpgradeProgression = true;
      result._shipUpgradeProgression = dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.fromJson(json.shipUpgradeProgression);
    }
    if (json.campaignProgress != null) {
      result._hasCampaignProgress = true;
      result._campaignProgress = CampaignProgress.fromJson(json.campaignProgress);
    }
    result._achievementProgresses = JsonToList(json.achievementProgresses, AchievementProgress);
    result._playerLoadouts = JsonToList(json.playerLoadouts, dcei_wildsky_card_proto.PlayerLoadout);
    if (json.playerInventory != null) {
      result._hasPlayerInventory = true;
      result._playerInventory = UserInventory.fromJson(json.playerInventory);
    }
    if (json.genericDataProgress != null) {
      result._hasGenericDataProgress = true;
      result._genericDataProgress = GenericDataProgress.fromJson(json.genericDataProgress);
    }
    result._mapSaveData = JsonToList(json.mapSaveData, SaveFile_SaveData);
    if (json.cardUsageStats != null) {
      result._hasCardUsageStats = true;
      result._cardUsageStats = CardUsageStats.fromJson(json.cardUsageStats);
    }
    result._promotionBundleStatus = JsonToList(json.promotionBundleStatus, PromotionBundleStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerInfo && !this._playerInfo.isEmpty()) {
      result.playerInfo = PlayerInfo.toJson(this._playerInfo);
    }
    if (this._hasPlayerProgression && !this._playerProgression.isEmpty()) {
      result.playerProgression = dcei_wildsky_card_proto.PlayerProgression.toJson(this._playerProgression);
    }
    if (this._hasPlayerEnergy && !this._playerEnergy.isEmpty()) {
      result.playerEnergy = EnergyData.toJson(this._playerEnergy);
    }
    if (this._likedCommentIds.length > 0) {
      result.likedCommentIds = ArrayToJson(this._likedCommentIds, JsonToString);
    }
    if (this._mapProgresses.length > 0) {
      result.mapProgresses = ArrayToJson(this._mapProgresses, MapProgress);
    }
    if (this._savedMapComments.length > 0) {
      result.savedMapComments = ArrayToJson(this._savedMapComments, SavedMapComment);
    }
    if (this._consumableItems.length > 0) {
      result.consumableItems = ArrayToJson(this._consumableItems, ConsumableItemSave);
    }
    if (this._hasShipUpgradeProgression && !this._shipUpgradeProgression.isEmpty()) {
      result.shipUpgradeProgression = dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.toJson(this._shipUpgradeProgression);
    }
    if (this._hasCampaignProgress && !this._campaignProgress.isEmpty()) {
      result.campaignProgress = CampaignProgress.toJson(this._campaignProgress);
    }
    if (this._achievementProgresses.length > 0) {
      result.achievementProgresses = ArrayToJson(this._achievementProgresses, AchievementProgress);
    }
    if (this._playerLoadouts.length > 0) {
      result.playerLoadouts = ArrayToJson(this._playerLoadouts, dcei_wildsky_card_proto.PlayerLoadout);
    }
    if (this._hasPlayerInventory && !this._playerInventory.isEmpty()) {
      result.playerInventory = UserInventory.toJson(this._playerInventory);
    }
    if (this._hasGenericDataProgress && !this._genericDataProgress.isEmpty()) {
      result.genericDataProgress = GenericDataProgress.toJson(this._genericDataProgress);
    }
    if (this._mapSaveData.length > 0) {
      result.mapSaveData = ArrayToJson(this._mapSaveData, SaveFile_SaveData);
    }
    if (this._hasCardUsageStats && !this._cardUsageStats.isEmpty()) {
      result.cardUsageStats = CardUsageStats.toJson(this._cardUsageStats);
    }
    if (this._promotionBundleStatus.length > 0) {
      result.promotionBundleStatus = ArrayToJson(this._promotionBundleStatus, PromotionBundleStatus);
    }
    return result;
  }
  /**
   * @returns {PlayerInfo}
   */
  get playerInfo() {
    return this._hasPlayerInfo ? this._playerInfo : PlayerInfo.default;
  }
  get hasPlayerInfo() {
    return this._hasPlayerInfo;
  }
  setPlayerInfo(path, value) {
    return {type: 'SET', path: path.concat(['playerInfo']), value: value.toJson()};
  }
  deletePlayerInfo(path) {
    return {type: 'DELETE', path: path.concat(['playerInfo'])};
  }
  /**
   * @returns {dcei_wildsky_card_proto.PlayerProgression}
   */
  get playerProgression() {
    return this._hasPlayerProgression ? this._playerProgression : dcei_wildsky_card_proto.PlayerProgression.default;
  }
  get hasPlayerProgression() {
    return this._hasPlayerProgression;
  }
  setPlayerProgression(path, value) {
    return {type: 'SET', path: path.concat(['playerProgression']), value: value.toJson()};
  }
  deletePlayerProgression(path) {
    return {type: 'DELETE', path: path.concat(['playerProgression'])};
  }
  /**
   * @returns {EnergyData}
   */
  get playerEnergy() {
    return this._hasPlayerEnergy ? this._playerEnergy : EnergyData.default;
  }
  get hasPlayerEnergy() {
    return this._hasPlayerEnergy;
  }
  setPlayerEnergy(path, value) {
    return {type: 'SET', path: path.concat(['playerEnergy']), value: value.toJson()};
  }
  deletePlayerEnergy(path) {
    return {type: 'DELETE', path: path.concat(['playerEnergy'])};
  }
  /**
   * @returns {string[]}
   */
  get likedCommentIds() {
    return this._likedCommentIds;
  }
  addLikedCommentIds(path, value) {
    return {type: 'ADD', path: path.concat(['likedCommentIds']), value};
  }
  setLikedCommentIds(path, value) {
    return {type: 'SET', path: path.concat(['likedCommentIds']), value: ArrayToJson(value, JsonToString)};
  }
  setLikedCommentIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['likedCommentIds', key]), value};
  }
  deleteLikedCommentIds(path) {
    return {type: 'DELETE', path: path.concat(['likedCommentIds'])};
  }
  deleteLikedCommentIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['likedCommentIds', key])};
  }
  /**
   * @returns {MapProgress[]}
   */
  get mapProgresses() {
    return this._mapProgresses;
  }
  addMapProgresses(path, value) {
    return {type: 'ADD', path: path.concat(['mapProgresses']), value: value.toJson()};
  }
  setMapProgresses(path, value) {
    return {type: 'SET', path: path.concat(['mapProgresses']), value: ArrayToJson(value, MapProgress)};
  }
  setMapProgressesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapProgresses', key]), value: value.toJson()};
  }
  deleteMapProgresses(path) {
    return {type: 'DELETE', path: path.concat(['mapProgresses'])};
  }
  deleteMapProgressesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapProgresses', key])};
  }
  /**
   * @returns {SavedMapComment[]}
   */
  get savedMapComments() {
    return this._savedMapComments;
  }
  addSavedMapComments(path, value) {
    return {type: 'ADD', path: path.concat(['savedMapComments']), value: value.toJson()};
  }
  setSavedMapComments(path, value) {
    return {type: 'SET', path: path.concat(['savedMapComments']), value: ArrayToJson(value, SavedMapComment)};
  }
  setSavedMapCommentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['savedMapComments', key]), value: value.toJson()};
  }
  deleteSavedMapComments(path) {
    return {type: 'DELETE', path: path.concat(['savedMapComments'])};
  }
  deleteSavedMapCommentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['savedMapComments', key])};
  }
  /**
   * @returns {ConsumableItemSave[]}
   */
  get consumableItems() {
    return this._consumableItems;
  }
  addConsumableItems(path, value) {
    return {type: 'ADD', path: path.concat(['consumableItems']), value: value.toJson()};
  }
  setConsumableItems(path, value) {
    return {type: 'SET', path: path.concat(['consumableItems']), value: ArrayToJson(value, ConsumableItemSave)};
  }
  setConsumableItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['consumableItems', key]), value: value.toJson()};
  }
  deleteConsumableItems(path) {
    return {type: 'DELETE', path: path.concat(['consumableItems'])};
  }
  deleteConsumableItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['consumableItems', key])};
  }
  /**
   * @returns {dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression}
   */
  get shipUpgradeProgression() {
    return this._hasShipUpgradeProgression ? this._shipUpgradeProgression : dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.default;
  }
  get hasShipUpgradeProgression() {
    return this._hasShipUpgradeProgression;
  }
  setShipUpgradeProgression(path, value) {
    return {type: 'SET', path: path.concat(['shipUpgradeProgression']), value: value.toJson()};
  }
  deleteShipUpgradeProgression(path) {
    return {type: 'DELETE', path: path.concat(['shipUpgradeProgression'])};
  }
  /**
   * @returns {CampaignProgress}
   */
  get campaignProgress() {
    return this._hasCampaignProgress ? this._campaignProgress : CampaignProgress.default;
  }
  get hasCampaignProgress() {
    return this._hasCampaignProgress;
  }
  setCampaignProgress(path, value) {
    return {type: 'SET', path: path.concat(['campaignProgress']), value: value.toJson()};
  }
  deleteCampaignProgress(path) {
    return {type: 'DELETE', path: path.concat(['campaignProgress'])};
  }
  /**
   * @returns {AchievementProgress[]}
   */
  get achievementProgresses() {
    return this._achievementProgresses;
  }
  addAchievementProgresses(path, value) {
    return {type: 'ADD', path: path.concat(['achievementProgresses']), value: value.toJson()};
  }
  setAchievementProgresses(path, value) {
    return {type: 'SET', path: path.concat(['achievementProgresses']), value: ArrayToJson(value, AchievementProgress)};
  }
  setAchievementProgressesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['achievementProgresses', key]), value: value.toJson()};
  }
  deleteAchievementProgresses(path) {
    return {type: 'DELETE', path: path.concat(['achievementProgresses'])};
  }
  deleteAchievementProgressesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['achievementProgresses', key])};
  }
  /**
   * @returns {dcei_wildsky_card_proto.PlayerLoadout[]}
   */
  get playerLoadouts() {
    return this._playerLoadouts;
  }
  addPlayerLoadouts(path, value) {
    return {type: 'ADD', path: path.concat(['playerLoadouts']), value: value.toJson()};
  }
  setPlayerLoadouts(path, value) {
    return {type: 'SET', path: path.concat(['playerLoadouts']), value: ArrayToJson(value, dcei_wildsky_card_proto.PlayerLoadout)};
  }
  setPlayerLoadoutsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['playerLoadouts', key]), value: value.toJson()};
  }
  deletePlayerLoadouts(path) {
    return {type: 'DELETE', path: path.concat(['playerLoadouts'])};
  }
  deletePlayerLoadoutsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['playerLoadouts', key])};
  }
  /**
   * @returns {UserInventory}
   */
  get playerInventory() {
    return this._hasPlayerInventory ? this._playerInventory : UserInventory.default;
  }
  get hasPlayerInventory() {
    return this._hasPlayerInventory;
  }
  setPlayerInventory(path, value) {
    return {type: 'SET', path: path.concat(['playerInventory']), value: value.toJson()};
  }
  deletePlayerInventory(path) {
    return {type: 'DELETE', path: path.concat(['playerInventory'])};
  }
  /**
   * @returns {GenericDataProgress}
   */
  get genericDataProgress() {
    return this._hasGenericDataProgress ? this._genericDataProgress : GenericDataProgress.default;
  }
  get hasGenericDataProgress() {
    return this._hasGenericDataProgress;
  }
  setGenericDataProgress(path, value) {
    return {type: 'SET', path: path.concat(['genericDataProgress']), value: value.toJson()};
  }
  deleteGenericDataProgress(path) {
    return {type: 'DELETE', path: path.concat(['genericDataProgress'])};
  }
  /**
   * @returns {SaveFile_SaveData[]}
   */
  get mapSaveData() {
    return this._mapSaveData;
  }
  addMapSaveData(path, value) {
    return {type: 'ADD', path: path.concat(['mapSaveData']), value: value.toJson()};
  }
  setMapSaveData(path, value) {
    return {type: 'SET', path: path.concat(['mapSaveData']), value: ArrayToJson(value, SaveFile_SaveData)};
  }
  setMapSaveDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapSaveData', key]), value: value.toJson()};
  }
  deleteMapSaveData(path) {
    return {type: 'DELETE', path: path.concat(['mapSaveData'])};
  }
  deleteMapSaveDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapSaveData', key])};
  }
  /**
   * @returns {CardUsageStats}
   */
  get cardUsageStats() {
    return this._hasCardUsageStats ? this._cardUsageStats : CardUsageStats.default;
  }
  get hasCardUsageStats() {
    return this._hasCardUsageStats;
  }
  setCardUsageStats(path, value) {
    return {type: 'SET', path: path.concat(['cardUsageStats']), value: value.toJson()};
  }
  deleteCardUsageStats(path) {
    return {type: 'DELETE', path: path.concat(['cardUsageStats'])};
  }
  /**
   * @returns {PromotionBundleStatus[]}
   */
  get promotionBundleStatus() {
    return this._promotionBundleStatus;
  }
  addPromotionBundleStatus(path, value) {
    return {type: 'ADD', path: path.concat(['promotionBundleStatus']), value: value.toJson()};
  }
  setPromotionBundleStatus(path, value) {
    return {type: 'SET', path: path.concat(['promotionBundleStatus']), value: ArrayToJson(value, PromotionBundleStatus)};
  }
  setPromotionBundleStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotionBundleStatus', key]), value: value.toJson()};
  }
  deletePromotionBundleStatus(path) {
    return {type: 'DELETE', path: path.concat(['promotionBundleStatus'])};
  }
  deletePromotionBundleStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotionBundleStatus', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasPlayerInfo = true;
              copy._playerInfo = PlayerInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerInfo) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasPlayerInfo = false;
              copy._playerInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerInfo) {
            const copy = new SaveFile(this);
            copy._hasPlayerInfo = true;
            copy._playerInfo = PlayerInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerInfo.apply(type, path.slice(1), value);
          if (newValue === this._playerInfo) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._playerInfo = copy._playerInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "playerProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasPlayerProgression = true;
              copy._playerProgression = dcei_wildsky_card_proto.PlayerProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerProgression) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasPlayerProgression = false;
              copy._playerProgression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerProgression) {
            const copy = new SaveFile(this);
            copy._hasPlayerProgression = true;
            copy._playerProgression = dcei_wildsky_card_proto.PlayerProgression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerProgression.apply(type, path.slice(1), value);
          if (newValue === this._playerProgression) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._playerProgression = copy._playerProgression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "playerEnergy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasPlayerEnergy = true;
              copy._playerEnergy = EnergyData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerEnergy) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasPlayerEnergy = false;
              copy._playerEnergy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerEnergy) {
            const copy = new SaveFile(this);
            copy._hasPlayerEnergy = true;
            copy._playerEnergy = EnergyData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerEnergy.apply(type, path.slice(1), value);
          if (newValue === this._playerEnergy) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._playerEnergy = copy._playerEnergy.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "likedCommentIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._likedCommentIds = [];        for (let i of value) {
                copy._likedCommentIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._likedCommentIds = copy._likedCommentIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._likedCommentIds.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._likedCommentIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._likedCommentIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._likedCommentIds = copy._likedCommentIds.slice();
              copy._likedCommentIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._likedCommentIds = copy._likedCommentIds.slice(0, path[1]).concat(copy._likedCommentIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._likedCommentIds.length) {
            return this;
          }
          const oldValue = this._likedCommentIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._likedCommentIds = copy._likedCommentIds.slice();
          copy._likedCommentIds[key] = newValue;
          return copy;
        }
      }
      case "mapProgresses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._mapProgresses = [];        for (let i of value) {
                copy._mapProgresses.push(MapProgress.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._mapProgresses = copy._mapProgresses.concat([MapProgress.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapProgresses.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._mapProgresses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapProgresses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._mapProgresses = copy._mapProgresses.slice();
              copy._mapProgresses[path[1]] = MapProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._mapProgresses = copy._mapProgresses.slice(0, path[1]).concat(copy._mapProgresses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapProgresses.length) {
            return this;
          }
          const oldValue = this._mapProgresses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._mapProgresses = copy._mapProgresses.slice();
          copy._mapProgresses[key] = newValue;
          return copy;
        }
      }
      case "savedMapComments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._savedMapComments = [];        for (let i of value) {
                copy._savedMapComments.push(SavedMapComment.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._savedMapComments = copy._savedMapComments.concat([SavedMapComment.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._savedMapComments.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._savedMapComments = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._savedMapComments.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._savedMapComments = copy._savedMapComments.slice();
              copy._savedMapComments[path[1]] = SavedMapComment.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._savedMapComments = copy._savedMapComments.slice(0, path[1]).concat(copy._savedMapComments.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._savedMapComments.length) {
            return this;
          }
          const oldValue = this._savedMapComments[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._savedMapComments = copy._savedMapComments.slice();
          copy._savedMapComments[key] = newValue;
          return copy;
        }
      }
      case "consumableItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._consumableItems = [];        for (let i of value) {
                copy._consumableItems.push(ConsumableItemSave.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._consumableItems = copy._consumableItems.concat([ConsumableItemSave.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._consumableItems.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._consumableItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._consumableItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._consumableItems = copy._consumableItems.slice();
              copy._consumableItems[path[1]] = ConsumableItemSave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._consumableItems = copy._consumableItems.slice(0, path[1]).concat(copy._consumableItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._consumableItems.length) {
            return this;
          }
          const oldValue = this._consumableItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._consumableItems = copy._consumableItems.slice();
          copy._consumableItems[key] = newValue;
          return copy;
        }
      }
      case "shipUpgradeProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasShipUpgradeProgression = true;
              copy._shipUpgradeProgression = dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShipUpgradeProgression) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasShipUpgradeProgression = false;
              copy._shipUpgradeProgression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasShipUpgradeProgression) {
            const copy = new SaveFile(this);
            copy._hasShipUpgradeProgression = true;
            copy._shipUpgradeProgression = dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._shipUpgradeProgression.apply(type, path.slice(1), value);
          if (newValue === this._shipUpgradeProgression) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._shipUpgradeProgression = copy._shipUpgradeProgression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "campaignProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasCampaignProgress = true;
              copy._campaignProgress = CampaignProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCampaignProgress) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasCampaignProgress = false;
              copy._campaignProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCampaignProgress) {
            const copy = new SaveFile(this);
            copy._hasCampaignProgress = true;
            copy._campaignProgress = CampaignProgress.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._campaignProgress.apply(type, path.slice(1), value);
          if (newValue === this._campaignProgress) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._campaignProgress = copy._campaignProgress.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "achievementProgresses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._achievementProgresses = [];        for (let i of value) {
                copy._achievementProgresses.push(AchievementProgress.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._achievementProgresses = copy._achievementProgresses.concat([AchievementProgress.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._achievementProgresses.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._achievementProgresses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._achievementProgresses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._achievementProgresses = copy._achievementProgresses.slice();
              copy._achievementProgresses[path[1]] = AchievementProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._achievementProgresses = copy._achievementProgresses.slice(0, path[1]).concat(copy._achievementProgresses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._achievementProgresses.length) {
            return this;
          }
          const oldValue = this._achievementProgresses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._achievementProgresses = copy._achievementProgresses.slice();
          copy._achievementProgresses[key] = newValue;
          return copy;
        }
      }
      case "playerLoadouts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._playerLoadouts = [];        for (let i of value) {
                copy._playerLoadouts.push(dcei_wildsky_card_proto.PlayerLoadout.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._playerLoadouts = copy._playerLoadouts.concat([dcei_wildsky_card_proto.PlayerLoadout.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._playerLoadouts.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._playerLoadouts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._playerLoadouts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._playerLoadouts = copy._playerLoadouts.slice();
              copy._playerLoadouts[path[1]] = dcei_wildsky_card_proto.PlayerLoadout.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._playerLoadouts = copy._playerLoadouts.slice(0, path[1]).concat(copy._playerLoadouts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._playerLoadouts.length) {
            return this;
          }
          const oldValue = this._playerLoadouts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._playerLoadouts = copy._playerLoadouts.slice();
          copy._playerLoadouts[key] = newValue;
          return copy;
        }
      }
      case "playerInventory": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasPlayerInventory = true;
              copy._playerInventory = UserInventory.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerInventory) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasPlayerInventory = false;
              copy._playerInventory = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerInventory) {
            const copy = new SaveFile(this);
            copy._hasPlayerInventory = true;
            copy._playerInventory = UserInventory.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerInventory.apply(type, path.slice(1), value);
          if (newValue === this._playerInventory) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._playerInventory = copy._playerInventory.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "genericDataProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasGenericDataProgress = true;
              copy._genericDataProgress = GenericDataProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGenericDataProgress) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasGenericDataProgress = false;
              copy._genericDataProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasGenericDataProgress) {
            const copy = new SaveFile(this);
            copy._hasGenericDataProgress = true;
            copy._genericDataProgress = GenericDataProgress.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._genericDataProgress.apply(type, path.slice(1), value);
          if (newValue === this._genericDataProgress) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._genericDataProgress = copy._genericDataProgress.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "mapSaveData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._mapSaveData = [];        for (let i of value) {
                copy._mapSaveData.push(SaveFile_SaveData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._mapSaveData = copy._mapSaveData.concat([SaveFile_SaveData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapSaveData.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._mapSaveData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapSaveData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._mapSaveData = copy._mapSaveData.slice();
              copy._mapSaveData[path[1]] = SaveFile_SaveData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._mapSaveData = copy._mapSaveData.slice(0, path[1]).concat(copy._mapSaveData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapSaveData.length) {
            return this;
          }
          const oldValue = this._mapSaveData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._mapSaveData = copy._mapSaveData.slice();
          copy._mapSaveData[key] = newValue;
          return copy;
        }
      }
      case "cardUsageStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._hasCardUsageStats = true;
              copy._cardUsageStats = CardUsageStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardUsageStats) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._hasCardUsageStats = false;
              copy._cardUsageStats = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCardUsageStats) {
            const copy = new SaveFile(this);
            copy._hasCardUsageStats = true;
            copy._cardUsageStats = CardUsageStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cardUsageStats.apply(type, path.slice(1), value);
          if (newValue === this._cardUsageStats) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._cardUsageStats = copy._cardUsageStats.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "promotionBundleStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._promotionBundleStatus = [];        for (let i of value) {
                copy._promotionBundleStatus.push(PromotionBundleStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SaveFile(this);
              copy._promotionBundleStatus = copy._promotionBundleStatus.concat([PromotionBundleStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotionBundleStatus.length === 0) {
                return this;
              }
              const copy = new SaveFile(this);
              copy._promotionBundleStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotionBundleStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SaveFile(this);
              copy._promotionBundleStatus = copy._promotionBundleStatus.slice();
              copy._promotionBundleStatus[path[1]] = PromotionBundleStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SaveFile(this);
              copy._promotionBundleStatus = copy._promotionBundleStatus.slice(0, path[1]).concat(copy._promotionBundleStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotionBundleStatus.length) {
            return this;
          }
          const oldValue = this._promotionBundleStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SaveFile(this);
          copy._promotionBundleStatus = copy._promotionBundleStatus.slice();
          copy._promotionBundleStatus[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SaveFile} other
   * @returns {SaveFile}
   */
  merge(other) {
    const copy = new SaveFile(this);
    if (other._hasPlayerInfo) {
      if (copy._hasPlayerInfo) {
        copy._playerInfo = copy.playerInfo.merge(other.playerInfo);
      } else {
        copy._playerInfo = other._playerInfo;
      }
      copy._hasPlayerInfo = true;
    }
    if (other._hasPlayerProgression) {
      if (copy._hasPlayerProgression) {
        copy._playerProgression = copy.playerProgression.merge(other.playerProgression);
      } else {
        copy._playerProgression = other._playerProgression;
      }
      copy._hasPlayerProgression = true;
    }
    if (other._hasPlayerEnergy) {
      if (copy._hasPlayerEnergy) {
        copy._playerEnergy = copy.playerEnergy.merge(other.playerEnergy);
      } else {
        copy._playerEnergy = other._playerEnergy;
      }
      copy._hasPlayerEnergy = true;
    }
    copy._likedCommentIds = this._likedCommentIds.concat(other._likedCommentIds);
    copy._mapProgresses = this._mapProgresses.concat(other._mapProgresses);
    copy._savedMapComments = this._savedMapComments.concat(other._savedMapComments);
    copy._consumableItems = this._consumableItems.concat(other._consumableItems);
    if (other._hasShipUpgradeProgression) {
      if (copy._hasShipUpgradeProgression) {
        copy._shipUpgradeProgression = copy.shipUpgradeProgression.merge(other.shipUpgradeProgression);
      } else {
        copy._shipUpgradeProgression = other._shipUpgradeProgression;
      }
      copy._hasShipUpgradeProgression = true;
    }
    if (other._hasCampaignProgress) {
      if (copy._hasCampaignProgress) {
        copy._campaignProgress = copy.campaignProgress.merge(other.campaignProgress);
      } else {
        copy._campaignProgress = other._campaignProgress;
      }
      copy._hasCampaignProgress = true;
    }
    copy._achievementProgresses = this._achievementProgresses.concat(other._achievementProgresses);
    copy._playerLoadouts = this._playerLoadouts.concat(other._playerLoadouts);
    if (other._hasPlayerInventory) {
      if (copy._hasPlayerInventory) {
        copy._playerInventory = copy.playerInventory.merge(other.playerInventory);
      } else {
        copy._playerInventory = other._playerInventory;
      }
      copy._hasPlayerInventory = true;
    }
    if (other._hasGenericDataProgress) {
      if (copy._hasGenericDataProgress) {
        copy._genericDataProgress = copy.genericDataProgress.merge(other.genericDataProgress);
      } else {
        copy._genericDataProgress = other._genericDataProgress;
      }
      copy._hasGenericDataProgress = true;
    }
    copy._mapSaveData = this._mapSaveData.concat(other._mapSaveData);
    if (other._hasCardUsageStats) {
      if (copy._hasCardUsageStats) {
        copy._cardUsageStats = copy.cardUsageStats.merge(other.cardUsageStats);
      } else {
        copy._cardUsageStats = other._cardUsageStats;
      }
      copy._hasCardUsageStats = true;
    }
    copy._promotionBundleStatus = this._promotionBundleStatus.concat(other._promotionBundleStatus);
    return copy;
  }
}
SaveFile.default = new SaveFile();
SaveFile.SaveData = SaveFile_SaveData;
class SaveFile_Builder {
  constructor(value) {
    this._value = new SaveFile(value);
  }
  build() {
    return new SaveFile(this._value);
  }
  setPlayerInfo(value) {
    this._value._hasPlayerInfo = true;
    this._value._playerInfo = value;
    return this;
  }
  deletePlayerInfo() {
    this._value._hasPlayerInfo = false;
    this._value._playerInfo = null;
    return this;
  }
  setPlayerProgression(value) {
    this._value._hasPlayerProgression = true;
    this._value._playerProgression = value;
    return this;
  }
  deletePlayerProgression() {
    this._value._hasPlayerProgression = false;
    this._value._playerProgression = null;
    return this;
  }
  setPlayerEnergy(value) {
    this._value._hasPlayerEnergy = true;
    this._value._playerEnergy = value;
    return this;
  }
  deletePlayerEnergy() {
    this._value._hasPlayerEnergy = false;
    this._value._playerEnergy = null;
    return this;
  }
  addAllLikedCommentIds(values) {
    this._value._likedCommentIds = this._value._likedCommentIds.concat(values);
    return this;
  }
  addLikedCommentIds(value) {
    this._value._likedCommentIds = this._value._likedCommentIds.concat([value]);
    return this;
  }
  setLikedCommentIds(index, value) {
    this._value._likedCommentIds = this._value._likedCommentIds.concat();
    this._value._likedCommentIds[index] = value;
    return this;
  }
  clearLikedCommentIds() {
    this._value._likedCommentIds = [];
    return this;
  }
  addAllMapProgresses(values) {
    this._value._mapProgresses = this._value._mapProgresses.concat(values);
    return this;
  }
  addMapProgresses(value) {
    this._value._mapProgresses = this._value._mapProgresses.concat([value]);
    return this;
  }
  setMapProgresses(index, value) {
    this._value._mapProgresses = this._value._mapProgresses.concat();
    this._value._mapProgresses[index] = value;
    return this;
  }
  clearMapProgresses() {
    this._value._mapProgresses = [];
    return this;
  }
  addAllSavedMapComments(values) {
    this._value._savedMapComments = this._value._savedMapComments.concat(values);
    return this;
  }
  addSavedMapComments(value) {
    this._value._savedMapComments = this._value._savedMapComments.concat([value]);
    return this;
  }
  setSavedMapComments(index, value) {
    this._value._savedMapComments = this._value._savedMapComments.concat();
    this._value._savedMapComments[index] = value;
    return this;
  }
  clearSavedMapComments() {
    this._value._savedMapComments = [];
    return this;
  }
  addAllConsumableItems(values) {
    this._value._consumableItems = this._value._consumableItems.concat(values);
    return this;
  }
  addConsumableItems(value) {
    this._value._consumableItems = this._value._consumableItems.concat([value]);
    return this;
  }
  setConsumableItems(index, value) {
    this._value._consumableItems = this._value._consumableItems.concat();
    this._value._consumableItems[index] = value;
    return this;
  }
  clearConsumableItems() {
    this._value._consumableItems = [];
    return this;
  }
  setShipUpgradeProgression(value) {
    this._value._hasShipUpgradeProgression = true;
    this._value._shipUpgradeProgression = value;
    return this;
  }
  deleteShipUpgradeProgression() {
    this._value._hasShipUpgradeProgression = false;
    this._value._shipUpgradeProgression = null;
    return this;
  }
  setCampaignProgress(value) {
    this._value._hasCampaignProgress = true;
    this._value._campaignProgress = value;
    return this;
  }
  deleteCampaignProgress() {
    this._value._hasCampaignProgress = false;
    this._value._campaignProgress = null;
    return this;
  }
  addAllAchievementProgresses(values) {
    this._value._achievementProgresses = this._value._achievementProgresses.concat(values);
    return this;
  }
  addAchievementProgresses(value) {
    this._value._achievementProgresses = this._value._achievementProgresses.concat([value]);
    return this;
  }
  setAchievementProgresses(index, value) {
    this._value._achievementProgresses = this._value._achievementProgresses.concat();
    this._value._achievementProgresses[index] = value;
    return this;
  }
  clearAchievementProgresses() {
    this._value._achievementProgresses = [];
    return this;
  }
  addAllPlayerLoadouts(values) {
    this._value._playerLoadouts = this._value._playerLoadouts.concat(values);
    return this;
  }
  addPlayerLoadouts(value) {
    this._value._playerLoadouts = this._value._playerLoadouts.concat([value]);
    return this;
  }
  setPlayerLoadouts(index, value) {
    this._value._playerLoadouts = this._value._playerLoadouts.concat();
    this._value._playerLoadouts[index] = value;
    return this;
  }
  clearPlayerLoadouts() {
    this._value._playerLoadouts = [];
    return this;
  }
  setPlayerInventory(value) {
    this._value._hasPlayerInventory = true;
    this._value._playerInventory = value;
    return this;
  }
  deletePlayerInventory() {
    this._value._hasPlayerInventory = false;
    this._value._playerInventory = null;
    return this;
  }
  setGenericDataProgress(value) {
    this._value._hasGenericDataProgress = true;
    this._value._genericDataProgress = value;
    return this;
  }
  deleteGenericDataProgress() {
    this._value._hasGenericDataProgress = false;
    this._value._genericDataProgress = null;
    return this;
  }
  addAllMapSaveData(values) {
    this._value._mapSaveData = this._value._mapSaveData.concat(values);
    return this;
  }
  addMapSaveData(value) {
    this._value._mapSaveData = this._value._mapSaveData.concat([value]);
    return this;
  }
  setMapSaveData(index, value) {
    this._value._mapSaveData = this._value._mapSaveData.concat();
    this._value._mapSaveData[index] = value;
    return this;
  }
  clearMapSaveData() {
    this._value._mapSaveData = [];
    return this;
  }
  setCardUsageStats(value) {
    this._value._hasCardUsageStats = true;
    this._value._cardUsageStats = value;
    return this;
  }
  deleteCardUsageStats() {
    this._value._hasCardUsageStats = false;
    this._value._cardUsageStats = null;
    return this;
  }
  addAllPromotionBundleStatus(values) {
    this._value._promotionBundleStatus = this._value._promotionBundleStatus.concat(values);
    return this;
  }
  addPromotionBundleStatus(value) {
    this._value._promotionBundleStatus = this._value._promotionBundleStatus.concat([value]);
    return this;
  }
  setPromotionBundleStatus(index, value) {
    this._value._promotionBundleStatus = this._value._promotionBundleStatus.concat();
    this._value._promotionBundleStatus[index] = value;
    return this;
  }
  clearPromotionBundleStatus() {
    this._value._promotionBundleStatus = [];
    return this;
  }
}
SaveFile.Builder = SaveFile_Builder;
class SaveFile_WithParent {
  /**
   * @param {SaveFile} value
   * @param {SaveFile_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SaveFile.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerInfo() {
    if (this._cachedHasPlayerInfo === undefined) {
      if (this._value.hasPlayerInfo) {
        this._cachedHasPlayerInfo = true;
      } else {
        this._cachedHasPlayerInfo = this._parent ? this._parent.hasPlayerInfo : false;
      }
    }
    return this._cachedHasPlayerInfo;
  }
  get playerInfo() {
    if (!this._cachedPlayerInfo) {
      if (this._value.hasPlayerInfo) {
        this._cachedPlayerInfo = new PlayerInfo.WithParent(this._value.playerInfo, this._parent && this._parent.hasPlayerInfo ? this._parent.playerInfo : null);
      } else {
        this._cachedPlayerInfo = this._parent ? new PlayerInfo.WithParent(PlayerInfo.default, this._parent.playerInfo) : PlayerInfo.WithParent.default;
      }
    }
    return this._cachedPlayerInfo;
  }
  get hasPlayerProgression() {
    if (this._cachedHasPlayerProgression === undefined) {
      if (this._value.hasPlayerProgression) {
        this._cachedHasPlayerProgression = true;
      } else {
        this._cachedHasPlayerProgression = this._parent ? this._parent.hasPlayerProgression : false;
      }
    }
    return this._cachedHasPlayerProgression;
  }
  get playerProgression() {
    if (!this._cachedPlayerProgression) {
      if (this._value.hasPlayerProgression) {
        this._cachedPlayerProgression = new dcei_wildsky_card_proto.PlayerProgression.WithParent(this._value.playerProgression, this._parent && this._parent.hasPlayerProgression ? this._parent.playerProgression : null);
      } else {
        this._cachedPlayerProgression = this._parent ? new dcei_wildsky_card_proto.PlayerProgression.WithParent(dcei_wildsky_card_proto.PlayerProgression.default, this._parent.playerProgression) : dcei_wildsky_card_proto.PlayerProgression.WithParent.default;
      }
    }
    return this._cachedPlayerProgression;
  }
  get hasPlayerEnergy() {
    if (this._cachedHasPlayerEnergy === undefined) {
      if (this._value.hasPlayerEnergy) {
        this._cachedHasPlayerEnergy = true;
      } else {
        this._cachedHasPlayerEnergy = this._parent ? this._parent.hasPlayerEnergy : false;
      }
    }
    return this._cachedHasPlayerEnergy;
  }
  get playerEnergy() {
    if (!this._cachedPlayerEnergy) {
      if (this._value.hasPlayerEnergy) {
        this._cachedPlayerEnergy = new EnergyData.WithParent(this._value.playerEnergy, this._parent && this._parent.hasPlayerEnergy ? this._parent.playerEnergy : null);
      } else {
        this._cachedPlayerEnergy = this._parent ? new EnergyData.WithParent(EnergyData.default, this._parent.playerEnergy) : EnergyData.WithParent.default;
      }
    }
    return this._cachedPlayerEnergy;
  }
  get selfLikedCommentIds() {
    return this._value.likedCommentIds;
  }
  get inherentLikedCommentIds() {
    if (!this._inherentLikedCommentIds) {
      this._inherentLikedCommentIds = this._parent ? this._parent.likedCommentIds : [];
    }
    return this._inherentLikedCommentIds;
  }
  get likedCommentIds() {
    if (!this._allLikedCommentIds) {
      this._allLikedCommentIds = this._parent ? this._parent.likedCommentIds.concat(this.selfLikedCommentIds) : this.selfLikedCommentIds;
    }
    return this._allLikedCommentIds;
  }
  get selfMapProgresses() {
    if (!this._selfMapProgresses) {
      this._selfMapProgresses = [];
      for (let i of this._value.mapProgresses) {
        this._selfMapProgresses.push(new MapProgress.WithParent(i, null));
      }
    }
    return this._selfMapProgresses;
  }
  get inherentMapProgresses() {
    if (!this._inherentMapProgresses) {
      this._inherentMapProgresses = this._parent ? this._parent.mapProgresses : [];
    }
    return this._inherentMapProgresses;
  }
  get mapProgresses() {
    if (!this._allMapProgresses) {
      this._allMapProgresses = this._parent ? this._parent.mapProgresses.concat(this.selfMapProgresses) : this.selfMapProgresses;
    }
    return this._allMapProgresses;
  }
  get selfSavedMapComments() {
    if (!this._selfSavedMapComments) {
      this._selfSavedMapComments = [];
      for (let i of this._value.savedMapComments) {
        this._selfSavedMapComments.push(new SavedMapComment.WithParent(i, null));
      }
    }
    return this._selfSavedMapComments;
  }
  get inherentSavedMapComments() {
    if (!this._inherentSavedMapComments) {
      this._inherentSavedMapComments = this._parent ? this._parent.savedMapComments : [];
    }
    return this._inherentSavedMapComments;
  }
  get savedMapComments() {
    if (!this._allSavedMapComments) {
      this._allSavedMapComments = this._parent ? this._parent.savedMapComments.concat(this.selfSavedMapComments) : this.selfSavedMapComments;
    }
    return this._allSavedMapComments;
  }
  get selfConsumableItems() {
    if (!this._selfConsumableItems) {
      this._selfConsumableItems = [];
      for (let i of this._value.consumableItems) {
        this._selfConsumableItems.push(new ConsumableItemSave.WithParent(i, null));
      }
    }
    return this._selfConsumableItems;
  }
  get inherentConsumableItems() {
    if (!this._inherentConsumableItems) {
      this._inherentConsumableItems = this._parent ? this._parent.consumableItems : [];
    }
    return this._inherentConsumableItems;
  }
  get consumableItems() {
    if (!this._allConsumableItems) {
      this._allConsumableItems = this._parent ? this._parent.consumableItems.concat(this.selfConsumableItems) : this.selfConsumableItems;
    }
    return this._allConsumableItems;
  }
  get hasShipUpgradeProgression() {
    if (this._cachedHasShipUpgradeProgression === undefined) {
      if (this._value.hasShipUpgradeProgression) {
        this._cachedHasShipUpgradeProgression = true;
      } else {
        this._cachedHasShipUpgradeProgression = this._parent ? this._parent.hasShipUpgradeProgression : false;
      }
    }
    return this._cachedHasShipUpgradeProgression;
  }
  get shipUpgradeProgression() {
    if (!this._cachedShipUpgradeProgression) {
      if (this._value.hasShipUpgradeProgression) {
        this._cachedShipUpgradeProgression = new dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.WithParent(this._value.shipUpgradeProgression, this._parent && this._parent.hasShipUpgradeProgression ? this._parent.shipUpgradeProgression : null);
      } else {
        this._cachedShipUpgradeProgression = this._parent ? new dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.WithParent(dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.default, this._parent.shipUpgradeProgression) : dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression.WithParent.default;
      }
    }
    return this._cachedShipUpgradeProgression;
  }
  get hasCampaignProgress() {
    if (this._cachedHasCampaignProgress === undefined) {
      if (this._value.hasCampaignProgress) {
        this._cachedHasCampaignProgress = true;
      } else {
        this._cachedHasCampaignProgress = this._parent ? this._parent.hasCampaignProgress : false;
      }
    }
    return this._cachedHasCampaignProgress;
  }
  get campaignProgress() {
    if (!this._cachedCampaignProgress) {
      if (this._value.hasCampaignProgress) {
        this._cachedCampaignProgress = new CampaignProgress.WithParent(this._value.campaignProgress, this._parent && this._parent.hasCampaignProgress ? this._parent.campaignProgress : null);
      } else {
        this._cachedCampaignProgress = this._parent ? new CampaignProgress.WithParent(CampaignProgress.default, this._parent.campaignProgress) : CampaignProgress.WithParent.default;
      }
    }
    return this._cachedCampaignProgress;
  }
  get selfAchievementProgresses() {
    if (!this._selfAchievementProgresses) {
      this._selfAchievementProgresses = [];
      for (let i of this._value.achievementProgresses) {
        this._selfAchievementProgresses.push(new AchievementProgress.WithParent(i, null));
      }
    }
    return this._selfAchievementProgresses;
  }
  get inherentAchievementProgresses() {
    if (!this._inherentAchievementProgresses) {
      this._inherentAchievementProgresses = this._parent ? this._parent.achievementProgresses : [];
    }
    return this._inherentAchievementProgresses;
  }
  get achievementProgresses() {
    if (!this._allAchievementProgresses) {
      this._allAchievementProgresses = this._parent ? this._parent.achievementProgresses.concat(this.selfAchievementProgresses) : this.selfAchievementProgresses;
    }
    return this._allAchievementProgresses;
  }
  get selfPlayerLoadouts() {
    if (!this._selfPlayerLoadouts) {
      this._selfPlayerLoadouts = [];
      for (let i of this._value.playerLoadouts) {
        this._selfPlayerLoadouts.push(new dcei_wildsky_card_proto.PlayerLoadout.WithParent(i, null));
      }
    }
    return this._selfPlayerLoadouts;
  }
  get inherentPlayerLoadouts() {
    if (!this._inherentPlayerLoadouts) {
      this._inherentPlayerLoadouts = this._parent ? this._parent.playerLoadouts : [];
    }
    return this._inherentPlayerLoadouts;
  }
  get playerLoadouts() {
    if (!this._allPlayerLoadouts) {
      this._allPlayerLoadouts = this._parent ? this._parent.playerLoadouts.concat(this.selfPlayerLoadouts) : this.selfPlayerLoadouts;
    }
    return this._allPlayerLoadouts;
  }
  get hasPlayerInventory() {
    if (this._cachedHasPlayerInventory === undefined) {
      if (this._value.hasPlayerInventory) {
        this._cachedHasPlayerInventory = true;
      } else {
        this._cachedHasPlayerInventory = this._parent ? this._parent.hasPlayerInventory : false;
      }
    }
    return this._cachedHasPlayerInventory;
  }
  get playerInventory() {
    if (!this._cachedPlayerInventory) {
      if (this._value.hasPlayerInventory) {
        this._cachedPlayerInventory = new UserInventory.WithParent(this._value.playerInventory, this._parent && this._parent.hasPlayerInventory ? this._parent.playerInventory : null);
      } else {
        this._cachedPlayerInventory = this._parent ? new UserInventory.WithParent(UserInventory.default, this._parent.playerInventory) : UserInventory.WithParent.default;
      }
    }
    return this._cachedPlayerInventory;
  }
  get hasGenericDataProgress() {
    if (this._cachedHasGenericDataProgress === undefined) {
      if (this._value.hasGenericDataProgress) {
        this._cachedHasGenericDataProgress = true;
      } else {
        this._cachedHasGenericDataProgress = this._parent ? this._parent.hasGenericDataProgress : false;
      }
    }
    return this._cachedHasGenericDataProgress;
  }
  get genericDataProgress() {
    if (!this._cachedGenericDataProgress) {
      if (this._value.hasGenericDataProgress) {
        this._cachedGenericDataProgress = new GenericDataProgress.WithParent(this._value.genericDataProgress, this._parent && this._parent.hasGenericDataProgress ? this._parent.genericDataProgress : null);
      } else {
        this._cachedGenericDataProgress = this._parent ? new GenericDataProgress.WithParent(GenericDataProgress.default, this._parent.genericDataProgress) : GenericDataProgress.WithParent.default;
      }
    }
    return this._cachedGenericDataProgress;
  }
  get selfMapSaveData() {
    if (!this._selfMapSaveData) {
      this._selfMapSaveData = [];
      for (let i of this._value.mapSaveData) {
        this._selfMapSaveData.push(new SaveFile_SaveData.WithParent(i, null));
      }
    }
    return this._selfMapSaveData;
  }
  get inherentMapSaveData() {
    if (!this._inherentMapSaveData) {
      this._inherentMapSaveData = this._parent ? this._parent.mapSaveData : [];
    }
    return this._inherentMapSaveData;
  }
  get mapSaveData() {
    if (!this._allMapSaveData) {
      this._allMapSaveData = this._parent ? this._parent.mapSaveData.concat(this.selfMapSaveData) : this.selfMapSaveData;
    }
    return this._allMapSaveData;
  }
  get hasCardUsageStats() {
    if (this._cachedHasCardUsageStats === undefined) {
      if (this._value.hasCardUsageStats) {
        this._cachedHasCardUsageStats = true;
      } else {
        this._cachedHasCardUsageStats = this._parent ? this._parent.hasCardUsageStats : false;
      }
    }
    return this._cachedHasCardUsageStats;
  }
  get cardUsageStats() {
    if (!this._cachedCardUsageStats) {
      if (this._value.hasCardUsageStats) {
        this._cachedCardUsageStats = new CardUsageStats.WithParent(this._value.cardUsageStats, this._parent && this._parent.hasCardUsageStats ? this._parent.cardUsageStats : null);
      } else {
        this._cachedCardUsageStats = this._parent ? new CardUsageStats.WithParent(CardUsageStats.default, this._parent.cardUsageStats) : CardUsageStats.WithParent.default;
      }
    }
    return this._cachedCardUsageStats;
  }
  get selfPromotionBundleStatus() {
    if (!this._selfPromotionBundleStatus) {
      this._selfPromotionBundleStatus = [];
      for (let i of this._value.promotionBundleStatus) {
        this._selfPromotionBundleStatus.push(new PromotionBundleStatus.WithParent(i, null));
      }
    }
    return this._selfPromotionBundleStatus;
  }
  get inherentPromotionBundleStatus() {
    if (!this._inherentPromotionBundleStatus) {
      this._inherentPromotionBundleStatus = this._parent ? this._parent.promotionBundleStatus : [];
    }
    return this._inherentPromotionBundleStatus;
  }
  get promotionBundleStatus() {
    if (!this._allPromotionBundleStatus) {
      this._allPromotionBundleStatus = this._parent ? this._parent.promotionBundleStatus.concat(this.selfPromotionBundleStatus) : this.selfPromotionBundleStatus;
    }
    return this._allPromotionBundleStatus;
  }
  update(current, parent) {
    const result = new SaveFile_WithParent(current, parent);
    if (this._cachedPlayerInfo && this._value.hasPlayerInfo && current.hasPlayerInfo) {
      if (this._value.playerInfo === current.playerInfo && this._parent === parent) {
        result._cachedPlayerInfo = this._cachedPlayerInfo;
      } else {
        result._cachedPlayerInfo = this._cachedPlayerInfo.update(current.playerInfo, parent && parent.hasPlayerInfo ? parent.playerInfo : null);
      }
    }
    if (this._cachedPlayerProgression && this._value.hasPlayerProgression && current.hasPlayerProgression) {
      if (this._value.playerProgression === current.playerProgression && this._parent === parent) {
        result._cachedPlayerProgression = this._cachedPlayerProgression;
      } else {
        result._cachedPlayerProgression = this._cachedPlayerProgression.update(current.playerProgression, parent && parent.hasPlayerProgression ? parent.playerProgression : null);
      }
    }
    if (this._cachedPlayerEnergy && this._value.hasPlayerEnergy && current.hasPlayerEnergy) {
      if (this._value.playerEnergy === current.playerEnergy && this._parent === parent) {
        result._cachedPlayerEnergy = this._cachedPlayerEnergy;
      } else {
        result._cachedPlayerEnergy = this._cachedPlayerEnergy.update(current.playerEnergy, parent && parent.hasPlayerEnergy ? parent.playerEnergy : null);
      }
    }
    if (this._selfMapProgresses) {
      if (this._value.mapProgresses === current.mapProgresses) {
        result._selfMapProgresses = this._selfMapProgresses;
      } else {
        result._selfMapProgresses = [];
        for (let i = 0; i < current.mapProgresses.length; i++) {
          const oldValue = this._value.mapProgresses[i];
          if (oldValue) {
            const oldCache = this._selfMapProgresses[i];
            if (oldValue === current.mapProgresses[i]) {
              result._selfMapProgresses[i] = oldCache;
            } else {
              result._selfMapProgresses[i] = oldCache.update(current.mapProgresses[i], null);
            }
          } else {
            result._selfMapProgresses[i] = new MapProgress.WithParent(current.mapProgresses[i], null);
          }
        }
      }
    }
    if (this._selfSavedMapComments) {
      if (this._value.savedMapComments === current.savedMapComments) {
        result._selfSavedMapComments = this._selfSavedMapComments;
      } else {
        result._selfSavedMapComments = [];
        for (let i = 0; i < current.savedMapComments.length; i++) {
          const oldValue = this._value.savedMapComments[i];
          if (oldValue) {
            const oldCache = this._selfSavedMapComments[i];
            if (oldValue === current.savedMapComments[i]) {
              result._selfSavedMapComments[i] = oldCache;
            } else {
              result._selfSavedMapComments[i] = oldCache.update(current.savedMapComments[i], null);
            }
          } else {
            result._selfSavedMapComments[i] = new SavedMapComment.WithParent(current.savedMapComments[i], null);
          }
        }
      }
    }
    if (this._selfConsumableItems) {
      if (this._value.consumableItems === current.consumableItems) {
        result._selfConsumableItems = this._selfConsumableItems;
      } else {
        result._selfConsumableItems = [];
        for (let i = 0; i < current.consumableItems.length; i++) {
          const oldValue = this._value.consumableItems[i];
          if (oldValue) {
            const oldCache = this._selfConsumableItems[i];
            if (oldValue === current.consumableItems[i]) {
              result._selfConsumableItems[i] = oldCache;
            } else {
              result._selfConsumableItems[i] = oldCache.update(current.consumableItems[i], null);
            }
          } else {
            result._selfConsumableItems[i] = new ConsumableItemSave.WithParent(current.consumableItems[i], null);
          }
        }
      }
    }
    if (this._cachedShipUpgradeProgression && this._value.hasShipUpgradeProgression && current.hasShipUpgradeProgression) {
      if (this._value.shipUpgradeProgression === current.shipUpgradeProgression && this._parent === parent) {
        result._cachedShipUpgradeProgression = this._cachedShipUpgradeProgression;
      } else {
        result._cachedShipUpgradeProgression = this._cachedShipUpgradeProgression.update(current.shipUpgradeProgression, parent && parent.hasShipUpgradeProgression ? parent.shipUpgradeProgression : null);
      }
    }
    if (this._cachedCampaignProgress && this._value.hasCampaignProgress && current.hasCampaignProgress) {
      if (this._value.campaignProgress === current.campaignProgress && this._parent === parent) {
        result._cachedCampaignProgress = this._cachedCampaignProgress;
      } else {
        result._cachedCampaignProgress = this._cachedCampaignProgress.update(current.campaignProgress, parent && parent.hasCampaignProgress ? parent.campaignProgress : null);
      }
    }
    if (this._selfAchievementProgresses) {
      if (this._value.achievementProgresses === current.achievementProgresses) {
        result._selfAchievementProgresses = this._selfAchievementProgresses;
      } else {
        result._selfAchievementProgresses = [];
        for (let i = 0; i < current.achievementProgresses.length; i++) {
          const oldValue = this._value.achievementProgresses[i];
          if (oldValue) {
            const oldCache = this._selfAchievementProgresses[i];
            if (oldValue === current.achievementProgresses[i]) {
              result._selfAchievementProgresses[i] = oldCache;
            } else {
              result._selfAchievementProgresses[i] = oldCache.update(current.achievementProgresses[i], null);
            }
          } else {
            result._selfAchievementProgresses[i] = new AchievementProgress.WithParent(current.achievementProgresses[i], null);
          }
        }
      }
    }
    if (this._selfPlayerLoadouts) {
      if (this._value.playerLoadouts === current.playerLoadouts) {
        result._selfPlayerLoadouts = this._selfPlayerLoadouts;
      } else {
        result._selfPlayerLoadouts = [];
        for (let i = 0; i < current.playerLoadouts.length; i++) {
          const oldValue = this._value.playerLoadouts[i];
          if (oldValue) {
            const oldCache = this._selfPlayerLoadouts[i];
            if (oldValue === current.playerLoadouts[i]) {
              result._selfPlayerLoadouts[i] = oldCache;
            } else {
              result._selfPlayerLoadouts[i] = oldCache.update(current.playerLoadouts[i], null);
            }
          } else {
            result._selfPlayerLoadouts[i] = new dcei_wildsky_card_proto.PlayerLoadout.WithParent(current.playerLoadouts[i], null);
          }
        }
      }
    }
    if (this._cachedPlayerInventory && this._value.hasPlayerInventory && current.hasPlayerInventory) {
      if (this._value.playerInventory === current.playerInventory && this._parent === parent) {
        result._cachedPlayerInventory = this._cachedPlayerInventory;
      } else {
        result._cachedPlayerInventory = this._cachedPlayerInventory.update(current.playerInventory, parent && parent.hasPlayerInventory ? parent.playerInventory : null);
      }
    }
    if (this._cachedGenericDataProgress && this._value.hasGenericDataProgress && current.hasGenericDataProgress) {
      if (this._value.genericDataProgress === current.genericDataProgress && this._parent === parent) {
        result._cachedGenericDataProgress = this._cachedGenericDataProgress;
      } else {
        result._cachedGenericDataProgress = this._cachedGenericDataProgress.update(current.genericDataProgress, parent && parent.hasGenericDataProgress ? parent.genericDataProgress : null);
      }
    }
    if (this._selfMapSaveData) {
      if (this._value.mapSaveData === current.mapSaveData) {
        result._selfMapSaveData = this._selfMapSaveData;
      } else {
        result._selfMapSaveData = [];
        for (let i = 0; i < current.mapSaveData.length; i++) {
          const oldValue = this._value.mapSaveData[i];
          if (oldValue) {
            const oldCache = this._selfMapSaveData[i];
            if (oldValue === current.mapSaveData[i]) {
              result._selfMapSaveData[i] = oldCache;
            } else {
              result._selfMapSaveData[i] = oldCache.update(current.mapSaveData[i], null);
            }
          } else {
            result._selfMapSaveData[i] = new SaveFile_SaveData.WithParent(current.mapSaveData[i], null);
          }
        }
      }
    }
    if (this._cachedCardUsageStats && this._value.hasCardUsageStats && current.hasCardUsageStats) {
      if (this._value.cardUsageStats === current.cardUsageStats && this._parent === parent) {
        result._cachedCardUsageStats = this._cachedCardUsageStats;
      } else {
        result._cachedCardUsageStats = this._cachedCardUsageStats.update(current.cardUsageStats, parent && parent.hasCardUsageStats ? parent.cardUsageStats : null);
      }
    }
    if (this._selfPromotionBundleStatus) {
      if (this._value.promotionBundleStatus === current.promotionBundleStatus) {
        result._selfPromotionBundleStatus = this._selfPromotionBundleStatus;
      } else {
        result._selfPromotionBundleStatus = [];
        for (let i = 0; i < current.promotionBundleStatus.length; i++) {
          const oldValue = this._value.promotionBundleStatus[i];
          if (oldValue) {
            const oldCache = this._selfPromotionBundleStatus[i];
            if (oldValue === current.promotionBundleStatus[i]) {
              result._selfPromotionBundleStatus[i] = oldCache;
            } else {
              result._selfPromotionBundleStatus[i] = oldCache.update(current.promotionBundleStatus[i], null);
            }
          } else {
            result._selfPromotionBundleStatus[i] = new PromotionBundleStatus.WithParent(current.promotionBundleStatus[i], null);
          }
        }
      }
    }
    return result;
  }
}
SaveFile_WithParent.default = new SaveFile_WithParent(SaveFile.default, null);
SaveFile.WithParent = SaveFile_WithParent;
class SaveFile_Descriptor {
  get playerInfo() {
    if (!this._playerInfo) {
      this._playerInfo = {
        name: "playerInfo",
        Name: "PlayerInfo",
        number: 1,
        protoType: 11,
        protoName: "player_info",
        type: PlayerInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerInfo;
  }
  get playerProgression() {
    if (!this._playerProgression) {
      this._playerProgression = {
        name: "playerProgression",
        Name: "PlayerProgression",
        number: 2,
        protoType: 11,
        protoName: "player_progression",
        type: dcei_wildsky_card_proto.PlayerProgression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerProgression;
  }
  get playerEnergy() {
    if (!this._playerEnergy) {
      this._playerEnergy = {
        name: "playerEnergy",
        Name: "PlayerEnergy",
        number: 3,
        protoType: 11,
        protoName: "player_energy",
        type: EnergyData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerEnergy;
  }
  get likedCommentIds() {
    if (!this._likedCommentIds) {
      this._likedCommentIds = {
        name: "likedCommentIds",
        Name: "LikedCommentIds",
        number: 4,
        protoType: 9,
        protoName: "liked_comment_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._likedCommentIds;
  }
  get mapProgresses() {
    if (!this._mapProgresses) {
      this._mapProgresses = {
        name: "mapProgresses",
        Name: "MapProgresses",
        number: 5,
        protoType: 11,
        protoName: "map_progresses",
        type: MapProgress,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapProgresses;
  }
  get savedMapComments() {
    if (!this._savedMapComments) {
      this._savedMapComments = {
        name: "savedMapComments",
        Name: "SavedMapComments",
        number: 6,
        protoType: 11,
        protoName: "saved_map_comments",
        type: SavedMapComment,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._savedMapComments;
  }
  get consumableItems() {
    if (!this._consumableItems) {
      this._consumableItems = {
        name: "consumableItems",
        Name: "ConsumableItems",
        number: 7,
        protoType: 11,
        protoName: "consumable_items",
        type: ConsumableItemSave,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._consumableItems;
  }
  get shipUpgradeProgression() {
    if (!this._shipUpgradeProgression) {
      this._shipUpgradeProgression = {
        name: "shipUpgradeProgression",
        Name: "ShipUpgradeProgression",
        number: 8,
        protoType: 11,
        protoName: "ship_upgrade_progression",
        type: dcei_wildsky_ship_upgrade_proto.ShipUpgradeProgression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipUpgradeProgression;
  }
  get campaignProgress() {
    if (!this._campaignProgress) {
      this._campaignProgress = {
        name: "campaignProgress",
        Name: "CampaignProgress",
        number: 11,
        protoType: 11,
        protoName: "campaign_progress",
        type: CampaignProgress,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignProgress;
  }
  get achievementProgresses() {
    if (!this._achievementProgresses) {
      this._achievementProgresses = {
        name: "achievementProgresses",
        Name: "AchievementProgresses",
        number: 12,
        protoType: 11,
        protoName: "achievement_progresses",
        type: AchievementProgress,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._achievementProgresses;
  }
  get playerLoadouts() {
    if (!this._playerLoadouts) {
      this._playerLoadouts = {
        name: "playerLoadouts",
        Name: "PlayerLoadouts",
        number: 13,
        protoType: 11,
        protoName: "player_loadouts",
        type: dcei_wildsky_card_proto.PlayerLoadout,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLoadouts;
  }
  get playerInventory() {
    if (!this._playerInventory) {
      this._playerInventory = {
        name: "playerInventory",
        Name: "PlayerInventory",
        number: 14,
        protoType: 11,
        protoName: "player_inventory",
        type: UserInventory,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerInventory;
  }
  get genericDataProgress() {
    if (!this._genericDataProgress) {
      this._genericDataProgress = {
        name: "genericDataProgress",
        Name: "GenericDataProgress",
        number: 21,
        protoType: 11,
        protoName: "generic_data_progress",
        type: GenericDataProgress,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._genericDataProgress;
  }
  get mapSaveData() {
    if (!this._mapSaveData) {
      this._mapSaveData = {
        name: "mapSaveData",
        Name: "MapSaveData",
        number: 31,
        protoType: 11,
        protoName: "map_save_data",
        type: SaveFile_SaveData,
        isRepeated: true,
        options: {
          comments: "Per-map save data that\'s accessible by the map through trigger APIs.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapSaveData;
  }
  get cardUsageStats() {
    if (!this._cardUsageStats) {
      this._cardUsageStats = {
        name: "cardUsageStats",
        Name: "CardUsageStats",
        number: 41,
        protoType: 11,
        protoName: "card_usage_stats",
        type: CardUsageStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardUsageStats;
  }
  get promotionBundleStatus() {
    if (!this._promotionBundleStatus) {
      this._promotionBundleStatus = {
        name: "promotionBundleStatus",
        Name: "PromotionBundleStatus",
        number: 51,
        protoType: 11,
        protoName: "promotion_bundle_status",
        type: PromotionBundleStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionBundleStatus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerInfo,
        this.playerProgression,
        this.playerEnergy,
        this.likedCommentIds,
        this.mapProgresses,
        this.savedMapComments,
        this.consumableItems,
        this.shipUpgradeProgression,
        this.campaignProgress,
        this.achievementProgresses,
        this.playerLoadouts,
        this.playerInventory,
        this.genericDataProgress,
        this.mapSaveData,
        this.cardUsageStats,
        this.promotionBundleStatus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerInfo",
        Name: "DummyOneofForPlayerInfo",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerProgression",
        Name: "DummyOneofForPlayerProgression",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerEnergy",
        Name: "DummyOneofForPlayerEnergy",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShipUpgradeProgression",
        Name: "DummyOneofForShipUpgradeProgression",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCampaignProgress",
        Name: "DummyOneofForCampaignProgress",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerInventory",
        Name: "DummyOneofForPlayerInventory",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGenericDataProgress",
        Name: "DummyOneofForGenericDataProgress",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardUsageStats",
        Name: "DummyOneofForCardUsageStats",
        fields: [
          this.fields[14],
        ],
      });
    }
    return this._oneofs;
  }
}
SaveFile.descriptor = new SaveFile_Descriptor();
export class ConsumableItemSave {
  get descriptor() {
    return ConsumableItemSave.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasAmount = false;
    this._amount = null;
    this._hasSequenceNumber = false;
    this._sequenceNumber = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasAmount) return false;
    if (this._hasSequenceNumber) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ConsumableItemSave) {
      return value;
    }
    return ConsumableItemSave.fromJson(value);
  }
  static fromJson(json) {
    const result = new ConsumableItemSave();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.sequenceNumber != null) {
      result._hasSequenceNumber = true;
      result._sequenceNumber = JsonToInt32.fromJson(json.sequenceNumber);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasSequenceNumber) {
      result.sequenceNumber = JsonToInt32.toJson(this._sequenceNumber);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {number}
   */
  get sequenceNumber() {
    return this._hasSequenceNumber ? this._sequenceNumber : JsonToInt32.default;
  }
  get hasSequenceNumber() {
    return this._hasSequenceNumber;
  }
  setSequenceNumber(path, value) {
    return {type: 'SET', path: path.concat(['sequenceNumber']), value};
  }
  deleteSequenceNumber(path) {
    return {type: 'DELETE', path: path.concat(['sequenceNumber'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ConsumableItemSave(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new ConsumableItemSave(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ConsumableItemSave(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new ConsumableItemSave(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "sequenceNumber": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ConsumableItemSave(this);
              copy._hasSequenceNumber = true;
              copy._sequenceNumber = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSequenceNumber) {
                return this;
              }
              const copy = new ConsumableItemSave(this);
              copy._hasSequenceNumber = false;
              copy._sequenceNumber = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ConsumableItemSave} other
   * @returns {ConsumableItemSave}
   */
  merge(other) {
    const copy = new ConsumableItemSave(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasSequenceNumber) {
      copy._hasSequenceNumber = true;
      copy._sequenceNumber = other._sequenceNumber;
    }
    return copy;
  }
}
ConsumableItemSave.default = new ConsumableItemSave();
class ConsumableItemSave_Builder {
  constructor(value) {
    this._value = new ConsumableItemSave(value);
  }
  build() {
    return new ConsumableItemSave(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setSequenceNumber(value) {
    this._value._hasSequenceNumber = true;
    this._value._sequenceNumber = value;
    return this;
  }
  deleteSequenceNumber() {
    this._value._hasSequenceNumber = false;
    this._value._sequenceNumber = null;
    return this;
  }
}
ConsumableItemSave.Builder = ConsumableItemSave_Builder;
class ConsumableItemSave_WithParent {
  /**
   * @param {ConsumableItemSave} value
   * @param {ConsumableItemSave_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ConsumableItemSave.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasSequenceNumber() {
    if (this._cachedHasSequenceNumber === undefined) {
      if (this._value.hasSequenceNumber) {
        this._cachedHasSequenceNumber = true;
      } else {
        this._cachedHasSequenceNumber = this._parent ? this._parent.hasSequenceNumber : false;
      }
    }
    return this._cachedHasSequenceNumber;
  }
  get sequenceNumber() {
    if (this._cachedSequenceNumber === undefined) {
      if (this._value.hasSequenceNumber) {
        this._cachedSequenceNumber = this._value.sequenceNumber;
      } else {
        this._cachedSequenceNumber = this._parent ? this._parent.sequenceNumber : this._value.sequenceNumber;
      }
    }
    return this._cachedSequenceNumber;
  }
  update(current, parent) {
    const result = new ConsumableItemSave_WithParent(current, parent);
    return result;
  }
}
ConsumableItemSave_WithParent.default = new ConsumableItemSave_WithParent(ConsumableItemSave.default, null);
ConsumableItemSave.WithParent = ConsumableItemSave_WithParent;
class ConsumableItemSave_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get sequenceNumber() {
    if (!this._sequenceNumber) {
      this._sequenceNumber = {
        name: "sequenceNumber",
        Name: "SequenceNumber",
        number: 3,
        protoType: 5,
        protoName: "sequence_number",
        type: JsonToInt32,
        options: {
          comments: "Used to keep tracks of how many time the user purchased",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sequenceNumber;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.amount,
        this.sequenceNumber,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSequenceNumber",
        Name: "DummyOneofForSequenceNumber",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ConsumableItemSave.descriptor = new ConsumableItemSave_Descriptor();
export class SavedMapComment {
  get descriptor() {
    return SavedMapComment.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTopic = false;
    this._topic = null;
    this._hasContent = false;
    this._content = null;
  }
  isEmpty() {
    if (this._hasTopic) return false;
    if (this._hasContent) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SavedMapComment) {
      return value;
    }
    return SavedMapComment.fromJson(value);
  }
  static fromJson(json) {
    const result = new SavedMapComment();
    if (json.topic != null) {
      result._hasTopic = true;
      result._topic = JsonToString.fromJson(json.topic);
    }
    if (json.content != null) {
      result._hasContent = true;
      result._content = JsonToString.fromJson(json.content);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTopic) {
      result.topic = JsonToString.toJson(this._topic);
    }
    if (this._hasContent) {
      result.content = JsonToString.toJson(this._content);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get topic() {
    return this._hasTopic ? this._topic : JsonToString.default;
  }
  get hasTopic() {
    return this._hasTopic;
  }
  setTopic(path, value) {
    return {type: 'SET', path: path.concat(['topic']), value};
  }
  deleteTopic(path) {
    return {type: 'DELETE', path: path.concat(['topic'])};
  }
  /**
   * @returns {string}
   */
  get content() {
    return this._hasContent ? this._content : JsonToString.default;
  }
  get hasContent() {
    return this._hasContent;
  }
  setContent(path, value) {
    return {type: 'SET', path: path.concat(['content']), value};
  }
  deleteContent(path) {
    return {type: 'DELETE', path: path.concat(['content'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "topic": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SavedMapComment(this);
              copy._hasTopic = true;
              copy._topic = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTopic) {
                return this;
              }
              const copy = new SavedMapComment(this);
              copy._hasTopic = false;
              copy._topic = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "content": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SavedMapComment(this);
              copy._hasContent = true;
              copy._content = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasContent) {
                return this;
              }
              const copy = new SavedMapComment(this);
              copy._hasContent = false;
              copy._content = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SavedMapComment} other
   * @returns {SavedMapComment}
   */
  merge(other) {
    const copy = new SavedMapComment(this);
    if (other._hasTopic) {
      copy._hasTopic = true;
      copy._topic = other._topic;
    }
    if (other._hasContent) {
      copy._hasContent = true;
      copy._content = other._content;
    }
    return copy;
  }
}
SavedMapComment.default = new SavedMapComment();
class SavedMapComment_Builder {
  constructor(value) {
    this._value = new SavedMapComment(value);
  }
  build() {
    return new SavedMapComment(this._value);
  }
  setTopic(value) {
    this._value._hasTopic = true;
    this._value._topic = value;
    return this;
  }
  deleteTopic() {
    this._value._hasTopic = false;
    this._value._topic = null;
    return this;
  }
  setContent(value) {
    this._value._hasContent = true;
    this._value._content = value;
    return this;
  }
  deleteContent() {
    this._value._hasContent = false;
    this._value._content = null;
    return this;
  }
}
SavedMapComment.Builder = SavedMapComment_Builder;
class SavedMapComment_WithParent {
  /**
   * @param {SavedMapComment} value
   * @param {SavedMapComment_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SavedMapComment.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTopic() {
    if (this._cachedHasTopic === undefined) {
      if (this._value.hasTopic) {
        this._cachedHasTopic = true;
      } else {
        this._cachedHasTopic = this._parent ? this._parent.hasTopic : false;
      }
    }
    return this._cachedHasTopic;
  }
  get topic() {
    if (this._cachedTopic === undefined) {
      if (this._value.hasTopic) {
        this._cachedTopic = this._value.topic;
      } else {
        this._cachedTopic = this._parent ? this._parent.topic : this._value.topic;
      }
    }
    return this._cachedTopic;
  }
  get hasContent() {
    if (this._cachedHasContent === undefined) {
      if (this._value.hasContent) {
        this._cachedHasContent = true;
      } else {
        this._cachedHasContent = this._parent ? this._parent.hasContent : false;
      }
    }
    return this._cachedHasContent;
  }
  get content() {
    if (this._cachedContent === undefined) {
      if (this._value.hasContent) {
        this._cachedContent = this._value.content;
      } else {
        this._cachedContent = this._parent ? this._parent.content : this._value.content;
      }
    }
    return this._cachedContent;
  }
  update(current, parent) {
    const result = new SavedMapComment_WithParent(current, parent);
    return result;
  }
}
SavedMapComment_WithParent.default = new SavedMapComment_WithParent(SavedMapComment.default, null);
SavedMapComment.WithParent = SavedMapComment_WithParent;
class SavedMapComment_Descriptor {
  get topic() {
    if (!this._topic) {
      this._topic = {
        name: "topic",
        Name: "Topic",
        number: 1,
        protoType: 9,
        protoName: "topic",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._topic;
  }
  get content() {
    if (!this._content) {
      this._content = {
        name: "content",
        Name: "Content",
        number: 2,
        protoType: 9,
        protoName: "content",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._content;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.topic,
        this.content,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTopic",
        Name: "DummyOneofForTopic",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForContent",
        Name: "DummyOneofForContent",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
SavedMapComment.descriptor = new SavedMapComment_Descriptor();
export class MapProgress {
  get descriptor() {
    return MapProgress.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasCompleted = false;
    this._completed = null;
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasCompleted) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapProgress) {
      return value;
    }
    return MapProgress.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapProgress();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.completed != null) {
      result._hasCompleted = true;
      result._completed = JsonToBoolean.fromJson(json.completed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasCompleted) {
      result.completed = JsonToBoolean.toJson(this._completed);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {boolean}
   */
  get completed() {
    return this._hasCompleted ? this._completed : JsonToBoolean.default;
  }
  get hasCompleted() {
    return this._hasCompleted;
  }
  setCompleted(path, value) {
    return {type: 'SET', path: path.concat(['completed']), value};
  }
  deleteCompleted(path) {
    return {type: 'DELETE', path: path.concat(['completed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapProgress(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new MapProgress(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "completed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapProgress(this);
              copy._hasCompleted = true;
              copy._completed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCompleted) {
                return this;
              }
              const copy = new MapProgress(this);
              copy._hasCompleted = false;
              copy._completed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapProgress} other
   * @returns {MapProgress}
   */
  merge(other) {
    const copy = new MapProgress(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasCompleted) {
      copy._hasCompleted = true;
      copy._completed = other._completed;
    }
    return copy;
  }
}
MapProgress.default = new MapProgress();
class MapProgress_Builder {
  constructor(value) {
    this._value = new MapProgress(value);
  }
  build() {
    return new MapProgress(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setCompleted(value) {
    this._value._hasCompleted = true;
    this._value._completed = value;
    return this;
  }
  deleteCompleted() {
    this._value._hasCompleted = false;
    this._value._completed = null;
    return this;
  }
}
MapProgress.Builder = MapProgress_Builder;
class MapProgress_WithParent {
  /**
   * @param {MapProgress} value
   * @param {MapProgress_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapProgress.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasCompleted() {
    if (this._cachedHasCompleted === undefined) {
      if (this._value.hasCompleted) {
        this._cachedHasCompleted = true;
      } else {
        this._cachedHasCompleted = this._parent ? this._parent.hasCompleted : false;
      }
    }
    return this._cachedHasCompleted;
  }
  get completed() {
    if (this._cachedCompleted === undefined) {
      if (this._value.hasCompleted) {
        this._cachedCompleted = this._value.completed;
      } else {
        this._cachedCompleted = this._parent ? this._parent.completed : this._value.completed;
      }
    }
    return this._cachedCompleted;
  }
  update(current, parent) {
    const result = new MapProgress_WithParent(current, parent);
    return result;
  }
}
MapProgress_WithParent.default = new MapProgress_WithParent(MapProgress.default, null);
MapProgress.WithParent = MapProgress_WithParent;
class MapProgress_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 1,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get completed() {
    if (!this._completed) {
      this._completed = {
        name: "completed",
        Name: "Completed",
        number: 2,
        protoType: 8,
        protoName: "completed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._completed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.completed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCompleted",
        Name: "DummyOneofForCompleted",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MapProgress.descriptor = new MapProgress_Descriptor();
export class EnergyData {
  get descriptor() {
    return EnergyData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrentEnergy = false;
    this._currentEnergy = null;
    this._hasMaxEnergy = false;
    this._maxEnergy = null;
    this._hasRegenerationStartTime = false;
    this._regenerationStartTime = null;
  }
  isEmpty() {
    if (this._hasCurrentEnergy) return false;
    if (this._hasMaxEnergy) return false;
    if (this._hasRegenerationStartTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EnergyData) {
      return value;
    }
    return EnergyData.fromJson(value);
  }
  static fromJson(json) {
    const result = new EnergyData();
    if (json.currentEnergy != null) {
      result._hasCurrentEnergy = true;
      result._currentEnergy = JsonToInt32.fromJson(json.currentEnergy);
    }
    if (json.maxEnergy != null) {
      result._hasMaxEnergy = true;
      result._maxEnergy = JsonToInt32.fromJson(json.maxEnergy);
    }
    if (json.regenerationStartTime != null) {
      result._hasRegenerationStartTime = true;
      result._regenerationStartTime = JsonToInt32.fromJson(json.regenerationStartTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrentEnergy) {
      result.currentEnergy = JsonToInt32.toJson(this._currentEnergy);
    }
    if (this._hasMaxEnergy) {
      result.maxEnergy = JsonToInt32.toJson(this._maxEnergy);
    }
    if (this._hasRegenerationStartTime) {
      result.regenerationStartTime = JsonToInt32.toJson(this._regenerationStartTime);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get currentEnergy() {
    return this._hasCurrentEnergy ? this._currentEnergy : JsonToInt32.default;
  }
  get hasCurrentEnergy() {
    return this._hasCurrentEnergy;
  }
  setCurrentEnergy(path, value) {
    return {type: 'SET', path: path.concat(['currentEnergy']), value};
  }
  deleteCurrentEnergy(path) {
    return {type: 'DELETE', path: path.concat(['currentEnergy'])};
  }
  /**
   * @returns {number}
   */
  get maxEnergy() {
    return this._hasMaxEnergy ? this._maxEnergy : JsonToInt32.default;
  }
  get hasMaxEnergy() {
    return this._hasMaxEnergy;
  }
  setMaxEnergy(path, value) {
    return {type: 'SET', path: path.concat(['maxEnergy']), value};
  }
  deleteMaxEnergy(path) {
    return {type: 'DELETE', path: path.concat(['maxEnergy'])};
  }
  /**
   * @returns {number}
   */
  get regenerationStartTime() {
    return this._hasRegenerationStartTime ? this._regenerationStartTime : JsonToInt32.default;
  }
  get hasRegenerationStartTime() {
    return this._hasRegenerationStartTime;
  }
  setRegenerationStartTime(path, value) {
    return {type: 'SET', path: path.concat(['regenerationStartTime']), value};
  }
  deleteRegenerationStartTime(path) {
    return {type: 'DELETE', path: path.concat(['regenerationStartTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currentEnergy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergyData(this);
              copy._hasCurrentEnergy = true;
              copy._currentEnergy = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentEnergy) {
                return this;
              }
              const copy = new EnergyData(this);
              copy._hasCurrentEnergy = false;
              copy._currentEnergy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxEnergy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergyData(this);
              copy._hasMaxEnergy = true;
              copy._maxEnergy = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxEnergy) {
                return this;
              }
              const copy = new EnergyData(this);
              copy._hasMaxEnergy = false;
              copy._maxEnergy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regenerationStartTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergyData(this);
              copy._hasRegenerationStartTime = true;
              copy._regenerationStartTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegenerationStartTime) {
                return this;
              }
              const copy = new EnergyData(this);
              copy._hasRegenerationStartTime = false;
              copy._regenerationStartTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EnergyData} other
   * @returns {EnergyData}
   */
  merge(other) {
    const copy = new EnergyData(this);
    if (other._hasCurrentEnergy) {
      copy._hasCurrentEnergy = true;
      copy._currentEnergy = other._currentEnergy;
    }
    if (other._hasMaxEnergy) {
      copy._hasMaxEnergy = true;
      copy._maxEnergy = other._maxEnergy;
    }
    if (other._hasRegenerationStartTime) {
      copy._hasRegenerationStartTime = true;
      copy._regenerationStartTime = other._regenerationStartTime;
    }
    return copy;
  }
}
EnergyData.default = new EnergyData();
class EnergyData_Builder {
  constructor(value) {
    this._value = new EnergyData(value);
  }
  build() {
    return new EnergyData(this._value);
  }
  setCurrentEnergy(value) {
    this._value._hasCurrentEnergy = true;
    this._value._currentEnergy = value;
    return this;
  }
  deleteCurrentEnergy() {
    this._value._hasCurrentEnergy = false;
    this._value._currentEnergy = null;
    return this;
  }
  setMaxEnergy(value) {
    this._value._hasMaxEnergy = true;
    this._value._maxEnergy = value;
    return this;
  }
  deleteMaxEnergy() {
    this._value._hasMaxEnergy = false;
    this._value._maxEnergy = null;
    return this;
  }
  setRegenerationStartTime(value) {
    this._value._hasRegenerationStartTime = true;
    this._value._regenerationStartTime = value;
    return this;
  }
  deleteRegenerationStartTime() {
    this._value._hasRegenerationStartTime = false;
    this._value._regenerationStartTime = null;
    return this;
  }
}
EnergyData.Builder = EnergyData_Builder;
class EnergyData_WithParent {
  /**
   * @param {EnergyData} value
   * @param {EnergyData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EnergyData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrentEnergy() {
    if (this._cachedHasCurrentEnergy === undefined) {
      if (this._value.hasCurrentEnergy) {
        this._cachedHasCurrentEnergy = true;
      } else {
        this._cachedHasCurrentEnergy = this._parent ? this._parent.hasCurrentEnergy : false;
      }
    }
    return this._cachedHasCurrentEnergy;
  }
  get currentEnergy() {
    if (this._cachedCurrentEnergy === undefined) {
      if (this._value.hasCurrentEnergy) {
        this._cachedCurrentEnergy = this._value.currentEnergy;
      } else {
        this._cachedCurrentEnergy = this._parent ? this._parent.currentEnergy : this._value.currentEnergy;
      }
    }
    return this._cachedCurrentEnergy;
  }
  get hasMaxEnergy() {
    if (this._cachedHasMaxEnergy === undefined) {
      if (this._value.hasMaxEnergy) {
        this._cachedHasMaxEnergy = true;
      } else {
        this._cachedHasMaxEnergy = this._parent ? this._parent.hasMaxEnergy : false;
      }
    }
    return this._cachedHasMaxEnergy;
  }
  get maxEnergy() {
    if (this._cachedMaxEnergy === undefined) {
      if (this._value.hasMaxEnergy) {
        this._cachedMaxEnergy = this._value.maxEnergy;
      } else {
        this._cachedMaxEnergy = this._parent ? this._parent.maxEnergy : this._value.maxEnergy;
      }
    }
    return this._cachedMaxEnergy;
  }
  get hasRegenerationStartTime() {
    if (this._cachedHasRegenerationStartTime === undefined) {
      if (this._value.hasRegenerationStartTime) {
        this._cachedHasRegenerationStartTime = true;
      } else {
        this._cachedHasRegenerationStartTime = this._parent ? this._parent.hasRegenerationStartTime : false;
      }
    }
    return this._cachedHasRegenerationStartTime;
  }
  get regenerationStartTime() {
    if (this._cachedRegenerationStartTime === undefined) {
      if (this._value.hasRegenerationStartTime) {
        this._cachedRegenerationStartTime = this._value.regenerationStartTime;
      } else {
        this._cachedRegenerationStartTime = this._parent ? this._parent.regenerationStartTime : this._value.regenerationStartTime;
      }
    }
    return this._cachedRegenerationStartTime;
  }
  update(current, parent) {
    const result = new EnergyData_WithParent(current, parent);
    return result;
  }
}
EnergyData_WithParent.default = new EnergyData_WithParent(EnergyData.default, null);
EnergyData.WithParent = EnergyData_WithParent;
class EnergyData_Descriptor {
  get currentEnergy() {
    if (!this._currentEnergy) {
      this._currentEnergy = {
        name: "currentEnergy",
        Name: "CurrentEnergy",
        number: 1,
        protoType: 5,
        protoName: "current_energy",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentEnergy;
  }
  get maxEnergy() {
    if (!this._maxEnergy) {
      this._maxEnergy = {
        name: "maxEnergy",
        Name: "MaxEnergy",
        number: 2,
        protoType: 5,
        protoName: "max_energy",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxEnergy;
  }
  get regenerationStartTime() {
    if (!this._regenerationStartTime) {
      this._regenerationStartTime = {
        name: "regenerationStartTime",
        Name: "RegenerationStartTime",
        number: 3,
        protoType: 5,
        protoName: "regeneration_start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regenerationStartTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currentEnergy,
        this.maxEnergy,
        this.regenerationStartTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrentEnergy",
        Name: "DummyOneofForCurrentEnergy",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxEnergy",
        Name: "DummyOneofForMaxEnergy",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegenerationStartTime",
        Name: "DummyOneofForRegenerationStartTime",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EnergyData.descriptor = new EnergyData_Descriptor();
export class PromotionBundleStatus {
  get descriptor() {
    return PromotionBundleStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPromotionBundleKey = false;
    this._promotionBundleKey = null;
    this._hasLastDismissTime = false;
    this._lastDismissTime = null;
  }
  isEmpty() {
    if (this._hasPromotionBundleKey) return false;
    if (this._hasLastDismissTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleStatus) {
      return value;
    }
    return PromotionBundleStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleStatus();
    if (json.promotionBundleKey != null) {
      result._hasPromotionBundleKey = true;
      result._promotionBundleKey = JsonToString.fromJson(json.promotionBundleKey);
    }
    if (json.lastDismissTime != null) {
      result._hasLastDismissTime = true;
      result._lastDismissTime = JsonToInt32.fromJson(json.lastDismissTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPromotionBundleKey) {
      result.promotionBundleKey = JsonToString.toJson(this._promotionBundleKey);
    }
    if (this._hasLastDismissTime) {
      result.lastDismissTime = JsonToInt32.toJson(this._lastDismissTime);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get promotionBundleKey() {
    return this._hasPromotionBundleKey ? this._promotionBundleKey : JsonToString.default;
  }
  get hasPromotionBundleKey() {
    return this._hasPromotionBundleKey;
  }
  setPromotionBundleKey(path, value) {
    return {type: 'SET', path: path.concat(['promotionBundleKey']), value};
  }
  deletePromotionBundleKey(path) {
    return {type: 'DELETE', path: path.concat(['promotionBundleKey'])};
  }
  /**
   * @returns {number}
   */
  get lastDismissTime() {
    return this._hasLastDismissTime ? this._lastDismissTime : JsonToInt32.default;
  }
  get hasLastDismissTime() {
    return this._hasLastDismissTime;
  }
  setLastDismissTime(path, value) {
    return {type: 'SET', path: path.concat(['lastDismissTime']), value};
  }
  deleteLastDismissTime(path) {
    return {type: 'DELETE', path: path.concat(['lastDismissTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "promotionBundleKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleStatus(this);
              copy._hasPromotionBundleKey = true;
              copy._promotionBundleKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPromotionBundleKey) {
                return this;
              }
              const copy = new PromotionBundleStatus(this);
              copy._hasPromotionBundleKey = false;
              copy._promotionBundleKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "lastDismissTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleStatus(this);
              copy._hasLastDismissTime = true;
              copy._lastDismissTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLastDismissTime) {
                return this;
              }
              const copy = new PromotionBundleStatus(this);
              copy._hasLastDismissTime = false;
              copy._lastDismissTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleStatus} other
   * @returns {PromotionBundleStatus}
   */
  merge(other) {
    const copy = new PromotionBundleStatus(this);
    if (other._hasPromotionBundleKey) {
      copy._hasPromotionBundleKey = true;
      copy._promotionBundleKey = other._promotionBundleKey;
    }
    if (other._hasLastDismissTime) {
      copy._hasLastDismissTime = true;
      copy._lastDismissTime = other._lastDismissTime;
    }
    return copy;
  }
}
PromotionBundleStatus.default = new PromotionBundleStatus();
class PromotionBundleStatus_Builder {
  constructor(value) {
    this._value = new PromotionBundleStatus(value);
  }
  build() {
    return new PromotionBundleStatus(this._value);
  }
  setPromotionBundleKey(value) {
    this._value._hasPromotionBundleKey = true;
    this._value._promotionBundleKey = value;
    return this;
  }
  deletePromotionBundleKey() {
    this._value._hasPromotionBundleKey = false;
    this._value._promotionBundleKey = null;
    return this;
  }
  setLastDismissTime(value) {
    this._value._hasLastDismissTime = true;
    this._value._lastDismissTime = value;
    return this;
  }
  deleteLastDismissTime() {
    this._value._hasLastDismissTime = false;
    this._value._lastDismissTime = null;
    return this;
  }
}
PromotionBundleStatus.Builder = PromotionBundleStatus_Builder;
class PromotionBundleStatus_WithParent {
  /**
   * @param {PromotionBundleStatus} value
   * @param {PromotionBundleStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPromotionBundleKey() {
    if (this._cachedHasPromotionBundleKey === undefined) {
      if (this._value.hasPromotionBundleKey) {
        this._cachedHasPromotionBundleKey = true;
      } else {
        this._cachedHasPromotionBundleKey = this._parent ? this._parent.hasPromotionBundleKey : false;
      }
    }
    return this._cachedHasPromotionBundleKey;
  }
  get promotionBundleKey() {
    if (this._cachedPromotionBundleKey === undefined) {
      if (this._value.hasPromotionBundleKey) {
        this._cachedPromotionBundleKey = this._value.promotionBundleKey;
      } else {
        this._cachedPromotionBundleKey = this._parent ? this._parent.promotionBundleKey : this._value.promotionBundleKey;
      }
    }
    return this._cachedPromotionBundleKey;
  }
  get hasLastDismissTime() {
    if (this._cachedHasLastDismissTime === undefined) {
      if (this._value.hasLastDismissTime) {
        this._cachedHasLastDismissTime = true;
      } else {
        this._cachedHasLastDismissTime = this._parent ? this._parent.hasLastDismissTime : false;
      }
    }
    return this._cachedHasLastDismissTime;
  }
  get lastDismissTime() {
    if (this._cachedLastDismissTime === undefined) {
      if (this._value.hasLastDismissTime) {
        this._cachedLastDismissTime = this._value.lastDismissTime;
      } else {
        this._cachedLastDismissTime = this._parent ? this._parent.lastDismissTime : this._value.lastDismissTime;
      }
    }
    return this._cachedLastDismissTime;
  }
  update(current, parent) {
    const result = new PromotionBundleStatus_WithParent(current, parent);
    return result;
  }
}
PromotionBundleStatus_WithParent.default = new PromotionBundleStatus_WithParent(PromotionBundleStatus.default, null);
PromotionBundleStatus.WithParent = PromotionBundleStatus_WithParent;
class PromotionBundleStatus_Descriptor {
  get promotionBundleKey() {
    if (!this._promotionBundleKey) {
      this._promotionBundleKey = {
        name: "promotionBundleKey",
        Name: "PromotionBundleKey",
        number: 1,
        protoType: 9,
        protoName: "promotion_bundle_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionBundleKey;
  }
  get lastDismissTime() {
    if (!this._lastDismissTime) {
      this._lastDismissTime = {
        name: "lastDismissTime",
        Name: "LastDismissTime",
        number: 2,
        protoType: 5,
        protoName: "last_dismiss_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._lastDismissTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.promotionBundleKey,
        this.lastDismissTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPromotionBundleKey",
        Name: "DummyOneofForPromotionBundleKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLastDismissTime",
        Name: "DummyOneofForLastDismissTime",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleStatus.descriptor = new PromotionBundleStatus_Descriptor();
export class BackUpData {
  get descriptor() {
    return BackUpData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCampaignProgress = false;
    this._campaignProgress = null;
    this._achievementProgresses = [];
    this._hasPlayerEnergy = false;
    this._playerEnergy = null;
    this._likedCommentIds = [];
    this._mapProgresses = [];
    this._savedMapComments = [];
    this._consumableItems = [];
    this._hasGenericDataProgress = false;
    this._genericDataProgress = null;
    this._hasCardUsageStats = false;
    this._cardUsageStats = null;
    this._promotionBundleStatus = [];
  }
  isEmpty() {
    if (this._hasCampaignProgress && !this._campaignProgress.isEmpty()) return false;
    if (this._achievementProgresses.length > 0) return false;
    if (this._hasPlayerEnergy && !this._playerEnergy.isEmpty()) return false;
    if (this._likedCommentIds.length > 0) return false;
    if (this._mapProgresses.length > 0) return false;
    if (this._savedMapComments.length > 0) return false;
    if (this._consumableItems.length > 0) return false;
    if (this._hasGenericDataProgress && !this._genericDataProgress.isEmpty()) return false;
    if (this._hasCardUsageStats && !this._cardUsageStats.isEmpty()) return false;
    if (this._promotionBundleStatus.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BackUpData) {
      return value;
    }
    return BackUpData.fromJson(value);
  }
  static fromJson(json) {
    const result = new BackUpData();
    if (json.campaignProgress != null) {
      result._hasCampaignProgress = true;
      result._campaignProgress = CampaignProgress.fromJson(json.campaignProgress);
    }
    result._achievementProgresses = JsonToList(json.achievementProgresses, AchievementProgress);
    if (json.playerEnergy != null) {
      result._hasPlayerEnergy = true;
      result._playerEnergy = EnergyData.fromJson(json.playerEnergy);
    }
    result._likedCommentIds = JsonToList(json.likedCommentIds, JsonToString);
    result._mapProgresses = JsonToList(json.mapProgresses, MapProgress);
    result._savedMapComments = JsonToList(json.savedMapComments, SavedMapComment);
    result._consumableItems = JsonToList(json.consumableItems, ConsumableItemSave);
    if (json.genericDataProgress != null) {
      result._hasGenericDataProgress = true;
      result._genericDataProgress = GenericDataProgress.fromJson(json.genericDataProgress);
    }
    if (json.cardUsageStats != null) {
      result._hasCardUsageStats = true;
      result._cardUsageStats = CardUsageStats.fromJson(json.cardUsageStats);
    }
    result._promotionBundleStatus = JsonToList(json.promotionBundleStatus, PromotionBundleStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCampaignProgress && !this._campaignProgress.isEmpty()) {
      result.campaignProgress = CampaignProgress.toJson(this._campaignProgress);
    }
    if (this._achievementProgresses.length > 0) {
      result.achievementProgresses = ArrayToJson(this._achievementProgresses, AchievementProgress);
    }
    if (this._hasPlayerEnergy && !this._playerEnergy.isEmpty()) {
      result.playerEnergy = EnergyData.toJson(this._playerEnergy);
    }
    if (this._likedCommentIds.length > 0) {
      result.likedCommentIds = ArrayToJson(this._likedCommentIds, JsonToString);
    }
    if (this._mapProgresses.length > 0) {
      result.mapProgresses = ArrayToJson(this._mapProgresses, MapProgress);
    }
    if (this._savedMapComments.length > 0) {
      result.savedMapComments = ArrayToJson(this._savedMapComments, SavedMapComment);
    }
    if (this._consumableItems.length > 0) {
      result.consumableItems = ArrayToJson(this._consumableItems, ConsumableItemSave);
    }
    if (this._hasGenericDataProgress && !this._genericDataProgress.isEmpty()) {
      result.genericDataProgress = GenericDataProgress.toJson(this._genericDataProgress);
    }
    if (this._hasCardUsageStats && !this._cardUsageStats.isEmpty()) {
      result.cardUsageStats = CardUsageStats.toJson(this._cardUsageStats);
    }
    if (this._promotionBundleStatus.length > 0) {
      result.promotionBundleStatus = ArrayToJson(this._promotionBundleStatus, PromotionBundleStatus);
    }
    return result;
  }
  /**
   * @returns {CampaignProgress}
   */
  get campaignProgress() {
    return this._hasCampaignProgress ? this._campaignProgress : CampaignProgress.default;
  }
  get hasCampaignProgress() {
    return this._hasCampaignProgress;
  }
  setCampaignProgress(path, value) {
    return {type: 'SET', path: path.concat(['campaignProgress']), value: value.toJson()};
  }
  deleteCampaignProgress(path) {
    return {type: 'DELETE', path: path.concat(['campaignProgress'])};
  }
  /**
   * @returns {AchievementProgress[]}
   */
  get achievementProgresses() {
    return this._achievementProgresses;
  }
  addAchievementProgresses(path, value) {
    return {type: 'ADD', path: path.concat(['achievementProgresses']), value: value.toJson()};
  }
  setAchievementProgresses(path, value) {
    return {type: 'SET', path: path.concat(['achievementProgresses']), value: ArrayToJson(value, AchievementProgress)};
  }
  setAchievementProgressesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['achievementProgresses', key]), value: value.toJson()};
  }
  deleteAchievementProgresses(path) {
    return {type: 'DELETE', path: path.concat(['achievementProgresses'])};
  }
  deleteAchievementProgressesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['achievementProgresses', key])};
  }
  /**
   * @returns {EnergyData}
   */
  get playerEnergy() {
    return this._hasPlayerEnergy ? this._playerEnergy : EnergyData.default;
  }
  get hasPlayerEnergy() {
    return this._hasPlayerEnergy;
  }
  setPlayerEnergy(path, value) {
    return {type: 'SET', path: path.concat(['playerEnergy']), value: value.toJson()};
  }
  deletePlayerEnergy(path) {
    return {type: 'DELETE', path: path.concat(['playerEnergy'])};
  }
  /**
   * @returns {string[]}
   */
  get likedCommentIds() {
    return this._likedCommentIds;
  }
  addLikedCommentIds(path, value) {
    return {type: 'ADD', path: path.concat(['likedCommentIds']), value};
  }
  setLikedCommentIds(path, value) {
    return {type: 'SET', path: path.concat(['likedCommentIds']), value: ArrayToJson(value, JsonToString)};
  }
  setLikedCommentIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['likedCommentIds', key]), value};
  }
  deleteLikedCommentIds(path) {
    return {type: 'DELETE', path: path.concat(['likedCommentIds'])};
  }
  deleteLikedCommentIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['likedCommentIds', key])};
  }
  /**
   * @returns {MapProgress[]}
   */
  get mapProgresses() {
    return this._mapProgresses;
  }
  addMapProgresses(path, value) {
    return {type: 'ADD', path: path.concat(['mapProgresses']), value: value.toJson()};
  }
  setMapProgresses(path, value) {
    return {type: 'SET', path: path.concat(['mapProgresses']), value: ArrayToJson(value, MapProgress)};
  }
  setMapProgressesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['mapProgresses', key]), value: value.toJson()};
  }
  deleteMapProgresses(path) {
    return {type: 'DELETE', path: path.concat(['mapProgresses'])};
  }
  deleteMapProgressesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['mapProgresses', key])};
  }
  /**
   * @returns {SavedMapComment[]}
   */
  get savedMapComments() {
    return this._savedMapComments;
  }
  addSavedMapComments(path, value) {
    return {type: 'ADD', path: path.concat(['savedMapComments']), value: value.toJson()};
  }
  setSavedMapComments(path, value) {
    return {type: 'SET', path: path.concat(['savedMapComments']), value: ArrayToJson(value, SavedMapComment)};
  }
  setSavedMapCommentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['savedMapComments', key]), value: value.toJson()};
  }
  deleteSavedMapComments(path) {
    return {type: 'DELETE', path: path.concat(['savedMapComments'])};
  }
  deleteSavedMapCommentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['savedMapComments', key])};
  }
  /**
   * @returns {ConsumableItemSave[]}
   */
  get consumableItems() {
    return this._consumableItems;
  }
  addConsumableItems(path, value) {
    return {type: 'ADD', path: path.concat(['consumableItems']), value: value.toJson()};
  }
  setConsumableItems(path, value) {
    return {type: 'SET', path: path.concat(['consumableItems']), value: ArrayToJson(value, ConsumableItemSave)};
  }
  setConsumableItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['consumableItems', key]), value: value.toJson()};
  }
  deleteConsumableItems(path) {
    return {type: 'DELETE', path: path.concat(['consumableItems'])};
  }
  deleteConsumableItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['consumableItems', key])};
  }
  /**
   * @returns {GenericDataProgress}
   */
  get genericDataProgress() {
    return this._hasGenericDataProgress ? this._genericDataProgress : GenericDataProgress.default;
  }
  get hasGenericDataProgress() {
    return this._hasGenericDataProgress;
  }
  setGenericDataProgress(path, value) {
    return {type: 'SET', path: path.concat(['genericDataProgress']), value: value.toJson()};
  }
  deleteGenericDataProgress(path) {
    return {type: 'DELETE', path: path.concat(['genericDataProgress'])};
  }
  /**
   * @returns {CardUsageStats}
   */
  get cardUsageStats() {
    return this._hasCardUsageStats ? this._cardUsageStats : CardUsageStats.default;
  }
  get hasCardUsageStats() {
    return this._hasCardUsageStats;
  }
  setCardUsageStats(path, value) {
    return {type: 'SET', path: path.concat(['cardUsageStats']), value: value.toJson()};
  }
  deleteCardUsageStats(path) {
    return {type: 'DELETE', path: path.concat(['cardUsageStats'])};
  }
  /**
   * @returns {PromotionBundleStatus[]}
   */
  get promotionBundleStatus() {
    return this._promotionBundleStatus;
  }
  addPromotionBundleStatus(path, value) {
    return {type: 'ADD', path: path.concat(['promotionBundleStatus']), value: value.toJson()};
  }
  setPromotionBundleStatus(path, value) {
    return {type: 'SET', path: path.concat(['promotionBundleStatus']), value: ArrayToJson(value, PromotionBundleStatus)};
  }
  setPromotionBundleStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotionBundleStatus', key]), value: value.toJson()};
  }
  deletePromotionBundleStatus(path) {
    return {type: 'DELETE', path: path.concat(['promotionBundleStatus'])};
  }
  deletePromotionBundleStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotionBundleStatus', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "campaignProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._hasCampaignProgress = true;
              copy._campaignProgress = CampaignProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCampaignProgress) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._hasCampaignProgress = false;
              copy._campaignProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCampaignProgress) {
            const copy = new BackUpData(this);
            copy._hasCampaignProgress = true;
            copy._campaignProgress = CampaignProgress.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._campaignProgress.apply(type, path.slice(1), value);
          if (newValue === this._campaignProgress) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._campaignProgress = copy._campaignProgress.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "achievementProgresses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._achievementProgresses = [];        for (let i of value) {
                copy._achievementProgresses.push(AchievementProgress.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BackUpData(this);
              copy._achievementProgresses = copy._achievementProgresses.concat([AchievementProgress.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._achievementProgresses.length === 0) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._achievementProgresses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._achievementProgresses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._achievementProgresses = copy._achievementProgresses.slice();
              copy._achievementProgresses[path[1]] = AchievementProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BackUpData(this);
              copy._achievementProgresses = copy._achievementProgresses.slice(0, path[1]).concat(copy._achievementProgresses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._achievementProgresses.length) {
            return this;
          }
          const oldValue = this._achievementProgresses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._achievementProgresses = copy._achievementProgresses.slice();
          copy._achievementProgresses[key] = newValue;
          return copy;
        }
      }
      case "playerEnergy": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._hasPlayerEnergy = true;
              copy._playerEnergy = EnergyData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerEnergy) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._hasPlayerEnergy = false;
              copy._playerEnergy = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerEnergy) {
            const copy = new BackUpData(this);
            copy._hasPlayerEnergy = true;
            copy._playerEnergy = EnergyData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerEnergy.apply(type, path.slice(1), value);
          if (newValue === this._playerEnergy) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._playerEnergy = copy._playerEnergy.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "likedCommentIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._likedCommentIds = [];        for (let i of value) {
                copy._likedCommentIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BackUpData(this);
              copy._likedCommentIds = copy._likedCommentIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._likedCommentIds.length === 0) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._likedCommentIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._likedCommentIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._likedCommentIds = copy._likedCommentIds.slice();
              copy._likedCommentIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BackUpData(this);
              copy._likedCommentIds = copy._likedCommentIds.slice(0, path[1]).concat(copy._likedCommentIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._likedCommentIds.length) {
            return this;
          }
          const oldValue = this._likedCommentIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._likedCommentIds = copy._likedCommentIds.slice();
          copy._likedCommentIds[key] = newValue;
          return copy;
        }
      }
      case "mapProgresses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._mapProgresses = [];        for (let i of value) {
                copy._mapProgresses.push(MapProgress.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BackUpData(this);
              copy._mapProgresses = copy._mapProgresses.concat([MapProgress.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._mapProgresses.length === 0) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._mapProgresses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._mapProgresses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._mapProgresses = copy._mapProgresses.slice();
              copy._mapProgresses[path[1]] = MapProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BackUpData(this);
              copy._mapProgresses = copy._mapProgresses.slice(0, path[1]).concat(copy._mapProgresses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._mapProgresses.length) {
            return this;
          }
          const oldValue = this._mapProgresses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._mapProgresses = copy._mapProgresses.slice();
          copy._mapProgresses[key] = newValue;
          return copy;
        }
      }
      case "savedMapComments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._savedMapComments = [];        for (let i of value) {
                copy._savedMapComments.push(SavedMapComment.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BackUpData(this);
              copy._savedMapComments = copy._savedMapComments.concat([SavedMapComment.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._savedMapComments.length === 0) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._savedMapComments = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._savedMapComments.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._savedMapComments = copy._savedMapComments.slice();
              copy._savedMapComments[path[1]] = SavedMapComment.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BackUpData(this);
              copy._savedMapComments = copy._savedMapComments.slice(0, path[1]).concat(copy._savedMapComments.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._savedMapComments.length) {
            return this;
          }
          const oldValue = this._savedMapComments[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._savedMapComments = copy._savedMapComments.slice();
          copy._savedMapComments[key] = newValue;
          return copy;
        }
      }
      case "consumableItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._consumableItems = [];        for (let i of value) {
                copy._consumableItems.push(ConsumableItemSave.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BackUpData(this);
              copy._consumableItems = copy._consumableItems.concat([ConsumableItemSave.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._consumableItems.length === 0) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._consumableItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._consumableItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._consumableItems = copy._consumableItems.slice();
              copy._consumableItems[path[1]] = ConsumableItemSave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BackUpData(this);
              copy._consumableItems = copy._consumableItems.slice(0, path[1]).concat(copy._consumableItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._consumableItems.length) {
            return this;
          }
          const oldValue = this._consumableItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._consumableItems = copy._consumableItems.slice();
          copy._consumableItems[key] = newValue;
          return copy;
        }
      }
      case "genericDataProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._hasGenericDataProgress = true;
              copy._genericDataProgress = GenericDataProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGenericDataProgress) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._hasGenericDataProgress = false;
              copy._genericDataProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasGenericDataProgress) {
            const copy = new BackUpData(this);
            copy._hasGenericDataProgress = true;
            copy._genericDataProgress = GenericDataProgress.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._genericDataProgress.apply(type, path.slice(1), value);
          if (newValue === this._genericDataProgress) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._genericDataProgress = copy._genericDataProgress.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "cardUsageStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._hasCardUsageStats = true;
              copy._cardUsageStats = CardUsageStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardUsageStats) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._hasCardUsageStats = false;
              copy._cardUsageStats = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCardUsageStats) {
            const copy = new BackUpData(this);
            copy._hasCardUsageStats = true;
            copy._cardUsageStats = CardUsageStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cardUsageStats.apply(type, path.slice(1), value);
          if (newValue === this._cardUsageStats) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._cardUsageStats = copy._cardUsageStats.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "promotionBundleStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._promotionBundleStatus = [];        for (let i of value) {
                copy._promotionBundleStatus.push(PromotionBundleStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BackUpData(this);
              copy._promotionBundleStatus = copy._promotionBundleStatus.concat([PromotionBundleStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotionBundleStatus.length === 0) {
                return this;
              }
              const copy = new BackUpData(this);
              copy._promotionBundleStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotionBundleStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BackUpData(this);
              copy._promotionBundleStatus = copy._promotionBundleStatus.slice();
              copy._promotionBundleStatus[path[1]] = PromotionBundleStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BackUpData(this);
              copy._promotionBundleStatus = copy._promotionBundleStatus.slice(0, path[1]).concat(copy._promotionBundleStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotionBundleStatus.length) {
            return this;
          }
          const oldValue = this._promotionBundleStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BackUpData(this);
          copy._promotionBundleStatus = copy._promotionBundleStatus.slice();
          copy._promotionBundleStatus[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BackUpData} other
   * @returns {BackUpData}
   */
  merge(other) {
    const copy = new BackUpData(this);
    if (other._hasCampaignProgress) {
      if (copy._hasCampaignProgress) {
        copy._campaignProgress = copy.campaignProgress.merge(other.campaignProgress);
      } else {
        copy._campaignProgress = other._campaignProgress;
      }
      copy._hasCampaignProgress = true;
    }
    copy._achievementProgresses = this._achievementProgresses.concat(other._achievementProgresses);
    if (other._hasPlayerEnergy) {
      if (copy._hasPlayerEnergy) {
        copy._playerEnergy = copy.playerEnergy.merge(other.playerEnergy);
      } else {
        copy._playerEnergy = other._playerEnergy;
      }
      copy._hasPlayerEnergy = true;
    }
    copy._likedCommentIds = this._likedCommentIds.concat(other._likedCommentIds);
    copy._mapProgresses = this._mapProgresses.concat(other._mapProgresses);
    copy._savedMapComments = this._savedMapComments.concat(other._savedMapComments);
    copy._consumableItems = this._consumableItems.concat(other._consumableItems);
    if (other._hasGenericDataProgress) {
      if (copy._hasGenericDataProgress) {
        copy._genericDataProgress = copy.genericDataProgress.merge(other.genericDataProgress);
      } else {
        copy._genericDataProgress = other._genericDataProgress;
      }
      copy._hasGenericDataProgress = true;
    }
    if (other._hasCardUsageStats) {
      if (copy._hasCardUsageStats) {
        copy._cardUsageStats = copy.cardUsageStats.merge(other.cardUsageStats);
      } else {
        copy._cardUsageStats = other._cardUsageStats;
      }
      copy._hasCardUsageStats = true;
    }
    copy._promotionBundleStatus = this._promotionBundleStatus.concat(other._promotionBundleStatus);
    return copy;
  }
}
BackUpData.default = new BackUpData();
class BackUpData_Builder {
  constructor(value) {
    this._value = new BackUpData(value);
  }
  build() {
    return new BackUpData(this._value);
  }
  setCampaignProgress(value) {
    this._value._hasCampaignProgress = true;
    this._value._campaignProgress = value;
    return this;
  }
  deleteCampaignProgress() {
    this._value._hasCampaignProgress = false;
    this._value._campaignProgress = null;
    return this;
  }
  addAllAchievementProgresses(values) {
    this._value._achievementProgresses = this._value._achievementProgresses.concat(values);
    return this;
  }
  addAchievementProgresses(value) {
    this._value._achievementProgresses = this._value._achievementProgresses.concat([value]);
    return this;
  }
  setAchievementProgresses(index, value) {
    this._value._achievementProgresses = this._value._achievementProgresses.concat();
    this._value._achievementProgresses[index] = value;
    return this;
  }
  clearAchievementProgresses() {
    this._value._achievementProgresses = [];
    return this;
  }
  setPlayerEnergy(value) {
    this._value._hasPlayerEnergy = true;
    this._value._playerEnergy = value;
    return this;
  }
  deletePlayerEnergy() {
    this._value._hasPlayerEnergy = false;
    this._value._playerEnergy = null;
    return this;
  }
  addAllLikedCommentIds(values) {
    this._value._likedCommentIds = this._value._likedCommentIds.concat(values);
    return this;
  }
  addLikedCommentIds(value) {
    this._value._likedCommentIds = this._value._likedCommentIds.concat([value]);
    return this;
  }
  setLikedCommentIds(index, value) {
    this._value._likedCommentIds = this._value._likedCommentIds.concat();
    this._value._likedCommentIds[index] = value;
    return this;
  }
  clearLikedCommentIds() {
    this._value._likedCommentIds = [];
    return this;
  }
  addAllMapProgresses(values) {
    this._value._mapProgresses = this._value._mapProgresses.concat(values);
    return this;
  }
  addMapProgresses(value) {
    this._value._mapProgresses = this._value._mapProgresses.concat([value]);
    return this;
  }
  setMapProgresses(index, value) {
    this._value._mapProgresses = this._value._mapProgresses.concat();
    this._value._mapProgresses[index] = value;
    return this;
  }
  clearMapProgresses() {
    this._value._mapProgresses = [];
    return this;
  }
  addAllSavedMapComments(values) {
    this._value._savedMapComments = this._value._savedMapComments.concat(values);
    return this;
  }
  addSavedMapComments(value) {
    this._value._savedMapComments = this._value._savedMapComments.concat([value]);
    return this;
  }
  setSavedMapComments(index, value) {
    this._value._savedMapComments = this._value._savedMapComments.concat();
    this._value._savedMapComments[index] = value;
    return this;
  }
  clearSavedMapComments() {
    this._value._savedMapComments = [];
    return this;
  }
  addAllConsumableItems(values) {
    this._value._consumableItems = this._value._consumableItems.concat(values);
    return this;
  }
  addConsumableItems(value) {
    this._value._consumableItems = this._value._consumableItems.concat([value]);
    return this;
  }
  setConsumableItems(index, value) {
    this._value._consumableItems = this._value._consumableItems.concat();
    this._value._consumableItems[index] = value;
    return this;
  }
  clearConsumableItems() {
    this._value._consumableItems = [];
    return this;
  }
  setGenericDataProgress(value) {
    this._value._hasGenericDataProgress = true;
    this._value._genericDataProgress = value;
    return this;
  }
  deleteGenericDataProgress() {
    this._value._hasGenericDataProgress = false;
    this._value._genericDataProgress = null;
    return this;
  }
  setCardUsageStats(value) {
    this._value._hasCardUsageStats = true;
    this._value._cardUsageStats = value;
    return this;
  }
  deleteCardUsageStats() {
    this._value._hasCardUsageStats = false;
    this._value._cardUsageStats = null;
    return this;
  }
  addAllPromotionBundleStatus(values) {
    this._value._promotionBundleStatus = this._value._promotionBundleStatus.concat(values);
    return this;
  }
  addPromotionBundleStatus(value) {
    this._value._promotionBundleStatus = this._value._promotionBundleStatus.concat([value]);
    return this;
  }
  setPromotionBundleStatus(index, value) {
    this._value._promotionBundleStatus = this._value._promotionBundleStatus.concat();
    this._value._promotionBundleStatus[index] = value;
    return this;
  }
  clearPromotionBundleStatus() {
    this._value._promotionBundleStatus = [];
    return this;
  }
}
BackUpData.Builder = BackUpData_Builder;
class BackUpData_WithParent {
  /**
   * @param {BackUpData} value
   * @param {BackUpData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BackUpData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCampaignProgress() {
    if (this._cachedHasCampaignProgress === undefined) {
      if (this._value.hasCampaignProgress) {
        this._cachedHasCampaignProgress = true;
      } else {
        this._cachedHasCampaignProgress = this._parent ? this._parent.hasCampaignProgress : false;
      }
    }
    return this._cachedHasCampaignProgress;
  }
  get campaignProgress() {
    if (!this._cachedCampaignProgress) {
      if (this._value.hasCampaignProgress) {
        this._cachedCampaignProgress = new CampaignProgress.WithParent(this._value.campaignProgress, this._parent && this._parent.hasCampaignProgress ? this._parent.campaignProgress : null);
      } else {
        this._cachedCampaignProgress = this._parent ? new CampaignProgress.WithParent(CampaignProgress.default, this._parent.campaignProgress) : CampaignProgress.WithParent.default;
      }
    }
    return this._cachedCampaignProgress;
  }
  get selfAchievementProgresses() {
    if (!this._selfAchievementProgresses) {
      this._selfAchievementProgresses = [];
      for (let i of this._value.achievementProgresses) {
        this._selfAchievementProgresses.push(new AchievementProgress.WithParent(i, null));
      }
    }
    return this._selfAchievementProgresses;
  }
  get inherentAchievementProgresses() {
    if (!this._inherentAchievementProgresses) {
      this._inherentAchievementProgresses = this._parent ? this._parent.achievementProgresses : [];
    }
    return this._inherentAchievementProgresses;
  }
  get achievementProgresses() {
    if (!this._allAchievementProgresses) {
      this._allAchievementProgresses = this._parent ? this._parent.achievementProgresses.concat(this.selfAchievementProgresses) : this.selfAchievementProgresses;
    }
    return this._allAchievementProgresses;
  }
  get hasPlayerEnergy() {
    if (this._cachedHasPlayerEnergy === undefined) {
      if (this._value.hasPlayerEnergy) {
        this._cachedHasPlayerEnergy = true;
      } else {
        this._cachedHasPlayerEnergy = this._parent ? this._parent.hasPlayerEnergy : false;
      }
    }
    return this._cachedHasPlayerEnergy;
  }
  get playerEnergy() {
    if (!this._cachedPlayerEnergy) {
      if (this._value.hasPlayerEnergy) {
        this._cachedPlayerEnergy = new EnergyData.WithParent(this._value.playerEnergy, this._parent && this._parent.hasPlayerEnergy ? this._parent.playerEnergy : null);
      } else {
        this._cachedPlayerEnergy = this._parent ? new EnergyData.WithParent(EnergyData.default, this._parent.playerEnergy) : EnergyData.WithParent.default;
      }
    }
    return this._cachedPlayerEnergy;
  }
  get selfLikedCommentIds() {
    return this._value.likedCommentIds;
  }
  get inherentLikedCommentIds() {
    if (!this._inherentLikedCommentIds) {
      this._inherentLikedCommentIds = this._parent ? this._parent.likedCommentIds : [];
    }
    return this._inherentLikedCommentIds;
  }
  get likedCommentIds() {
    if (!this._allLikedCommentIds) {
      this._allLikedCommentIds = this._parent ? this._parent.likedCommentIds.concat(this.selfLikedCommentIds) : this.selfLikedCommentIds;
    }
    return this._allLikedCommentIds;
  }
  get selfMapProgresses() {
    if (!this._selfMapProgresses) {
      this._selfMapProgresses = [];
      for (let i of this._value.mapProgresses) {
        this._selfMapProgresses.push(new MapProgress.WithParent(i, null));
      }
    }
    return this._selfMapProgresses;
  }
  get inherentMapProgresses() {
    if (!this._inherentMapProgresses) {
      this._inherentMapProgresses = this._parent ? this._parent.mapProgresses : [];
    }
    return this._inherentMapProgresses;
  }
  get mapProgresses() {
    if (!this._allMapProgresses) {
      this._allMapProgresses = this._parent ? this._parent.mapProgresses.concat(this.selfMapProgresses) : this.selfMapProgresses;
    }
    return this._allMapProgresses;
  }
  get selfSavedMapComments() {
    if (!this._selfSavedMapComments) {
      this._selfSavedMapComments = [];
      for (let i of this._value.savedMapComments) {
        this._selfSavedMapComments.push(new SavedMapComment.WithParent(i, null));
      }
    }
    return this._selfSavedMapComments;
  }
  get inherentSavedMapComments() {
    if (!this._inherentSavedMapComments) {
      this._inherentSavedMapComments = this._parent ? this._parent.savedMapComments : [];
    }
    return this._inherentSavedMapComments;
  }
  get savedMapComments() {
    if (!this._allSavedMapComments) {
      this._allSavedMapComments = this._parent ? this._parent.savedMapComments.concat(this.selfSavedMapComments) : this.selfSavedMapComments;
    }
    return this._allSavedMapComments;
  }
  get selfConsumableItems() {
    if (!this._selfConsumableItems) {
      this._selfConsumableItems = [];
      for (let i of this._value.consumableItems) {
        this._selfConsumableItems.push(new ConsumableItemSave.WithParent(i, null));
      }
    }
    return this._selfConsumableItems;
  }
  get inherentConsumableItems() {
    if (!this._inherentConsumableItems) {
      this._inherentConsumableItems = this._parent ? this._parent.consumableItems : [];
    }
    return this._inherentConsumableItems;
  }
  get consumableItems() {
    if (!this._allConsumableItems) {
      this._allConsumableItems = this._parent ? this._parent.consumableItems.concat(this.selfConsumableItems) : this.selfConsumableItems;
    }
    return this._allConsumableItems;
  }
  get hasGenericDataProgress() {
    if (this._cachedHasGenericDataProgress === undefined) {
      if (this._value.hasGenericDataProgress) {
        this._cachedHasGenericDataProgress = true;
      } else {
        this._cachedHasGenericDataProgress = this._parent ? this._parent.hasGenericDataProgress : false;
      }
    }
    return this._cachedHasGenericDataProgress;
  }
  get genericDataProgress() {
    if (!this._cachedGenericDataProgress) {
      if (this._value.hasGenericDataProgress) {
        this._cachedGenericDataProgress = new GenericDataProgress.WithParent(this._value.genericDataProgress, this._parent && this._parent.hasGenericDataProgress ? this._parent.genericDataProgress : null);
      } else {
        this._cachedGenericDataProgress = this._parent ? new GenericDataProgress.WithParent(GenericDataProgress.default, this._parent.genericDataProgress) : GenericDataProgress.WithParent.default;
      }
    }
    return this._cachedGenericDataProgress;
  }
  get hasCardUsageStats() {
    if (this._cachedHasCardUsageStats === undefined) {
      if (this._value.hasCardUsageStats) {
        this._cachedHasCardUsageStats = true;
      } else {
        this._cachedHasCardUsageStats = this._parent ? this._parent.hasCardUsageStats : false;
      }
    }
    return this._cachedHasCardUsageStats;
  }
  get cardUsageStats() {
    if (!this._cachedCardUsageStats) {
      if (this._value.hasCardUsageStats) {
        this._cachedCardUsageStats = new CardUsageStats.WithParent(this._value.cardUsageStats, this._parent && this._parent.hasCardUsageStats ? this._parent.cardUsageStats : null);
      } else {
        this._cachedCardUsageStats = this._parent ? new CardUsageStats.WithParent(CardUsageStats.default, this._parent.cardUsageStats) : CardUsageStats.WithParent.default;
      }
    }
    return this._cachedCardUsageStats;
  }
  get selfPromotionBundleStatus() {
    if (!this._selfPromotionBundleStatus) {
      this._selfPromotionBundleStatus = [];
      for (let i of this._value.promotionBundleStatus) {
        this._selfPromotionBundleStatus.push(new PromotionBundleStatus.WithParent(i, null));
      }
    }
    return this._selfPromotionBundleStatus;
  }
  get inherentPromotionBundleStatus() {
    if (!this._inherentPromotionBundleStatus) {
      this._inherentPromotionBundleStatus = this._parent ? this._parent.promotionBundleStatus : [];
    }
    return this._inherentPromotionBundleStatus;
  }
  get promotionBundleStatus() {
    if (!this._allPromotionBundleStatus) {
      this._allPromotionBundleStatus = this._parent ? this._parent.promotionBundleStatus.concat(this.selfPromotionBundleStatus) : this.selfPromotionBundleStatus;
    }
    return this._allPromotionBundleStatus;
  }
  update(current, parent) {
    const result = new BackUpData_WithParent(current, parent);
    if (this._cachedCampaignProgress && this._value.hasCampaignProgress && current.hasCampaignProgress) {
      if (this._value.campaignProgress === current.campaignProgress && this._parent === parent) {
        result._cachedCampaignProgress = this._cachedCampaignProgress;
      } else {
        result._cachedCampaignProgress = this._cachedCampaignProgress.update(current.campaignProgress, parent && parent.hasCampaignProgress ? parent.campaignProgress : null);
      }
    }
    if (this._selfAchievementProgresses) {
      if (this._value.achievementProgresses === current.achievementProgresses) {
        result._selfAchievementProgresses = this._selfAchievementProgresses;
      } else {
        result._selfAchievementProgresses = [];
        for (let i = 0; i < current.achievementProgresses.length; i++) {
          const oldValue = this._value.achievementProgresses[i];
          if (oldValue) {
            const oldCache = this._selfAchievementProgresses[i];
            if (oldValue === current.achievementProgresses[i]) {
              result._selfAchievementProgresses[i] = oldCache;
            } else {
              result._selfAchievementProgresses[i] = oldCache.update(current.achievementProgresses[i], null);
            }
          } else {
            result._selfAchievementProgresses[i] = new AchievementProgress.WithParent(current.achievementProgresses[i], null);
          }
        }
      }
    }
    if (this._cachedPlayerEnergy && this._value.hasPlayerEnergy && current.hasPlayerEnergy) {
      if (this._value.playerEnergy === current.playerEnergy && this._parent === parent) {
        result._cachedPlayerEnergy = this._cachedPlayerEnergy;
      } else {
        result._cachedPlayerEnergy = this._cachedPlayerEnergy.update(current.playerEnergy, parent && parent.hasPlayerEnergy ? parent.playerEnergy : null);
      }
    }
    if (this._selfMapProgresses) {
      if (this._value.mapProgresses === current.mapProgresses) {
        result._selfMapProgresses = this._selfMapProgresses;
      } else {
        result._selfMapProgresses = [];
        for (let i = 0; i < current.mapProgresses.length; i++) {
          const oldValue = this._value.mapProgresses[i];
          if (oldValue) {
            const oldCache = this._selfMapProgresses[i];
            if (oldValue === current.mapProgresses[i]) {
              result._selfMapProgresses[i] = oldCache;
            } else {
              result._selfMapProgresses[i] = oldCache.update(current.mapProgresses[i], null);
            }
          } else {
            result._selfMapProgresses[i] = new MapProgress.WithParent(current.mapProgresses[i], null);
          }
        }
      }
    }
    if (this._selfSavedMapComments) {
      if (this._value.savedMapComments === current.savedMapComments) {
        result._selfSavedMapComments = this._selfSavedMapComments;
      } else {
        result._selfSavedMapComments = [];
        for (let i = 0; i < current.savedMapComments.length; i++) {
          const oldValue = this._value.savedMapComments[i];
          if (oldValue) {
            const oldCache = this._selfSavedMapComments[i];
            if (oldValue === current.savedMapComments[i]) {
              result._selfSavedMapComments[i] = oldCache;
            } else {
              result._selfSavedMapComments[i] = oldCache.update(current.savedMapComments[i], null);
            }
          } else {
            result._selfSavedMapComments[i] = new SavedMapComment.WithParent(current.savedMapComments[i], null);
          }
        }
      }
    }
    if (this._selfConsumableItems) {
      if (this._value.consumableItems === current.consumableItems) {
        result._selfConsumableItems = this._selfConsumableItems;
      } else {
        result._selfConsumableItems = [];
        for (let i = 0; i < current.consumableItems.length; i++) {
          const oldValue = this._value.consumableItems[i];
          if (oldValue) {
            const oldCache = this._selfConsumableItems[i];
            if (oldValue === current.consumableItems[i]) {
              result._selfConsumableItems[i] = oldCache;
            } else {
              result._selfConsumableItems[i] = oldCache.update(current.consumableItems[i], null);
            }
          } else {
            result._selfConsumableItems[i] = new ConsumableItemSave.WithParent(current.consumableItems[i], null);
          }
        }
      }
    }
    if (this._cachedGenericDataProgress && this._value.hasGenericDataProgress && current.hasGenericDataProgress) {
      if (this._value.genericDataProgress === current.genericDataProgress && this._parent === parent) {
        result._cachedGenericDataProgress = this._cachedGenericDataProgress;
      } else {
        result._cachedGenericDataProgress = this._cachedGenericDataProgress.update(current.genericDataProgress, parent && parent.hasGenericDataProgress ? parent.genericDataProgress : null);
      }
    }
    if (this._cachedCardUsageStats && this._value.hasCardUsageStats && current.hasCardUsageStats) {
      if (this._value.cardUsageStats === current.cardUsageStats && this._parent === parent) {
        result._cachedCardUsageStats = this._cachedCardUsageStats;
      } else {
        result._cachedCardUsageStats = this._cachedCardUsageStats.update(current.cardUsageStats, parent && parent.hasCardUsageStats ? parent.cardUsageStats : null);
      }
    }
    if (this._selfPromotionBundleStatus) {
      if (this._value.promotionBundleStatus === current.promotionBundleStatus) {
        result._selfPromotionBundleStatus = this._selfPromotionBundleStatus;
      } else {
        result._selfPromotionBundleStatus = [];
        for (let i = 0; i < current.promotionBundleStatus.length; i++) {
          const oldValue = this._value.promotionBundleStatus[i];
          if (oldValue) {
            const oldCache = this._selfPromotionBundleStatus[i];
            if (oldValue === current.promotionBundleStatus[i]) {
              result._selfPromotionBundleStatus[i] = oldCache;
            } else {
              result._selfPromotionBundleStatus[i] = oldCache.update(current.promotionBundleStatus[i], null);
            }
          } else {
            result._selfPromotionBundleStatus[i] = new PromotionBundleStatus.WithParent(current.promotionBundleStatus[i], null);
          }
        }
      }
    }
    return result;
  }
}
BackUpData_WithParent.default = new BackUpData_WithParent(BackUpData.default, null);
BackUpData.WithParent = BackUpData_WithParent;
class BackUpData_Descriptor {
  get campaignProgress() {
    if (!this._campaignProgress) {
      this._campaignProgress = {
        name: "campaignProgress",
        Name: "CampaignProgress",
        number: 1,
        protoType: 11,
        protoName: "campaign_progress",
        type: CampaignProgress,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignProgress;
  }
  get achievementProgresses() {
    if (!this._achievementProgresses) {
      this._achievementProgresses = {
        name: "achievementProgresses",
        Name: "AchievementProgresses",
        number: 2,
        protoType: 11,
        protoName: "achievement_progresses",
        type: AchievementProgress,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._achievementProgresses;
  }
  get playerEnergy() {
    if (!this._playerEnergy) {
      this._playerEnergy = {
        name: "playerEnergy",
        Name: "PlayerEnergy",
        number: 3,
        protoType: 11,
        protoName: "player_energy",
        type: EnergyData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerEnergy;
  }
  get likedCommentIds() {
    if (!this._likedCommentIds) {
      this._likedCommentIds = {
        name: "likedCommentIds",
        Name: "LikedCommentIds",
        number: 4,
        protoType: 9,
        protoName: "liked_comment_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._likedCommentIds;
  }
  get mapProgresses() {
    if (!this._mapProgresses) {
      this._mapProgresses = {
        name: "mapProgresses",
        Name: "MapProgresses",
        number: 5,
        protoType: 11,
        protoName: "map_progresses",
        type: MapProgress,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapProgresses;
  }
  get savedMapComments() {
    if (!this._savedMapComments) {
      this._savedMapComments = {
        name: "savedMapComments",
        Name: "SavedMapComments",
        number: 6,
        protoType: 11,
        protoName: "saved_map_comments",
        type: SavedMapComment,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._savedMapComments;
  }
  get consumableItems() {
    if (!this._consumableItems) {
      this._consumableItems = {
        name: "consumableItems",
        Name: "ConsumableItems",
        number: 7,
        protoType: 11,
        protoName: "consumable_items",
        type: ConsumableItemSave,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._consumableItems;
  }
  get genericDataProgress() {
    if (!this._genericDataProgress) {
      this._genericDataProgress = {
        name: "genericDataProgress",
        Name: "GenericDataProgress",
        number: 11,
        protoType: 11,
        protoName: "generic_data_progress",
        type: GenericDataProgress,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._genericDataProgress;
  }
  get cardUsageStats() {
    if (!this._cardUsageStats) {
      this._cardUsageStats = {
        name: "cardUsageStats",
        Name: "CardUsageStats",
        number: 41,
        protoType: 11,
        protoName: "card_usage_stats",
        type: CardUsageStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardUsageStats;
  }
  get promotionBundleStatus() {
    if (!this._promotionBundleStatus) {
      this._promotionBundleStatus = {
        name: "promotionBundleStatus",
        Name: "PromotionBundleStatus",
        number: 51,
        protoType: 11,
        protoName: "promotion_bundle_status",
        type: PromotionBundleStatus,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionBundleStatus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.campaignProgress,
        this.achievementProgresses,
        this.playerEnergy,
        this.likedCommentIds,
        this.mapProgresses,
        this.savedMapComments,
        this.consumableItems,
        this.genericDataProgress,
        this.cardUsageStats,
        this.promotionBundleStatus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCampaignProgress",
        Name: "DummyOneofForCampaignProgress",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerEnergy",
        Name: "DummyOneofForPlayerEnergy",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGenericDataProgress",
        Name: "DummyOneofForGenericDataProgress",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardUsageStats",
        Name: "DummyOneofForCardUsageStats",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
BackUpData.descriptor = new BackUpData_Descriptor();
class CampaignProgress_LevelProgress {
  get descriptor() {
    return CampaignProgress_LevelProgress.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasWorld = false;
    this._world = null;
    this._hasLevel = false;
    this._level = null;
    this._hasFinish = false;
    this._finish = null;
    this._hasPerfect = false;
    this._perfect = null;
    this._hasChallengeLevel = false;
    this._challengeLevel = null;
  }
  isEmpty() {
    if (this._hasWorld) return false;
    if (this._hasLevel) return false;
    if (this._hasFinish) return false;
    if (this._hasPerfect) return false;
    if (this._hasChallengeLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignProgress_LevelProgress) {
      return value;
    }
    return CampaignProgress_LevelProgress.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignProgress_LevelProgress();
    if (json.world != null) {
      result._hasWorld = true;
      result._world = JsonToString.fromJson(json.world);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToString.fromJson(json.level);
    }
    if (json.finish != null) {
      result._hasFinish = true;
      result._finish = JsonToBoolean.fromJson(json.finish);
    }
    if (json.perfect != null) {
      result._hasPerfect = true;
      result._perfect = JsonToBoolean.fromJson(json.perfect);
    }
    if (json.challengeLevel != null) {
      result._hasChallengeLevel = true;
      result._challengeLevel = JsonToInt32.fromJson(json.challengeLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasWorld) {
      result.world = JsonToString.toJson(this._world);
    }
    if (this._hasLevel) {
      result.level = JsonToString.toJson(this._level);
    }
    if (this._hasFinish) {
      result.finish = JsonToBoolean.toJson(this._finish);
    }
    if (this._hasPerfect) {
      result.perfect = JsonToBoolean.toJson(this._perfect);
    }
    if (this._hasChallengeLevel) {
      result.challengeLevel = JsonToInt32.toJson(this._challengeLevel);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get world() {
    return this._hasWorld ? this._world : JsonToString.default;
  }
  get hasWorld() {
    return this._hasWorld;
  }
  setWorld(path, value) {
    return {type: 'SET', path: path.concat(['world']), value};
  }
  deleteWorld(path) {
    return {type: 'DELETE', path: path.concat(['world'])};
  }
  /**
   * @returns {string}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToString.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {boolean}
   */
  get finish() {
    return this._hasFinish ? this._finish : JsonToBoolean.default;
  }
  get hasFinish() {
    return this._hasFinish;
  }
  setFinish(path, value) {
    return {type: 'SET', path: path.concat(['finish']), value};
  }
  deleteFinish(path) {
    return {type: 'DELETE', path: path.concat(['finish'])};
  }
  /**
   * @returns {boolean}
   */
  get perfect() {
    return this._hasPerfect ? this._perfect : JsonToBoolean.default;
  }
  get hasPerfect() {
    return this._hasPerfect;
  }
  setPerfect(path, value) {
    return {type: 'SET', path: path.concat(['perfect']), value};
  }
  deletePerfect(path) {
    return {type: 'DELETE', path: path.concat(['perfect'])};
  }
  /**
   * @returns {number}
   */
  get challengeLevel() {
    return this._hasChallengeLevel ? this._challengeLevel : JsonToInt32.default;
  }
  get hasChallengeLevel() {
    return this._hasChallengeLevel;
  }
  setChallengeLevel(path, value) {
    return {type: 'SET', path: path.concat(['challengeLevel']), value};
  }
  deleteChallengeLevel(path) {
    return {type: 'DELETE', path: path.concat(['challengeLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "world": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasWorld = true;
              copy._world = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWorld) {
                return this;
              }
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasWorld = false;
              copy._world = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasLevel = true;
              copy._level = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "finish": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasFinish = true;
              copy._finish = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFinish) {
                return this;
              }
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasFinish = false;
              copy._finish = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "perfect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasPerfect = true;
              copy._perfect = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPerfect) {
                return this;
              }
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasPerfect = false;
              copy._perfect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "challengeLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasChallengeLevel = true;
              copy._challengeLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChallengeLevel) {
                return this;
              }
              const copy = new CampaignProgress_LevelProgress(this);
              copy._hasChallengeLevel = false;
              copy._challengeLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignProgress_LevelProgress} other
   * @returns {CampaignProgress_LevelProgress}
   */
  merge(other) {
    const copy = new CampaignProgress_LevelProgress(this);
    if (other._hasWorld) {
      copy._hasWorld = true;
      copy._world = other._world;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasFinish) {
      copy._hasFinish = true;
      copy._finish = other._finish;
    }
    if (other._hasPerfect) {
      copy._hasPerfect = true;
      copy._perfect = other._perfect;
    }
    if (other._hasChallengeLevel) {
      copy._hasChallengeLevel = true;
      copy._challengeLevel = other._challengeLevel;
    }
    return copy;
  }
}
CampaignProgress_LevelProgress.default = new CampaignProgress_LevelProgress();
class CampaignProgress_LevelProgress_Builder {
  constructor(value) {
    this._value = new CampaignProgress_LevelProgress(value);
  }
  build() {
    return new CampaignProgress_LevelProgress(this._value);
  }
  setWorld(value) {
    this._value._hasWorld = true;
    this._value._world = value;
    return this;
  }
  deleteWorld() {
    this._value._hasWorld = false;
    this._value._world = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setFinish(value) {
    this._value._hasFinish = true;
    this._value._finish = value;
    return this;
  }
  deleteFinish() {
    this._value._hasFinish = false;
    this._value._finish = null;
    return this;
  }
  setPerfect(value) {
    this._value._hasPerfect = true;
    this._value._perfect = value;
    return this;
  }
  deletePerfect() {
    this._value._hasPerfect = false;
    this._value._perfect = null;
    return this;
  }
  setChallengeLevel(value) {
    this._value._hasChallengeLevel = true;
    this._value._challengeLevel = value;
    return this;
  }
  deleteChallengeLevel() {
    this._value._hasChallengeLevel = false;
    this._value._challengeLevel = null;
    return this;
  }
}
CampaignProgress_LevelProgress.Builder = CampaignProgress_LevelProgress_Builder;
class CampaignProgress_LevelProgress_WithParent {
  /**
   * @param {CampaignProgress_LevelProgress} value
   * @param {CampaignProgress_LevelProgress_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignProgress_LevelProgress.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasWorld() {
    if (this._cachedHasWorld === undefined) {
      if (this._value.hasWorld) {
        this._cachedHasWorld = true;
      } else {
        this._cachedHasWorld = this._parent ? this._parent.hasWorld : false;
      }
    }
    return this._cachedHasWorld;
  }
  get world() {
    if (this._cachedWorld === undefined) {
      if (this._value.hasWorld) {
        this._cachedWorld = this._value.world;
      } else {
        this._cachedWorld = this._parent ? this._parent.world : this._value.world;
      }
    }
    return this._cachedWorld;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasFinish() {
    if (this._cachedHasFinish === undefined) {
      if (this._value.hasFinish) {
        this._cachedHasFinish = true;
      } else {
        this._cachedHasFinish = this._parent ? this._parent.hasFinish : false;
      }
    }
    return this._cachedHasFinish;
  }
  get finish() {
    if (this._cachedFinish === undefined) {
      if (this._value.hasFinish) {
        this._cachedFinish = this._value.finish;
      } else {
        this._cachedFinish = this._parent ? this._parent.finish : this._value.finish;
      }
    }
    return this._cachedFinish;
  }
  get hasPerfect() {
    if (this._cachedHasPerfect === undefined) {
      if (this._value.hasPerfect) {
        this._cachedHasPerfect = true;
      } else {
        this._cachedHasPerfect = this._parent ? this._parent.hasPerfect : false;
      }
    }
    return this._cachedHasPerfect;
  }
  get perfect() {
    if (this._cachedPerfect === undefined) {
      if (this._value.hasPerfect) {
        this._cachedPerfect = this._value.perfect;
      } else {
        this._cachedPerfect = this._parent ? this._parent.perfect : this._value.perfect;
      }
    }
    return this._cachedPerfect;
  }
  get hasChallengeLevel() {
    if (this._cachedHasChallengeLevel === undefined) {
      if (this._value.hasChallengeLevel) {
        this._cachedHasChallengeLevel = true;
      } else {
        this._cachedHasChallengeLevel = this._parent ? this._parent.hasChallengeLevel : false;
      }
    }
    return this._cachedHasChallengeLevel;
  }
  get challengeLevel() {
    if (this._cachedChallengeLevel === undefined) {
      if (this._value.hasChallengeLevel) {
        this._cachedChallengeLevel = this._value.challengeLevel;
      } else {
        this._cachedChallengeLevel = this._parent ? this._parent.challengeLevel : this._value.challengeLevel;
      }
    }
    return this._cachedChallengeLevel;
  }
  update(current, parent) {
    const result = new CampaignProgress_LevelProgress_WithParent(current, parent);
    return result;
  }
}
CampaignProgress_LevelProgress_WithParent.default = new CampaignProgress_LevelProgress_WithParent(CampaignProgress_LevelProgress.default, null);
CampaignProgress_LevelProgress.WithParent = CampaignProgress_LevelProgress_WithParent;
class CampaignProgress_LevelProgress_Descriptor {
  get world() {
    if (!this._world) {
      this._world = {
        name: "world",
        Name: "World",
        number: 1,
        protoType: 9,
        protoName: "world",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._world;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 2,
        protoType: 9,
        protoName: "level",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get finish() {
    if (!this._finish) {
      this._finish = {
        name: "finish",
        Name: "Finish",
        number: 3,
        protoType: 8,
        protoName: "finish",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._finish;
  }
  get perfect() {
    if (!this._perfect) {
      this._perfect = {
        name: "perfect",
        Name: "Perfect",
        number: 4,
        protoType: 8,
        protoName: "perfect",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._perfect;
  }
  get challengeLevel() {
    if (!this._challengeLevel) {
      this._challengeLevel = {
        name: "challengeLevel",
        Name: "ChallengeLevel",
        number: 5,
        protoType: 5,
        protoName: "challenge_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._challengeLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.world,
        this.level,
        this.finish,
        this.perfect,
        this.challengeLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForWorld",
        Name: "DummyOneofForWorld",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFinish",
        Name: "DummyOneofForFinish",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPerfect",
        Name: "DummyOneofForPerfect",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChallengeLevel",
        Name: "DummyOneofForChallengeLevel",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignProgress_LevelProgress.descriptor = new CampaignProgress_LevelProgress_Descriptor();
export class CampaignProgress {
  get descriptor() {
    return CampaignProgress.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._levelProgresses = [];
  }
  isEmpty() {
    if (this._levelProgresses.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignProgress) {
      return value;
    }
    return CampaignProgress.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignProgress();
    result._levelProgresses = JsonToList(json.levelProgresses, CampaignProgress_LevelProgress);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._levelProgresses.length > 0) {
      result.levelProgresses = ArrayToJson(this._levelProgresses, CampaignProgress_LevelProgress);
    }
    return result;
  }
  /**
   * @returns {CampaignProgress_LevelProgress[]}
   */
  get levelProgresses() {
    return this._levelProgresses;
  }
  addLevelProgresses(path, value) {
    return {type: 'ADD', path: path.concat(['levelProgresses']), value: value.toJson()};
  }
  setLevelProgresses(path, value) {
    return {type: 'SET', path: path.concat(['levelProgresses']), value: ArrayToJson(value, CampaignProgress_LevelProgress)};
  }
  setLevelProgressesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levelProgresses', key]), value: value.toJson()};
  }
  deleteLevelProgresses(path) {
    return {type: 'DELETE', path: path.concat(['levelProgresses'])};
  }
  deleteLevelProgressesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levelProgresses', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levelProgresses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress(this);
              copy._levelProgresses = [];        for (let i of value) {
                copy._levelProgresses.push(CampaignProgress_LevelProgress.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignProgress(this);
              copy._levelProgresses = copy._levelProgresses.concat([CampaignProgress_LevelProgress.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levelProgresses.length === 0) {
                return this;
              }
              const copy = new CampaignProgress(this);
              copy._levelProgresses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levelProgresses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignProgress(this);
              copy._levelProgresses = copy._levelProgresses.slice();
              copy._levelProgresses[path[1]] = CampaignProgress_LevelProgress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignProgress(this);
              copy._levelProgresses = copy._levelProgresses.slice(0, path[1]).concat(copy._levelProgresses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levelProgresses.length) {
            return this;
          }
          const oldValue = this._levelProgresses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignProgress(this);
          copy._levelProgresses = copy._levelProgresses.slice();
          copy._levelProgresses[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignProgress} other
   * @returns {CampaignProgress}
   */
  merge(other) {
    const copy = new CampaignProgress(this);
    copy._levelProgresses = this._levelProgresses.concat(other._levelProgresses);
    return copy;
  }
}
CampaignProgress.default = new CampaignProgress();
CampaignProgress.LevelProgress = CampaignProgress_LevelProgress;
class CampaignProgress_Builder {
  constructor(value) {
    this._value = new CampaignProgress(value);
  }
  build() {
    return new CampaignProgress(this._value);
  }
  addAllLevelProgresses(values) {
    this._value._levelProgresses = this._value._levelProgresses.concat(values);
    return this;
  }
  addLevelProgresses(value) {
    this._value._levelProgresses = this._value._levelProgresses.concat([value]);
    return this;
  }
  setLevelProgresses(index, value) {
    this._value._levelProgresses = this._value._levelProgresses.concat();
    this._value._levelProgresses[index] = value;
    return this;
  }
  clearLevelProgresses() {
    this._value._levelProgresses = [];
    return this;
  }
}
CampaignProgress.Builder = CampaignProgress_Builder;
class CampaignProgress_WithParent {
  /**
   * @param {CampaignProgress} value
   * @param {CampaignProgress_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignProgress.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLevelProgresses() {
    if (!this._selfLevelProgresses) {
      this._selfLevelProgresses = [];
      for (let i of this._value.levelProgresses) {
        this._selfLevelProgresses.push(new CampaignProgress_LevelProgress.WithParent(i, null));
      }
    }
    return this._selfLevelProgresses;
  }
  get inherentLevelProgresses() {
    if (!this._inherentLevelProgresses) {
      this._inherentLevelProgresses = this._parent ? this._parent.levelProgresses : [];
    }
    return this._inherentLevelProgresses;
  }
  get levelProgresses() {
    if (!this._allLevelProgresses) {
      this._allLevelProgresses = this._parent ? this._parent.levelProgresses.concat(this.selfLevelProgresses) : this.selfLevelProgresses;
    }
    return this._allLevelProgresses;
  }
  update(current, parent) {
    const result = new CampaignProgress_WithParent(current, parent);
    if (this._selfLevelProgresses) {
      if (this._value.levelProgresses === current.levelProgresses) {
        result._selfLevelProgresses = this._selfLevelProgresses;
      } else {
        result._selfLevelProgresses = [];
        for (let i = 0; i < current.levelProgresses.length; i++) {
          const oldValue = this._value.levelProgresses[i];
          if (oldValue) {
            const oldCache = this._selfLevelProgresses[i];
            if (oldValue === current.levelProgresses[i]) {
              result._selfLevelProgresses[i] = oldCache;
            } else {
              result._selfLevelProgresses[i] = oldCache.update(current.levelProgresses[i], null);
            }
          } else {
            result._selfLevelProgresses[i] = new CampaignProgress_LevelProgress.WithParent(current.levelProgresses[i], null);
          }
        }
      }
    }
    return result;
  }
}
CampaignProgress_WithParent.default = new CampaignProgress_WithParent(CampaignProgress.default, null);
CampaignProgress.WithParent = CampaignProgress_WithParent;
class CampaignProgress_Descriptor {
  get levelProgresses() {
    if (!this._levelProgresses) {
      this._levelProgresses = {
        name: "levelProgresses",
        Name: "LevelProgresses",
        number: 1,
        protoType: 11,
        protoName: "level_progresses",
        type: CampaignProgress_LevelProgress,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelProgresses;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levelProgresses,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CampaignProgress.descriptor = new CampaignProgress_Descriptor();
export class AchievementProgress {
  get descriptor() {
    return AchievementProgress.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasProgress = false;
    this._progress = null;
    this._hasRewardClaimed = false;
    this._rewardClaimed = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasProgress) return false;
    if (this._hasRewardClaimed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AchievementProgress) {
      return value;
    }
    return AchievementProgress.fromJson(value);
  }
  static fromJson(json) {
    const result = new AchievementProgress();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.progress != null) {
      result._hasProgress = true;
      result._progress = JsonToInt32.fromJson(json.progress);
    }
    if (json.rewardClaimed != null) {
      result._hasRewardClaimed = true;
      result._rewardClaimed = JsonToBoolean.fromJson(json.rewardClaimed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasProgress) {
      result.progress = JsonToInt32.toJson(this._progress);
    }
    if (this._hasRewardClaimed) {
      result.rewardClaimed = JsonToBoolean.toJson(this._rewardClaimed);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get progress() {
    return this._hasProgress ? this._progress : JsonToInt32.default;
  }
  get hasProgress() {
    return this._hasProgress;
  }
  setProgress(path, value) {
    return {type: 'SET', path: path.concat(['progress']), value};
  }
  deleteProgress(path) {
    return {type: 'DELETE', path: path.concat(['progress'])};
  }
  /**
   * @returns {boolean}
   */
  get rewardClaimed() {
    return this._hasRewardClaimed ? this._rewardClaimed : JsonToBoolean.default;
  }
  get hasRewardClaimed() {
    return this._hasRewardClaimed;
  }
  setRewardClaimed(path, value) {
    return {type: 'SET', path: path.concat(['rewardClaimed']), value};
  }
  deleteRewardClaimed(path) {
    return {type: 'DELETE', path: path.concat(['rewardClaimed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementProgress(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new AchievementProgress(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementProgress(this);
              copy._hasProgress = true;
              copy._progress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgress) {
                return this;
              }
              const copy = new AchievementProgress(this);
              copy._hasProgress = false;
              copy._progress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardClaimed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementProgress(this);
              copy._hasRewardClaimed = true;
              copy._rewardClaimed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardClaimed) {
                return this;
              }
              const copy = new AchievementProgress(this);
              copy._hasRewardClaimed = false;
              copy._rewardClaimed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AchievementProgress} other
   * @returns {AchievementProgress}
   */
  merge(other) {
    const copy = new AchievementProgress(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasProgress) {
      copy._hasProgress = true;
      copy._progress = other._progress;
    }
    if (other._hasRewardClaimed) {
      copy._hasRewardClaimed = true;
      copy._rewardClaimed = other._rewardClaimed;
    }
    return copy;
  }
}
AchievementProgress.default = new AchievementProgress();
class AchievementProgress_Builder {
  constructor(value) {
    this._value = new AchievementProgress(value);
  }
  build() {
    return new AchievementProgress(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setProgress(value) {
    this._value._hasProgress = true;
    this._value._progress = value;
    return this;
  }
  deleteProgress() {
    this._value._hasProgress = false;
    this._value._progress = null;
    return this;
  }
  setRewardClaimed(value) {
    this._value._hasRewardClaimed = true;
    this._value._rewardClaimed = value;
    return this;
  }
  deleteRewardClaimed() {
    this._value._hasRewardClaimed = false;
    this._value._rewardClaimed = null;
    return this;
  }
}
AchievementProgress.Builder = AchievementProgress_Builder;
class AchievementProgress_WithParent {
  /**
   * @param {AchievementProgress} value
   * @param {AchievementProgress_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AchievementProgress.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasProgress() {
    if (this._cachedHasProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedHasProgress = true;
      } else {
        this._cachedHasProgress = this._parent ? this._parent.hasProgress : false;
      }
    }
    return this._cachedHasProgress;
  }
  get progress() {
    if (this._cachedProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedProgress = this._value.progress;
      } else {
        this._cachedProgress = this._parent ? this._parent.progress : this._value.progress;
      }
    }
    return this._cachedProgress;
  }
  get hasRewardClaimed() {
    if (this._cachedHasRewardClaimed === undefined) {
      if (this._value.hasRewardClaimed) {
        this._cachedHasRewardClaimed = true;
      } else {
        this._cachedHasRewardClaimed = this._parent ? this._parent.hasRewardClaimed : false;
      }
    }
    return this._cachedHasRewardClaimed;
  }
  get rewardClaimed() {
    if (this._cachedRewardClaimed === undefined) {
      if (this._value.hasRewardClaimed) {
        this._cachedRewardClaimed = this._value.rewardClaimed;
      } else {
        this._cachedRewardClaimed = this._parent ? this._parent.rewardClaimed : this._value.rewardClaimed;
      }
    }
    return this._cachedRewardClaimed;
  }
  update(current, parent) {
    const result = new AchievementProgress_WithParent(current, parent);
    return result;
  }
}
AchievementProgress_WithParent.default = new AchievementProgress_WithParent(AchievementProgress.default, null);
AchievementProgress.WithParent = AchievementProgress_WithParent;
class AchievementProgress_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get progress() {
    if (!this._progress) {
      this._progress = {
        name: "progress",
        Name: "Progress",
        number: 2,
        protoType: 5,
        protoName: "progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progress;
  }
  get rewardClaimed() {
    if (!this._rewardClaimed) {
      this._rewardClaimed = {
        name: "rewardClaimed",
        Name: "RewardClaimed",
        number: 3,
        protoType: 8,
        protoName: "reward_claimed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardClaimed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.progress,
        this.rewardClaimed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgress",
        Name: "DummyOneofForProgress",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewardClaimed",
        Name: "DummyOneofForRewardClaimed",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
AchievementProgress.descriptor = new AchievementProgress_Descriptor();
export class InventoryItem {
  get descriptor() {
    return InventoryItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
    this._hasCumulativeValue = false;
    this._cumulativeValue = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue) return false;
    if (this._hasCumulativeValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InventoryItem) {
      return value;
    }
    return InventoryItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new InventoryItem();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToInt32.fromJson(json.value);
    }
    if (json.cumulativeValue != null) {
      result._hasCumulativeValue = true;
      result._cumulativeValue = JsonToInt32.fromJson(json.cumulativeValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue) {
      result.value = JsonToInt32.toJson(this._value);
    }
    if (this._hasCumulativeValue) {
      result.cumulativeValue = JsonToInt32.toJson(this._cumulativeValue);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToInt32.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {number}
   */
  get cumulativeValue() {
    return this._hasCumulativeValue ? this._cumulativeValue : JsonToInt32.default;
  }
  get hasCumulativeValue() {
    return this._hasCumulativeValue;
  }
  setCumulativeValue(path, value) {
    return {type: 'SET', path: path.concat(['cumulativeValue']), value};
  }
  deleteCumulativeValue(path) {
    return {type: 'DELETE', path: path.concat(['cumulativeValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryItem(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new InventoryItem(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryItem(this);
              copy._hasValue = true;
              copy._value = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new InventoryItem(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cumulativeValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryItem(this);
              copy._hasCumulativeValue = true;
              copy._cumulativeValue = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCumulativeValue) {
                return this;
              }
              const copy = new InventoryItem(this);
              copy._hasCumulativeValue = false;
              copy._cumulativeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InventoryItem} other
   * @returns {InventoryItem}
   */
  merge(other) {
    const copy = new InventoryItem(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    if (other._hasCumulativeValue) {
      copy._hasCumulativeValue = true;
      copy._cumulativeValue = other._cumulativeValue;
    }
    return copy;
  }
}
InventoryItem.default = new InventoryItem();
class InventoryItem_Builder {
  constructor(value) {
    this._value = new InventoryItem(value);
  }
  build() {
    return new InventoryItem(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
  setCumulativeValue(value) {
    this._value._hasCumulativeValue = true;
    this._value._cumulativeValue = value;
    return this;
  }
  deleteCumulativeValue() {
    this._value._hasCumulativeValue = false;
    this._value._cumulativeValue = null;
    return this;
  }
}
InventoryItem.Builder = InventoryItem_Builder;
class InventoryItem_WithParent {
  /**
   * @param {InventoryItem} value
   * @param {InventoryItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InventoryItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  get hasCumulativeValue() {
    if (this._cachedHasCumulativeValue === undefined) {
      if (this._value.hasCumulativeValue) {
        this._cachedHasCumulativeValue = true;
      } else {
        this._cachedHasCumulativeValue = this._parent ? this._parent.hasCumulativeValue : false;
      }
    }
    return this._cachedHasCumulativeValue;
  }
  get cumulativeValue() {
    if (this._cachedCumulativeValue === undefined) {
      if (this._value.hasCumulativeValue) {
        this._cachedCumulativeValue = this._value.cumulativeValue;
      } else {
        this._cachedCumulativeValue = this._parent ? this._parent.cumulativeValue : this._value.cumulativeValue;
      }
    }
    return this._cachedCumulativeValue;
  }
  update(current, parent) {
    const result = new InventoryItem_WithParent(current, parent);
    return result;
  }
}
InventoryItem_WithParent.default = new InventoryItem_WithParent(InventoryItem.default, null);
InventoryItem.WithParent = InventoryItem_WithParent;
class InventoryItem_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 5,
        protoName: "value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get cumulativeValue() {
    if (!this._cumulativeValue) {
      this._cumulativeValue = {
        name: "cumulativeValue",
        Name: "CumulativeValue",
        number: 3,
        protoType: 5,
        protoName: "cumulative_value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cumulativeValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
        this.cumulativeValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCumulativeValue",
        Name: "DummyOneofForCumulativeValue",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
InventoryItem.descriptor = new InventoryItem_Descriptor();
export class UserInventory {
  get descriptor() {
    return UserInventory.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._items = [];
  }
  isEmpty() {
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserInventory) {
      return value;
    }
    return UserInventory.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserInventory();
    result._items = JsonToList(json.items, InventoryItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, InventoryItem);
    }
    return result;
  }
  /**
   * @returns {InventoryItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, InventoryItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserInventory(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(InventoryItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserInventory(this);
              copy._items = copy._items.concat([InventoryItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new UserInventory(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserInventory(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = InventoryItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserInventory(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserInventory(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserInventory} other
   * @returns {UserInventory}
   */
  merge(other) {
    const copy = new UserInventory(this);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
UserInventory.default = new UserInventory();
class UserInventory_Builder {
  constructor(value) {
    this._value = new UserInventory(value);
  }
  build() {
    return new UserInventory(this._value);
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
UserInventory.Builder = UserInventory_Builder;
class UserInventory_WithParent {
  /**
   * @param {UserInventory} value
   * @param {UserInventory_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserInventory.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new InventoryItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new UserInventory_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new InventoryItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserInventory_WithParent.default = new UserInventory_WithParent(UserInventory.default, null);
UserInventory.WithParent = UserInventory_WithParent;
class UserInventory_Descriptor {
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "items",
        type: InventoryItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserInventory.descriptor = new UserInventory_Descriptor();
class GenericDataProgress_Item {
  get descriptor() {
    return GenericDataProgress_Item.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasProgress = false;
    this._progress = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasProgress) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GenericDataProgress_Item) {
      return value;
    }
    return GenericDataProgress_Item.fromJson(value);
  }
  static fromJson(json) {
    const result = new GenericDataProgress_Item();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.progress != null) {
      result._hasProgress = true;
      result._progress = JsonToInt32.fromJson(json.progress);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasProgress) {
      result.progress = JsonToInt32.toJson(this._progress);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get progress() {
    return this._hasProgress ? this._progress : JsonToInt32.default;
  }
  get hasProgress() {
    return this._hasProgress;
  }
  setProgress(path, value) {
    return {type: 'SET', path: path.concat(['progress']), value};
  }
  deleteProgress(path) {
    return {type: 'DELETE', path: path.concat(['progress'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GenericDataProgress_Item(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new GenericDataProgress_Item(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GenericDataProgress_Item(this);
              copy._hasProgress = true;
              copy._progress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgress) {
                return this;
              }
              const copy = new GenericDataProgress_Item(this);
              copy._hasProgress = false;
              copy._progress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GenericDataProgress_Item} other
   * @returns {GenericDataProgress_Item}
   */
  merge(other) {
    const copy = new GenericDataProgress_Item(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasProgress) {
      copy._hasProgress = true;
      copy._progress = other._progress;
    }
    return copy;
  }
}
GenericDataProgress_Item.default = new GenericDataProgress_Item();
class GenericDataProgress_Item_Builder {
  constructor(value) {
    this._value = new GenericDataProgress_Item(value);
  }
  build() {
    return new GenericDataProgress_Item(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setProgress(value) {
    this._value._hasProgress = true;
    this._value._progress = value;
    return this;
  }
  deleteProgress() {
    this._value._hasProgress = false;
    this._value._progress = null;
    return this;
  }
}
GenericDataProgress_Item.Builder = GenericDataProgress_Item_Builder;
class GenericDataProgress_Item_WithParent {
  /**
   * @param {GenericDataProgress_Item} value
   * @param {GenericDataProgress_Item_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GenericDataProgress_Item.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasProgress() {
    if (this._cachedHasProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedHasProgress = true;
      } else {
        this._cachedHasProgress = this._parent ? this._parent.hasProgress : false;
      }
    }
    return this._cachedHasProgress;
  }
  get progress() {
    if (this._cachedProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedProgress = this._value.progress;
      } else {
        this._cachedProgress = this._parent ? this._parent.progress : this._value.progress;
      }
    }
    return this._cachedProgress;
  }
  update(current, parent) {
    const result = new GenericDataProgress_Item_WithParent(current, parent);
    return result;
  }
}
GenericDataProgress_Item_WithParent.default = new GenericDataProgress_Item_WithParent(GenericDataProgress_Item.default, null);
GenericDataProgress_Item.WithParent = GenericDataProgress_Item_WithParent;
class GenericDataProgress_Item_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get progress() {
    if (!this._progress) {
      this._progress = {
        name: "progress",
        Name: "Progress",
        number: 2,
        protoType: 5,
        protoName: "progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progress;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.progress,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgress",
        Name: "DummyOneofForProgress",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
GenericDataProgress_Item.descriptor = new GenericDataProgress_Item_Descriptor();
export class GenericDataProgress {
  get descriptor() {
    return GenericDataProgress.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._items = [];
  }
  isEmpty() {
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GenericDataProgress) {
      return value;
    }
    return GenericDataProgress.fromJson(value);
  }
  static fromJson(json) {
    const result = new GenericDataProgress();
    result._items = JsonToList(json.items, GenericDataProgress_Item);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, GenericDataProgress_Item);
    }
    return result;
  }
  /**
   * @returns {GenericDataProgress_Item[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, GenericDataProgress_Item)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GenericDataProgress(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(GenericDataProgress_Item.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GenericDataProgress(this);
              copy._items = copy._items.concat([GenericDataProgress_Item.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new GenericDataProgress(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GenericDataProgress(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = GenericDataProgress_Item.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GenericDataProgress(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GenericDataProgress(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GenericDataProgress} other
   * @returns {GenericDataProgress}
   */
  merge(other) {
    const copy = new GenericDataProgress(this);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
GenericDataProgress.default = new GenericDataProgress();
GenericDataProgress.Item = GenericDataProgress_Item;
class GenericDataProgress_Builder {
  constructor(value) {
    this._value = new GenericDataProgress(value);
  }
  build() {
    return new GenericDataProgress(this._value);
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
GenericDataProgress.Builder = GenericDataProgress_Builder;
class GenericDataProgress_WithParent {
  /**
   * @param {GenericDataProgress} value
   * @param {GenericDataProgress_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GenericDataProgress.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new GenericDataProgress_Item.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new GenericDataProgress_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new GenericDataProgress_Item.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
GenericDataProgress_WithParent.default = new GenericDataProgress_WithParent(GenericDataProgress.default, null);
GenericDataProgress.WithParent = GenericDataProgress_WithParent;
class GenericDataProgress_Descriptor {
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "items",
        type: GenericDataProgress_Item,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
GenericDataProgress.descriptor = new GenericDataProgress_Descriptor();
